<template>
    <div>
        <div v-if="product && Object.keys(product).length">
            <section class="breadcrumb-section">
                <div class="container">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link to="/">Home</router-link>
                            </li>

                            <li
                                v-if="is_tshirt_24_hour"
                                class="breadcrumb-item"
                            >
                                <router-link
                                    :to="{
                                        name: 'product_list_24_tshirt',
                                        params: { product_type: 'tshirt24' }
                                    }"
                                    >24hour T-shirt</router-link
                                >
                            </li>

                            <li
                                v-else-if="product.Category"
                                class="breadcrumb-item"
                            >
                                <router-link
                                    :to="{
                                        path:
                                            '/product-list/' +
                                            productTypePath +
                                            '/' +
                                            product.Category.id
                                    }"
                                    >{{ product.Category.title }}</router-link
                                >
                            </li>

                            <li
                                class="breadcrumb-item active"
                                aria-current="page"
                            >
                            {{ product && product.name ? product.name : "Product Details" }}
                            </li>
                        </ol>
                    </nav>
                </div>
            </section>

            <section
                class="product_details pt_20 product_details_vue product_details_update product_details_update_v3"
            >
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-lg-6 pr-lg-0 pro-mobile-0">
                            <div class="gallery-container" :class="{
                                'cap_category_images': shouldApplyCapCategoryClass(getPrimaryImageUrlForCapClass())
                            }">
                                <ProductZoomer
                                    :product="product"
                                    v-if="!isEmpty(images)"
                                    :base-images="images"
                                    :base-zoomer-options="zoomerOptions"
                                />
                            </div>
                            <div
                                class="share mx-auto d-flex justify-content-center align-items-center mt_30"
                            >
                                <h6 class="font_size_18 m-0">SHARE:</h6>
                                <div
                                    class="sharethis-inline-share-buttons"
                                ></div>
                                <ul class="share_item ml_16 my-0">
                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            @click="shareOnFacebook"
                                            ><img
                                                src="/maincss/images/share_fb.svg"
                                                alt="Facebook"
                                        /></a>
                                    </li>
                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            @click="shareOnTwitter"
                                            ><img
                                                src="/maincss/images/twitterx.svg"
                                                width="22px"
                                                height="22px"
                                                alt="Twitter"
                                        /></a>
                                    </li>
                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            @click="shareOnInstagram"
                                            ><img
                                                src="/maincss/images/share_instagram.svg"
                                                alt="Instagram"
                                        /></a>
                                    </li>
                                </ul>
                            </div>
                            <div class="product_detail_tabs pt-0 pb-40-bottom">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul
                                                class="nav nav-tabs default_tabs"
                                                id="product_tabs"
                                                role="tablist"
                                            >
                                                <li
                                                    v-if="product.description"
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link active"
                                                        id="home-tab1"
                                                        data-toggle="tab"
                                                        href="#product_details"
                                                        role="tab"
                                                        aria-controls="home"
                                                        aria-selected="true"
                                                        >Product Details</a
                                                    >
                                                </li>
                                                <!-- <li
                                                    v-if="
                                                        more_decoration_list.length >
                                                        0
                                                    "
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link"
                                                        id="profile-tab1"
                                                        data-toggle="tab"
                                                        href="#decoration"
                                                        role="tab"
                                                        aria-controls="profile"
                                                        aria-selected="false"
                                                        >Decoration</a
                                                    >
                                                </li> -->

                                                <li
                                                    v-if="
                                                        otherServices.length > 0
                                                    "
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link"
                                                        id="profile-tab1"
                                                        data-toggle="tab"
                                                        href="#decoration"
                                                        role="tab"
                                                        aria-controls="profile"
                                                        aria-selected="false"
                                                        >Other Services</a
                                                    >
                                                </li>
                                                <li
                                                    v-if="
                                                        product.Brand &&
                                                        product.Brand
                                                            .size_chart_image
                                                    "
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link"
                                                        id="contact-tab1"
                                                        data-toggle="tab"
                                                        href="#size_chart"
                                                        role="tab"
                                                        aria-controls="contact"
                                                        aria-selected="false"
                                                        >Size Chart</a
                                                    >
                                                </li>
                                            </ul>
                                            <div
                                                class="tab-content"
                                                id="myTabContent"
                                            >
                                                <div
                                                    class="tab-pane fade show active"
                                                    v-if="product.description"
                                                    id="product_details"
                                                    role="tabpanel"
                                                    aria-labelledby="home-tab1"
                                                >
                                                    <h4
                                                        class="font_size_20 mb-0"
                                                    >
                                                        Product Description
                                                    </h4>
                                                    <h5
                                                        class="font_size_20 mb-0 mt_28"
                                                        v-html="
                                                            product.description
                                                        "
                                                    ></h5>
                                                    <br />
                                                    <div
                                                        v-if="
                                                            product.feature_description
                                                        "
                                                    >
                                                        <h4
                                                            class="font_size_20 mb-0"
                                                        >
                                                            Features
                                                        </h4>
                                                        <h5
                                                            class="font_size_20 mb-0 mt_28"
                                                            v-html="
                                                                product.feature_description
                                                            "
                                                        ></h5>
                                                    </div>
                                                    <a
                                                        v-if="
                                                            product.product_specification_sheet_url
                                                        "
                                                        :href="
                                                            product.product_specification_sheet_url
                                                        "
                                                        target="_blank"
                                                        >Product Spec Sheet</a
                                                    >
                                                </div>

                                                <!-- <div
                                                    class="tab-pane fade"
                                                    v-if="
                                                        more_decoration_list.length >
                                                        0
                                                    "
                                                    id="decoration"
                                                    role="tabpanel"
                                                    aria-labelledby="profile-tab1"
                                                >
                                                    <div class="tabs_table">
                                                        <div
                                                            class="available_color_columns no_borders_custom decoration_table_product_detais_custom"
                                                        >
                                                            <table
                                                                class="table table-bordered"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Name
                                                                        </th>
                                                                        <th
                                                                            width="700"
                                                                        >
                                                                            Description
                                                                        </th>
                                                                        <th>
                                                                            Decoration
                                                                            Type
                                                                        </th>
                                                                        <th>
                                                                            Price
                                                                        </th>
                                                                        <th>
                                                                            Add
                                                                            On
                                                                            Price
                                                                        </th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr
                                                                        v-for="(
                                                                            moredecoration,
                                                                            index
                                                                        ) in more_decoration_list"
                                                                        :key="
                                                                            index
                                                                        "
                                                                    >
                                                                        <td>
                                                                            {{
                                                                                moredecoration.name
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                moredecoration.description
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                moredecoration.decoration_type
                                                                            }}
                                                                        </td>
                                                                        <td
                                                                            class="edit-table-column"
                                                                            @mouseover="
                                                                                isHovering = true
                                                                            "
                                                                            @mouseout="
                                                                                isHovering = false
                                                                            "
                                                                        >
                                                                            <template
                                                                                v-if="
                                                                                    moredecoration.price_type ==
                                                                                    'Price'
                                                                                "
                                                                            >
                                                                                {{
                                                                                    icPriceFormat(
                                                                                        moredecoration.price
                                                                                    )
                                                                                }}
                                                                            </template>
                                                                            <template
                                                                                v-else
                                                                            >
                                                                                <span
                                                                                    v-html="
                                                                                        tireName(
                                                                                            moredecoration.tier_id
                                                                                        )
                                                                                    "
                                                                                >
                                                                                </span>
                                                                            </template>
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                icPriceFormat(
                                                                                    moredecoration.add_on_price
                                                                                )
                                                                            }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div> -->

                                                <div
                                                    class="tab-pane fade"
                                                    v-if="
                                                        otherServices.length > 0
                                                    "
                                                    id="decoration"
                                                    role="tabpanel"
                                                    aria-labelledby="profile-tab1"
                                                >
                                                    <div class="tabs_table">
                                                        <div
                                                            class="available_color_columns no_borders_custom decoration_table_product_detais_custom"
                                                        >
                                                            <table
                                                                class="table table-bordered"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Name
                                                                        </th>
                                                                        <th
                                                                            width="700"
                                                                        >
                                                                            Description
                                                                        </th>
                                                                        <th>
                                                                            Fee
                                                                            Structure
                                                                        </th>
                                                                        <th>
                                                                            Price
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr
                                                                        v-for="(
                                                                            service,
                                                                            index
                                                                        ) in otherServices"
                                                                        :key="
                                                                            index
                                                                        "
                                                                    >
                                                                        <td>
                                                                            {{
                                                                                getOtherServiceEcommDisplayName(service) || service.name
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                service.description
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                service.fee_structure
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                icPriceFormat(
                                                                                    service.retail_cost
                                                                                )
                                                                            }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    class="tab-pane fade"
                                                    v-if="
                                                        product.Brand &&
                                                        product.Brand
                                                            .size_chart_image
                                                    "
                                                    id="size_chart"
                                                    role="tabpanel"
                                                    aria-labelledby="contact-tab1"
                                                >
                                                    <div
                                                        class="product_details product_details_vue"
                                                    >
                                                        <div
                                                            class="products_count_tab mt_30 product_details_content"
                                                        >
                                                            <div
                                                                class="products_count_tab"
                                                            >
                                                                <embed
                                                                    v-if="
                                                                        getUrlExtension(
                                                                            product
                                                                                .Brand
                                                                                .size_chart_image
                                                                        ) ==
                                                                        'pdf'
                                                                    "
                                                                    :src="`${product.Brand.size_chart_image}#toolbar=0&navpanes=0&scrollbar=0`"
                                                                    width="100%"
                                                                    height="800px"
                                                                />
                                                                <img
                                                                    v-else
                                                                    :src="
                                                                        product
                                                                            .Brand
                                                                            .size_chart_image
                                                                    "
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-md-12 col-lg-6 pl_84 pr_34 product_details_content"
                        >
                            <div
                                v-if="activeProductDiscountEndDate"
                                class="offer_badge_right"
                            >
                                <span
                                    >On Sale Thru
                                    {{ activeProductDiscountEndDate }}</span
                                >
                            </div>

                            <!-- Product Error/Unavailable Message -->
                            <div
                                v-if="productLoadError || productUnavailable"
                                class="alert alert-danger product-error-message"
                                style="
                                    margin-top: 20px;
                                    padding: 15px;
                                    border-radius: 5px;
                                    background-color: #f8d7da;
                                    border: 1px solid #f5c6cb;
                                    color: #721c24;
                                "
                            >
                                <div style="display: flex; align-items: center">
                                    <svg
                                        style="
                                            width: 24px;
                                            height: 24px;
                                            margin-right: 10px;
                                            flex-shrink: 0;
                                        "
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                    <div>
                                        <strong
                                            style="
                                                font-size: 16px;
                                                display: block;
                                                margin-bottom: 5px;
                                            "
                                            >Product Unavailable</strong
                                        >
                                        <p style="margin: 0; font-size: 14px">
                                            {{
                                                productErrorMessage ||
                                                "This product is currently unavailable. Please contact the administrator for more information."
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="product_headding d-flex">
                                <h1 class="heading1 w-75">
                                    {{ product.name | capitalize }}
                                </h1>
                                <div
                                    v-if="product.Brand"
                                    class="company_logo ml-auto w-25 text-right"
                                >
                                    <router-link
                                        v-tooltip="product.Brand.name"
                                        :to="{
                                            path:
                                                '/brand/' +
                                                (product.Brand.slug
                                                    ? product.Brand.slug
                                                    : product.Brand.id)
                                        }"
                                    >
                                        <img
                                            :src="
                                                product.Brand.logo_file
                                                    ? product.Brand.logo_file
                                                    : '/maincss/images/brand_logo.png'
                                            "
                                            alt=" "
                                        />
                                    </router-link>
                                </div>
                            </div>
                            <div class="d-flex align-items-center mt_6">
                                <h4
                                    class="font_size_28 text_primary_blue m-0 text-uppercase"
                                >
                                    {{ product.product_number }}
                                </h4>
                            </div>
                            <div class="rush_service_main">
                                <div class="rush-bar">
                                    <div class="ship-date">
                                        <span class="label">
                                            Estimated Ship Date
                                            <span class="asterisk">*</span> :
                                        </span>
                                        <span class="value">{{
                                            displayShipDate
                                        }}</span>
                                    </div>
                                    <div
                                        class="rush-cta"
                                        v-if="
                                            !rushOptionsVisible &&
                                            dynamicRushOptions.length > 0
                                        "
                                    >
                                        <span class="need-text"
                                            >Need it faster?</span
                                        >
                                        <button
                                            type="button"
                                            class="rush-btn"
                                            @click="toggleRushOptions"
                                        >
                                            RUSH OPTIONS
                                        </button>
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        rushOptionsVisible &&
                                        dynamicRushOptions.length > 0
                                    "
                                    class="rush-options-card"
                                >
                                    <p class="rush_option_heading">
                                        Rush Service
                                        <span class="asterisk">*</span> :
                                    </p>
                                    <div
                                        class="rush-option"
                                        v-for="option in dynamicRushOptions"
                                        :key="option.id"
                                    >
                                        <label class="rush-option-label">
                                            <input
                                                type="radio"
                                                :value="option.id"
                                                v-model="selectedRushOptionId"
                                                @change="
                                                    selectRushOption(option)
                                                "
                                            />
                                            <p class="label_items">
                                                <span class="option-title">
                                                    {{ option.label }}
                                                </span>
                                                <span
                                                    class="option-price"
                                                    v-if="option.price > 0"
                                                >
                                                    – ${{
                                                        option.price.toFixed(2)
                                                    }}
                                                </span>
                                                <span class="option-date">
                                                    – Est. Shipping:
                                                    {{ option.shipDate }}
                                                </span>
                                            </p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="product_details_content">
                                <div class="product_details_radio_btn">
                                    <form action="#">
                                        <div
                                            class="form__group d-flex align-items-center mt_28"
                                        >
                                            <div
                                                v-show="
                                                    decoration_services_show
                                                "
                                                v-for="dec_service in sortedDecorationServices"
                                                :class="
                                                    (dec_service.isActive
                                                        ? 'active '
                                                        : '') +
                                                    'form__radio-group'
                                                "
                                                :key="dec_service.id"
                                            >
                                                <input
                                                    type="radio"
                                                    name="decoration_services"
                                                    :id="dec_service.id"
                                                    :value="dec_service.name"
                                                    :checked="
                                                        dec_service.isActive
                                                    "
                                                    v-on:input="
                                                        changeDecorationService(
                                                            dec_service.id
                                                        )
                                                    "
                                                    class="form__radio-input"
                                                />
                                                <label
                                                    :for="dec_service.id"
                                                    class="form__label-radio"
                                                >
                                                    <img
                                                        src="/maincss/images/checked_shipping_white.svg"
                                                        alt=""
                                                    />
                                                    {{ getDecorationServiceEcommDisplayName(dec_service) || dec_service.name }}
                                                </label>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <!-- Patch Selection UI (Material + Name dropdowns) -->
                                <div
                                    v-if="isPatchEnabledForActiveService"
                                    class="patch-selection-row mt_16 d-flex flex-wrap align-items-end"
                                    style="gap: 16px;"
                                >
                                    <div class="patch-dropdown-group">
                                        <label class="patch-dropdown-label">Material</label>
                                        <select
                                            class="form-control patch-select"
                                            v-model="selectedPatchMaterialId"
                                            @change="onPatchMaterialChange"
                                        >
                                            <option :value="null" disabled>Select Material</option>
                                            <option
                                                v-for="mat in patchMaterials"
                                                :key="mat.id"
                                                :value="mat.id"
                                            >{{ mat.name }}</option>
                                        </select>
                                    </div>
                                    <div class="patch-dropdown-group">
                                        <label class="patch-dropdown-label">Name</label>
                                        <select
                                            class="form-control patch-select"
                                            v-model="selectedPatchId"
                                            @change="onPatchNameChange"
                                            :disabled="!selectedPatchMaterialId || patchesByMaterial.length === 0"
                                        >
                                            <option :value="null" disabled>Select Patch</option>
                                            <option
                                                v-for="patch in patchesByMaterial"
                                                :key="patch.id"
                                                :value="patch.id"
                                            >{{ patch.image_name }}{{ (patch.width && patch.height) ? ' (' + patch.width + '" x ' + patch.height + '")' : '' }}</option>
                                        </select>
                                    </div>
                                </div>
                                <!-- <div
                                    v-if="isPatchEnabledForActiveService && selectedPatchDimensions"
                                    class="patch-dimensions-display mt_8"
                                >
                                    Dimension &nbsp; {{ selectedPatchDimensions }}
                                </div> -->
                                <div
                                    v-if="isPatchEnabledForActiveService"
                                    class="patch-options-link-wrap mt_8"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        class="patch-options-link"
                                        @click.prevent="goToPatchApplicationDetail"
                                    >
                                        Compare Patch Options
                                    </a>
                                </div>

                                <!-- Customer Patch Inventory -->
                                <div
                                    v-if="isPatchEnabledForActiveService && patchInventoryForProduct.length > 0"
                                    class="patch-inventory-section mt_16"
                                    style="background: #f0f7ff; border: 1px solid #d0e3f7; border-radius: 6px; padding: 12px 16px;"
                                >
                                    <div style="font-weight: 600; font-size: 14px; margin-bottom: 8px; color: #1a3e6e;">
                                        Available Patch Inventory
                                    </div>
                                    <div
                                        v-for="inv in patchInventoryForProduct"
                                        :key="inv.id"
                                        class="d-flex align-items-center justify-content-between"
                                        style="padding: 4px 0; font-size: 13px;"
                                    >
                                        <span>
                                            {{ inv.patch ? inv.patch.image_name : ('Patch #' + inv.patch_id) }}
                                            <span v-if="inv.width && inv.height" style="color: #666;">
                                                ({{ inv.width }}" x {{ inv.height }}")
                                            </span>
                                            <span v-if="inv.material" style="color: #888; font-size: 12px;">
                                                &mdash; {{ inv.material.name }}
                                            </span>
                                        </span>
                                        <span style="font-weight: 600; color: #1a6e3a;">
                                            {{ inv.remaining_quantity }} remaining
                                        </span>
                                    </div>
                                </div>

                                <div
                                    class="product_count_pricing mt_24"
                                    v-if="priceTableData.length > 0"
                                >
                                    <div
                                        class="product_count_pricing mt_24"
                                        v-if="priceTableData.length > 0"
                                    >
                                        <div
                                            class="table-responsive product_x-scroll"
                                        >
                                            <table
                                                class="table text-center pricing-table"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th
                                                            style="
                                                                width: 100px;
                                                                text-align: left;
                                                            "
                                                        >
                                                            Quantity
                                                        </th>
                                                        <th
                                                            v-for="(
                                                                item, index
                                                            ) in priceTableData"
                                                            :key="`qty-${index}`"
                                                        >
                                                            {{ item.quantity }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="text-left">
                                                            <strong
                                                                >Retail</strong
                                                            >
                                                        </td>
                                                        <td
                                                            :class="{
                                                                retail_discount:
                                                                    activeProductDiscount
                                                            }"
                                                            v-for="(
                                                                item, index
                                                            ) in priceTableData"
                                                            :key="`retail-${index}`"
                                                        >
                                                            {{
                                                                icPriceFormat(
                                                                    item.retail_cost
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        v-if="
                                                            activeProductDiscount
                                                        "
                                                    >
                                                        <td
                                                            class="text-left on_sale"
                                                        >
                                                            <strong
                                                                >OnSale</strong
                                                            >
                                                        </td>
                                                        <td
                                                            v-for="(
                                                                item, index
                                                            ) in priceTableData"
                                                            :key="`onsale-${index}`"
                                                        >
                                                            {{
                                                                item.on_sale_price !==
                                                                null
                                                                    ? icPriceFormat(
                                                                          item.on_sale_price
                                                                      )
                                                                    : "-"
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <!-- Patch Pricing Row -->
                                                    <tr v-if="isPatchEnabledForActiveService && selectedPatchData && patchPricePerTier.length > 0">
                                                        <td class="text-left">
                                                            <strong>Patch</strong>
                                                        </td>
                                                        <td
                                                            v-for="(tier, index) in patchPricePerTier"
                                                            :key="`patch-${index}`"
                                                            :class="{ 'patch-price-cell': true, 'patch-no-price': !tier.has_price }"
                                                        >
                                                            {{ tier.has_price ? icPriceFormat(tier.retail_price) : '-' }}
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        v-if="
                                                            isPreviewMode &&
                                                            !isAdminLoggedIn
                                                        "
                                                    >
                                                        <td class="text-left">
                                                            <strong
                                                                >Cost</strong
                                                            >
                                                        </td>
                                                        <td
                                                            v-for="(
                                                                item, index
                                                            ) in priceTableData"
                                                            :key="`cost-${index}`"
                                                        >
                                                            {{
                                                                icPriceFormat(
                                                                    item.net_cost
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        v-if="
                                                            isPreviewMode &&
                                                            !isAdminLoggedIn
                                                        "
                                                    >
                                                        <td class="text-left">
                                                            <strong
                                                                >Margin</strong
                                                            >
                                                        </td>
                                                        <td
                                                            v-for="(
                                                                item, index
                                                            ) in priceTableData"
                                                            :key="`margin-${index}`"
                                                        >
                                                            {{
                                                                icPriceFormat(
                                                                    (item.on_sale_price !=
                                                                    null
                                                                        ? item.on_sale_price
                                                                        : item.retail_cost) -
                                                                        item.net_cost
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p
                                class="base_price"
                                v-if="activeServicePriceText"
                                style="white-space: pre-line"
                            >
                                {{ activeServicePriceText }}
                            </p>
                            <div class="mt-1">
                                <strong>
                                    Minimum Order Quantity :
                                    <span>{{ minimumOrderQuantity }}</span>
                                </strong>
                            </div>
                            <div class="products_count_tab mt_30">
                                <ul
                                    class="nav nav-tabs overfolw_x_scroll"
                                    id="myTab"
                                    role="tablist"
                                >
                                    <li
                                        @click="activeLink(index)"
                                        class="nav-item"
                                        :class="{ active: is_active == index }"
                                        v-for="(gender, index) in gender_groups"
                                        :key="index"
                                        role="presentation"
                                    >
                                        <a
                                            class="nav-link"
                                            :id="index + '-tab'"
                                            role="tab"
                                            aria-controls="profile"
                                            aria-selected="false"
                                            >{{ getAvailableSizeRange(gender) }}</a
                                        >
                                    </li>
                                </ul>
                                <div
                                    class="row"
                                    v-for="(gender, index) in gender_groups"
                                    :key="index"
                                    v-show="index == is_active"
                                >
                                    <div
                                        class="col-md-10 col-lg-9 color_checkboxes_mr"
                                    >
                                        <h4
                                            class="available_colors font_size_17 mt_20 mb_0"
                                        >
                                            Available Colors
                                        </h4>
                                        <div
                                            class="d-flex flex-wrap justify-content-left color_checkbox"
                                        >
                                            <div
                                                v-for="(
                                                    gendercolors, ind
                                                ) in sortedColors"
                                                :key="gendercolors.id || ind"
                                                class="form-check pl-0 mt_10"
                                            >
                                                <label
                                                    v-show="ind <= 9"
                                                    class="checkbox_custom"
                                                    v-tooltip="
                                                        gendercolors.color_name
                                                    "
                                                    :class="{
                                                        'checkmark-black':
                                                            gendercolors.is_selected &&
                                                            gendercolors.hash ==
                                                                '#ffffff',
                                                        'check-active':
                                                            gendercolors.is_selected &&
                                                            gendercolors.hash !=
                                                                '#ffffff'
                                                    }"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        :id="`gender_${gender.id}_color_${gendercolors.id}`"
                                                        :name="
                                                            'avilable_color_' +
                                                            index
                                                        "
                                                        @change="
                                                            getsizeByColor(
                                                                gendercolors,
                                                                $event
                                                            )
                                                        "
                                                        v-model="
                                                            gendercolors.is_selected
                                                        "
                                                    />
                                                    <img
                                                        v-if="
                                                            gendercolors.swatches &&
                                                            gendercolors.swatches.trim() !== ''
                                                        "
                                                        :src="
                                                            gendercolors.swatches
                                                        "
                                                        class="checkmark"
                                                        :class="[
                                                            gendercolors.hash ==
                                                            '#FFFFFF'
                                                                ? 'bg-white'
                                                                : ''
                                                        ]"
                                                    />
                                                    <span
                                                        v-else
                                                        :class="
                                                            gendercolors.hash.trim() ==
                                                            '#ffffff'
                                                                ? 'checkmark checkmark_black'
                                                                : 'checkmark'
                                                        "
                                                        v-bind:style="
                                                            'background:' +
                                                            gendercolors.hash
                                                        "
                                                    ></span>
                                                </label>

                                                <div v-if="is_color_show_more">
                                                    <label
                                                        v-show="ind > 9"
                                                        class="checkbox_custom"
                                                        v-tooltip="
                                                            gendercolors.color_name
                                                        "
                                                        :class="{
                                                            'checkmark-black':
                                                                gendercolors.is_selected &&
                                                                gendercolors.hash ==
                                                                    '#ffffff',
                                                            'check-active':
                                                                gendercolors.is_selected &&
                                                                gendercolors.hash !=
                                                                    '#ffffff'
                                                        }"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            :id="`gender_${gender.id}_color_${gendercolors.id}`"
                                                            :name="
                                                                'avilable_color_' +
                                                                index
                                                            "
                                                            @change="
                                                                getsizeByColor(
                                                                    gendercolors,
                                                                    $event
                                                                )
                                                            "
                                                            v-model="
                                                                gendercolors.is_selected
                                                            "
                                                        />
                                                        <img
                                                            v-if="
                                                                gendercolors.swatches &&
                                                                gendercolors.swatches.trim() !== ''
                                                            "
                                                            :src="
                                                                gendercolors.swatches
                                                            "
                                                            class="checkmark"
                                                            :class="[
                                                                gendercolors.hash ==
                                                                '#FFFFFF'
                                                                    ? 'bg-white'
                                                                    : ''
                                                            ]"
                                                        />
                                                        <span
                                                            v-else
                                                            :class="
                                                                gendercolors.hash.trim() ==
                                                                '#ffffff'
                                                                    ? 'checkmark checkmark_black'
                                                                    : 'checkmark'
                                                            "
                                                            v-bind:style="
                                                                'background:' +
                                                                gendercolors.hash
                                                            "
                                                        ></span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div
                                                v-show="colors.length > 10"
                                                class="form-check pl-0 mt_10"
                                            >
                                                <label class="checkbox_custom">
                                                    <input
                                                        type="checkbox"
                                                        @click="
                                                            showMore(
                                                                'is_color_show_more'
                                                            )
                                                        "
                                                    />
                                                    <span
                                                        class="checkmark check_box plus_icon-align"
                                                        v-bind:class="
                                                            is_color_show_more
                                                                ? 'minus_box'
                                                                : ''
                                                        "
                                                    >
                                                        <img
                                                            v-if="
                                                                is_color_show_more
                                                            "
                                                            src="/maincss/images/minus1.svg"
                                                        />
                                                        <template v-else
                                                            >+{{
                                                                colors.length -
                                                                10
                                                            }}</template
                                                        >
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="tab-content mt_12"
                                    id="myTabContent"
                                >
                                    <div
                                        class="tab-pane fade show active"
                                        v-for="(gender, index) in gender_groups"
                                        :key="index"
                                        :id="index"
                                        role="tabpanel"
                                        :aria-labelledb="index + '-tab'"
                                        v-show="is_active == index"
                                    >
                                        <div class="tab_pro_panel">
                                            <div
                                                v-for="picked_color in gender.selected_colors"
                                                :key="picked_color.id"
                                                class="tabs_table d-md-flex size_color_table"
                                            >
                                                <div
                                                    class="available_color_columns"
                                                >
                                                    <div
                                                        class="color d-flex align-items-center color_column"
                                                    >
                                                        <img
                                                            v-if="
                                                                picked_color.swatches &&
                                                                picked_color.swatches.trim() !== ''
                                                            "
                                                            class="color_box mr_10"
                                                            :src="
                                                                picked_color.swatches
                                                            "
                                                        />
                                                        <div
                                                            v-else
                                                            class="color_box mr_10"
                                                            :style="
                                                                'background: ' +
                                                                picked_color.hash
                                                            "
                                                        ></div>
                                                        <h5 class="color-name">
                                                            {{
                                                                converToCamel(
                                                                    picked_color.color_name
                                                                )
                                                            }}
                                                            - Sizes
                                                        </h5>
                                                    </div>
                                                </div>
                                                <div class="sizez_columns">
                                                    <div
                                                        class="d-flex flex-wrap inner_size_table"
                                                    >
                                                        <div
                                                            class="product_count"
                                                            v-for="(
                                                                gendersizes,
                                                                indx
                                                            ) in picked_color[
                                                                'unique_sizes'
                                                            ]"
                                                            :key="indx"
                                                        >
                                                            <div
                                                                class="count_item_heading"
                                                            >
                                                                <h6 class="m-0">
                                                                    {{
                                                                        gendersizes
                                                                            .Size
                                                                            .size
                                                                    }}
                                                                </h6>
                                                                <span>
                                                                    {{
                                                                        icPriceFormat(
                                                                            getSizeCostWithDiscount(
                                                                                gendersizes.cost
                                                                            )
                                                                        )
                                                                    }}
                                                                </span>
                                                            </div>
                                                            <div
                                                                class="count_item_price"
                                                            >
                                                                <input
                                                                    type="text"
                                                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                                                    v-model="
                                                                        gendersizes.quantity
                                                                    "
                                                                    @change="
                                                                        calculatePricing(
                                                                            index,
                                                                            gendersizes,
                                                                            $event
                                                                        )
                                                                    "
                                                                    class="form-control"
                                                                    placeholder="0"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="product_count total_count d-none"
                                                        >
                                                            <div
                                                                class="count_item_heading"
                                                            >
                                                                <h6 class="m-0">
                                                                    Total
                                                                </h6>
                                                            </div>
                                                            <div
                                                                class="count_item_price total_box"
                                                            >
                                                                <b>{{
                                                                    icPriceFormat(
                                                                        picked_color.total_cost_gender_wise
                                                                    )
                                                                }}</b>
                                                                <!-- <input readonly type="text" :value="icPriceFormat(picked_color.total_cost_gender_wise)"
                                  class="form-control" placeholder="0" /> -->
                                                                <div
                                                                    class="dropdown"
                                                                    v-if="
                                                                        picked_color.total_qty_gender_wise >
                                                                        0
                                                                    "
                                                                >
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        class="dropdown-toggle d-flex align-items-center"
                                                                        :id="
                                                                            'dropdownMenuButton' +
                                                                            picked_color.id
                                                                        "
                                                                        data-toggle="dropdown"
                                                                        aria-haspopup="true"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <img
                                                                            src="/maincss/images/path.png"
                                                                            class="ml_6 path"
                                                                        />
                                                                    </a>

                                                                    <div
                                                                        class="dropdown-menu drop-cart-menu drop_product"
                                                                        aria-labelledby="dropdownMenuButton"
                                                                    >
                                                                        <h4
                                                                            class="font_size_16 text_primary_blue py_2 px_20"
                                                                        >
                                                                            {{
                                                                                converToCamel(
                                                                                    picked_color.color_name
                                                                                )
                                                                            }}
                                                                            <span
                                                                                class="cross_ic"
                                                                            >
                                                                                <img
                                                                                    src="/maincss/images/cross.svg"
                                                                                />
                                                                            </span>
                                                                        </h4>
                                                                        <div
                                                                            class="scroll"
                                                                        >
                                                                            <div>
                                                                                <div
                                                                                    class="col-md-12"
                                                                                >
                                                                                    <div
                                                                                        class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                                    >
                                                                                        <div
                                                                                            class="table-responsive"
                                                                                        >
                                                                                            <table
                                                                                                width="100%"
                                                                                                class="table-bordered comma-decimal-place table-data table-hover space_b"
                                                                                            >
                                                                                                <thead>
                                                                                                    <tr>
                                                                                                        <th>
                                                                                                            Size
                                                                                                        </th>
                                                                                                        <th>
                                                                                                            Quantity
                                                                                                        </th>
                                                                                                        <th>
                                                                                                            Total
                                                                                                        </th>
                                                                                                    </tr>
                                                                                                </thead>
                                                                                                <tbody>
                                                                                                    <tr
                                                                                                        v-for="(
                                                                                                            size,
                                                                                                            ind
                                                                                                        ) in picked_color[
                                                                                                            'unique_sizes'
                                                                                                        ]"
                                                                                                        :key="
                                                                                                            ind
                                                                                                        "
                                                                                                        v-show="
                                                                                                            size.quantity >
                                                                                                            0
                                                                                                        "
                                                                                                    >
                                                                                                        <td
                                                                                                            class="size"
                                                                                                        >
                                                                                                            {{
                                                                                                                size
                                                                                                                    .Size
                                                                                                                    .size
                                                                                                            }}
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {{
                                                                                                                size.quantity
                                                                                                            }}
                                                                                                            *
                                                                                                            {{
                                                                                                                icPriceFormat(
                                                                                                                    getSizeCostWithDiscount(
                                                                                                                        size.cost
                                                                                                                    )
                                                                                                                )
                                                                                                            }}
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {{
                                                                                                                icPriceFormat(
                                                                                                                    getSizeCostWithDiscount(
                                                                                                                        size.cost
                                                                                                                    ) *
                                                                                                                        (parseInt(
                                                                                                                            size.quantity
                                                                                                                        ) ||
                                                                                                                            0)
                                                                                                                )
                                                                                                            }}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="col-md-12"
                                                                                >
                                                                                    <div
                                                                                        class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                                        v-if="
                                                                                            parseFloat(
                                                                                                picked_color.total_design_fee
                                                                                            ) >
                                                                                            0
                                                                                        "
                                                                                    >
                                                                                        <p
                                                                                            class="font-weight-bold w-90 m-0"
                                                                                        >
                                                                                            Design
                                                                                            Fee:
                                                                                        </p>
                                                                                        <p
                                                                                            class="ml-auto mb-0"
                                                                                        >
                                                                                            {{
                                                                                                picked_color.total_design_fee >=
                                                                                                0
                                                                                                    ? icPriceFormat(
                                                                                                          picked_color.total_design_fee
                                                                                                      )
                                                                                                    : 0.0
                                                                                            }}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span
                                                        class="d-block multiple_error"
                                                        v-if="
                                                            picked_color.existing_cart_quantity
                                                        "
                                                    >
                                                        This color already added
                                                        in cart with
                                                        {{
                                                            picked_color.existing_cart_quantity
                                                        }}.
                                                    </span>
                                                </div>
                                                <a
                                                    href="javascript:void(0);"
                                                    class="mt-1"
                                                >
                                                    <img
                                                        @click="
                                                            getsizeByColor(
                                                                picked_color
                                                            )
                                                        "
                                                        src="/maincss/images/icons/delete_dark.svg"
                                                    />
                                                </a>
                                            </div>
                                        </div>

                                        <!-- START IMPRINT LOCATION COLORS -->
                                        <div
                                            class="right_section_main"
                                            v-if="choose_imprint_locations"
                                        >
                                            <h5
                                                class="mt-4"
                                            >
                                                Select locations and
                                                number of colors
                                            </h5>
                                            <!-- <h5
                                                class="mt-4"
                                                v-else-if="
                                                    product.decoration_type == 2
                                                "
                                            >
                                                Select embroidery locations and
                                                number of thread colors
                                            </h5> -->
                                            <div class="right_section">
                                                <div class="alignment_section">
                                                    <div
                                                        class="right_items w-100"
                                                        :class="{
                                                            checkbox_checked:
                                                                implicitylocation.is_selected
                                                        }"
                                                        v-for="(
                                                            implicitylocation,
                                                            l_inx
                                                        ) in imprint_locations"
                                                        :key="l_inx"
                                                    >
                                                        <div
                                                            class="images_right" 
                                                            :class="{
                                                                'cap_category_images': shouldApplyCapCategoryClassStrict(implicitylocation.image_path)
                                                            }"
                                                            @click="
                                                                selectImprintLocations(
                                                                    l_inx
                                                                )
                                                            "
                                                        >
                                                            <img
                                                                class="direct"
                                                                :src="
                                                                    implicitylocation.image_path
                                                                "
                                                                alt=""
                                                            />
                                                            <input
                                                                type="checkbox"
                                                                :name="
                                                                    'is_selected_location' +
                                                                    l_inx
                                                                "
                                                                :class="{
                                                                    checked:
                                                                        implicitylocation.is_selected
                                                                }"
                                                                :id="
                                                                    'same-address' +
                                                                    l_inx
                                                                "
                                                                :checked="
                                                                    implicitylocation.is_selected
                                                                "
                                                            />
                                                        </div>
                                                        <p>
                                                            {{
                                                                implicitylocation.location
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="select-imprint-area mt_24 popup_right_section"
                                                    v-show="is_imprint_location"
                                                >
                                                    <div
                                                        class="imprint-area-box imprint-product_area_box mb_40 popup_dropdown"
                                                    >
                                                        <div id="accordion">
                                                            <div class="">
                                                                <div
                                                                    class=""
                                                                    id="select-one"
                                                                >
                                                                    <h5
                                                                        class="mb-0"
                                                                        v-for="(
                                                                            implicitylocation,
                                                                            l_inx
                                                                        ) in imprint_locations"
                                                                        :key="
                                                                            l_inx
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="left-chest-"
                                                                            v-if="
                                                                                implicitylocation.is_selected
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="row left_botom_0"
                                                                            >
                                                                                <div
                                                                                    class="col-md-6 align-self-end drop-sec"
                                                                                >
                                                                                    <label
                                                                                        class="label-head"
                                                                                        style="
                                                                                            cursor: pointer;
                                                                                        "
                                                                                        for="left-chest"
                                                                                    >
                                                                                        {{
                                                                                            implicitylocation.location
                                                                                        }}
                                                                                        <p
                                                                                            v-if="
                                                                                                decoration_type ==
                                                                                                1
                                                                                            "
                                                                                        >
                                                                                            (choose
                                                                                            
                                                                                            colors)
                                                                                        </p>
                                                                                        <p
                                                                                            v-if="
                                                                                                decoration_type ==
                                                                                                2
                                                                                            "
                                                                                        >
                                                                                            (choose
                                                                                            
                                                                                            colors)
                                                                                        </p>
                                                                                        <p
                                                                                            v-if="
                                                                                                decoration_type ==
                                                                                                3
                                                                                            "
                                                                                        >
                                                                                            (choose
                                                                                            
                                                                                            colors)
                                                                                        </p>
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    class="col-md-4 dropdown_colors"
                                                                                >
                                                                                    <div
                                                                                        class="form-group mt-0"
                                                                                    >
                                                                                        <v-select
                                                                                            width="100%"
                                                                                            placeholder="Select-colors"
                                                                                            label="value"
                                                                                            :reduce="
                                                                                                (
                                                                                                    color
                                                                                                ) =>
                                                                                                    color.id
                                                                                            "
                                                                                            :options="
                                                                                                imprintcityColors
                                                                                            "
                                                                                            v-model="
                                                                                                implicitylocation.no_of_color
                                                                                            "
                                                                                            @input="
                                                                                                selectNumberOfColors(
                                                                                                    implicitylocation,
                                                                                                    $event
                                                                                                )
                                                                                            "
                                                                                        ></v-select>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="col-md-2 cost_right"
                                                                                >
                                                                                    <span
                                                                                        class="mt-1 d-none"
                                                                                        v-if="
                                                                                            implicitylocation.decoration_fee
                                                                                        "
                                                                                    >
                                                                                        +
                                                                                        {{
                                                                                            icPriceFormat(
                                                                                                implicitylocation.decoration_fee
                                                                                            )
                                                                                        }}
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <!-- <div :id="`collapseColors${l_inx}`"
                                                                                class="collapse show"
                                                                                aria-labelledby="select-one"
                                                                                data-parent="#accordion">
                                                                                <div class="card-body">
                                                                                    <div class="row select_color"
                                                                                        v-show="implicitylocation.no_of_color > 0"
                                                                                        v-for="(colors, c_inx) in implicitylocation.colors"
                                                                                        :key="c_inx">
                                                                                        <div
                                                                                            class="col-md-6 align-self-end drop_menus">
                                                                                            <label>
                                                                                                <span
                                                                                                    v-if="decoration_type == 1">
                                                                                                    Select
                                                                                                    Imprint
                                                                                                    Color -
                                                                                                    {{ c_inx
                                                                                                        + 1
                                                                                                    }}</span>
                                                                                                <span
                                                                                                    v-else-if="decoration_type == 2 || decoration_type == 4">
                                                                                                    Select
                                                                                                    Thread
                                                                                                    Color -
                                                                                                    {{ c_inx
                                                                                                        + 1
                                                                                                    }}</span>
                                                                                                <span
                                                                                                    v-else-if="decoration_type == 3">
                                                                                                    Select
                                                                                                    Vinyl
                                                                                                    Color -
                                                                                                    {{ c_inx
                                                                                                        + 1
                                                                                                    }}</span>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div class="col-md-6">
                                                                                            <div class="form-group mt_0">
                                                                                                <v-select
                                                                                                    :filter="fuseSearch"
                                                                                                    :options="filterVendorColors(imprint_colors_array_for_template, l_inx)"
                                                                                                    :get-option-label="(option) => option.color_name"
                                                                                                    placeholder="Select"
                                                                                                    v-model="colors.color"
                                                                                                    @input="getColorWiseCost(c_inx, l_inx, is_active, $event)">
                                                                                                    <template
                                                                                                        #option="{ color_value, color_name, swatch_file }">
                                                                                                        <span
                                                                                                            v-if="color_value">
                                                                                                            <cite
                                                                                                                class="imprint_color_box"
                                                                                                                v-bind:style="'background:' + color_value"></cite>
                                                                                                            {{
                                                                                                                color_name
                                                                                                            }}
                                                                                                        </span>
                                                                                                        <span v-else>
                                                                                                            <img class="imprint_color_box"
                                                                                                                :src="swatch_file"
                                                                                                                alt="" />
                                                                                                            {{
                                                                                                                color_name
                                                                                                            }}
                                                                                                        </span>
                                                                                                    </template>
                                                                                                </v-select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div> -->
                                                                        </div>
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- END IMPRINT LOCATION COLORS -->

                                        <!-- <div class="d-md-flex mt_26 cost_total_col" v-if="hashcolor[index]"> -->
                                        <div
                                            v-if="
                                                activeDecorationService &&
                                                gender.total_qty_gender_wise > 0
                                            "
                                        >
                                            <PCNAPriceBreakdown
                                                v-if="
                                                    activeDecorationService.use_imprintcity_price_template ===
                                                        0 &&
                                                    activeDecorationService.master_service
                                                "
                                                :key="
                                                    activeDecorationService.id +
                                                    '_' +
                                                    gender.total_qty_gender_wise
                                                "
                                                :quantity="
                                                    gender.total_qty_gender_wise
                                                "
                                                :other-services="otherServices"
                                                :base-cost="
                                                    currentBreakdown.baseCost
                                                "
                                                :run-charge="
                                                    currentBreakdown.runCharge
                                                "
                                                :run-charge-details="
                                                    currentBreakdown.runChargeDetails ||
                                                    []
                                                "
                                                :setup-fee="
                                                    currentBreakdown.setupFee
                                                "
                                                :subtotal="
                                                    currentBreakdown.totalCost
                                                "
                                                :discount-config="
                                                    activeProductDiscount
                                                "
                                                :imprint-locations="
                                                    imprint_locations
                                                "
                                                :service-master-data="
                                                    activeDecorationService.master_service ||
                                                    {}
                                                "
                                                :stitch-count="0"
                                                :color-size-combinations="
                                                    getColorSizeCombinations(
                                                        gender
                                                    )
                                                "
                                                :selected-rush-option-id="
                                                    selectedRushOptionId
                                                "
                                                :vendor-services="
                                                    vendorServices
                                                "
                                                :active-service-id="
                                                    activeDecorationService &&
                                                    activeDecorationService.id !== null &&
                                                    activeDecorationService.id !== undefined
                                                        ? Number(activeDecorationService.id)
                                                        : null
                                                "
                                                :dynamic-rush-options="
                                                    dynamicRushOptions
                                                "
                                                :patch-cost="productPatchCost"
                                                :patch-cost-details="productPatchCostDetails"
                                                :patch-slab-quantity="productPatchSlabQuantity"
                                                :patch-cost-warning="productPatchCostWarning"
                                            />

                                            <ImprintCityPriceBreakdown
                                                v-else
                                                :quantity="
                                                    gender.total_qty_gender_wise
                                                "
                                                :design-fee="
                                                    gender.total_design_fee
                                                "
                                                :discount-config="
                                                    activeProductDiscount
                                                "
                                                :other-services="otherServices"
                                                :base-cost="
                                                    currentBreakdown.baseCost
                                                "
                                                :run-charge="
                                                    currentBreakdown.runCharge
                                                "
                                                :setup-fee="
                                                    currentBreakdown.setupFee
                                                "
                                                :total-cost="
                                                    currentBreakdown.totalCost
                                                "
                                                :run-charge-details="
                                                    currentBreakdown.runChargeDetails ||
                                                    []
                                                "
                                                :imprint-locations="
                                                    imprint_locations
                                                "
                                                :service-master-data="
                                                    activeDecorationService.master_service ||
                                                    {}
                                                "
                                                :active-decoration-service="
                                                    activeDecorationService ||
                                                    null
                                                "
                                                :decoration-pricing-data="
                                                    activeDecorationService.price_decoration_bulk ||
                                                    null
                                                "
                                                :decoration-type="
                                                    activeDecorationService.decoration_type ||
                                                    1
                                                "
                                                :total-quantity="
                                                    gender.total_qty_gender_wise
                                                "
                                                :color-size-combinations="
                                                    getColorSizeCombinations(
                                                        gender
                                                    )
                                                "
                                                :selected-rush-option-id="
                                                    selectedRushOptionId
                                                "
                                                :vendor-services="
                                                    vendorServices
                                                "
                                                :active-service-id="
                                                    activeDecorationService &&
                                                    activeDecorationService.id !== null &&
                                                    activeDecorationService.id !== undefined
                                                        ? Number(activeDecorationService.id)
                                                        : null
                                                "
                                                :dynamic-rush-options="
                                                    dynamicRushOptions
                                                "
                                                :patch-cost="productPatchCost"
                                                :patch-cost-details="productPatchCostDetails"
                                                :patch-slab-quantity="productPatchSlabQuantity"
                                                :patch-cost-warning="productPatchCostWarning"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="base_price mt-2" style="white-space: pre-line" v-if="activeServicePriceText">
                                    <p>{{ activeServicePriceText }}</p>
                                </div>
                                <div
                                    class="action-contents"
                                    v-if="!isPreviewMode"
                                >
                                    <a href="javascript:void(0);">
                                        <img
                                            src="/maincss/images/path.png"
                                            alt=""
                                    /></a>
                                    <p class="m-0">
                                        Submit to add or upload your artwork. You can still add other products with the same artwork afterwards to get the bulk pricing.
                                    </p>
                                </div>
                                <div class="buttons mt_0 add_new_button design-add-button">
                                    <a
                                        v-if="!isPreviewMode"
                                        href="Javascript:void(0);"
                                        class="btn btn_orange btn btn_orange bg_primary_orange text_white login-cart"
                                        :class="{
                                            disabled: shouldDisableActions
                                        }"
                                        @click="
                                            shouldDisableActions
                                                ? null
                                                : openStartDesignModal()
                                        "
                                    >
                                    Submit & Add Artwork
                                    </a>

                                    <div
                                        class="modal login-form-popup like_design_popup fade h-auto"
                                        id="add-art-work"
                                        tabindex="-1"
                                        aria-labelledby="art-work"
                                        aria-hidden="true"
                                        data-keyboard="false"
                                        data-backdrop="static"
                                    >
                                        <div
                                            class="modal-dialog modal-dialog-centered"
                                        >
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <div class="header_items">
                                                        <div>
                                                            <h5
                                                                class="modal-title"
                                                            >
                                                                How would you
                                                                like to design
                                                                your item ?
                                                            </h5>
                                                        </div>

                                                        <div
                                                            class="close_modal"
                                                        >
                                                            <a
                                                                href="#"
                                                                class="popup-close art_poup_close"
                                                                id="popup-close"
                                                                data-dismiss="modal"
                                                                ref="popupclose"
                                                            >
                                                                <span
                                                                    aria-hidden="true"
                                                                    v-tooltip="
                                                                        'Close'
                                                                    "
                                                                    >&times;</span
                                                                >
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="modal-body">
                                                    <div
                                                        class="form-check"
                                                        @click="
                                                            start_designing_with =
                                                                'scratch'
                                                        "
                                                    >
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault1"
                                                            @click="
                                                                start_designing_with =
                                                                    'scratch'
                                                            "
                                                            checked
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            @click="
                                                                start_designing_with =
                                                                    'scratch'
                                                            "
                                                            for="flexRadioDefault1"
                                                        >
                                                            Start from scratch
                                                            with Imprint City
                                                            Text and Graphics
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault2"
                                                            @click="
                                                                start_designing_with =
                                                                    'existing'
                                                            "
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            for="flexRadioDefault2"
                                                            @click="
                                                                start_designing_with =
                                                                    'existing'
                                                            "
                                                        >
                                                            Use One of My
                                                            Existing Design
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault3"
                                                            @click="
                                                                start_designing_with =
                                                                    'upload'
                                                            "
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            for="flexRadioDefault3"
                                                            @click="
                                                                start_designing_with =
                                                                    'upload'
                                                            "
                                                        >
                                                            Upload some new
                                                            graphics
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button
                                                        type="button"
                                                        @click="startDesign()"
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--crop popup-->
                <div
                    class="modal login-form-popup fade h-auto"
                    id="crop_modal"
                    tabindex="-1"
                    aria-labelledby="login"
                    aria-hidden="true"
                    data-keyboard="false"
                    data-backdrop="static"
                >
                    <div
                        class="modal-dialog modal-dialog-centered modal-dialog-scrollable large_popup_l upload_art_popup"
                    >
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3>Upload</h3>
                                <a
                                    href="#"
                                    class="popup-close"
                                    id="popup-close"
                                    data-dismiss="modal"
                                    @click="cancelUploadArtwork"
                                >
                                    <img
                                        src="/maincss/images/cancel.svg"
                                        alt=" "
                                    />
                                </a>
                            </div>
                            <div class="modal-body">
                                <div class="login-form">
                                    <div class="upload_crop_design_studio row">
                                        <div class="left_panel col-md-6">
                                            <input
                                                class="crop_bdr"
                                                id="crop_bdr"
                                                type="file"
                                                @change="croppie"
                                                v-tooltip="
                                                    'Accepting png, jpg, and jpeg format'
                                                "
                                            />
                                            <span class="uplod-size"
                                                >Accepting only Png, Jpg, Jpeg,
                                                Svg, Pdf, Ai, Eps files</span
                                            >
                                            <small
                                                class="form-text text-error"
                                                v-if="
                                                    crop_image_validation == 1
                                                "
                                                >Incorrect image format.Please
                                                upload the Png, Jpg, Jpeg, Svg,
                                                Pdf, Ai, Eps file formats</small
                                            >
                                            <small
                                                class="form-text text-error"
                                                v-if="
                                                    image_size_validation == 1
                                                "
                                                >Please upload images greater
                                                than 1000px X 1000px</small
                                            >
                                        </div>

                                        <div
                                            class="form-check brand_logo_img col-md-6"
                                        >
                                            <label
                                                v-if="
                                                    getUrlExtension(
                                                        croppieImage
                                                    ) == 'pdf'
                                                "
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <a
                                                    :href="croppieImage"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src="/maincss/images/pdf.svg"
                                                        alt="pdf"
                                                        width="100%"
                                                        height="100%"
                                                    />
                                                </a>
                                            </label>
                                            <label
                                                v-else-if="
                                                    getUrlExtension(
                                                        croppieImage
                                                    ) == 'ai'
                                                "
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <a
                                                    :href="croppieImage"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src="/maincss/images/ai_format_image.png"
                                                        alt="postscript"
                                                        width="100%"
                                                        height="100%"
                                                    />
                                                </a>
                                            </label>
                                            <label
                                                v-else-if="
                                                    getUrlExtension(
                                                        croppieImage
                                                    ) == 'eps'
                                                "
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <a
                                                    :href="croppieImage"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src="/maincss/images/eps_formate_image.png"
                                                        alt="postscript"
                                                        width="100"
                                                        height="100"
                                                    />
                                                </a>
                                            </label>
                                            <label
                                                v-else
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <img
                                                    :src="
                                                        croppieImage
                                                            ? croppieImage
                                                            : '/maincss/design-studio/img/design-st-upload.jpg'
                                                    "
                                                    class
                                                    alt="Size Chart Logo"
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <small
                                        class="form-text text-error text-left"
                                        v-show="errors.has('uploadform.image')"
                                    >
                                        {{ errors.first("uploadform.image") }}
                                    </small>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    style="
                                        background-color: #f2790c !important;
                                        color: #fff !important;
                                        border: 1px solid #f2790c !important;
                                    "
                                    class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                    id="crop_btn"
                                    type="button"
                                    @click="crop"
                                >
                                    <img
                                        src="/maincss/images/upload-white.svg"
                                        alt=" "
                                    />
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- START DESIGNING POPUP -->
                <div
                    class="modal fade h-auto login-form-popup"
                    id="design-confirmation-modal"
                    tabindex="-1"
                    aria-hidden="true"
                    data-keyboard="false"
                    data-backdrop="static"
                >
                    <div
                        class="modal-dialog modal-dialog-centered upload-artwork"
                    >
                        <div class="modal-content">
                            <div class="modal-body">
                                <a
                                    href="#"
                                    class="popup-close art_poup_close"
                                    id="popup-close"
                                    data-dismiss="modal"
                                >
                                    <img
                                        src="/maincss/images/cancel.svg"
                                        v-tooltip="'Close'"
                                        alt=" "
                                    />
                                </a>
                                <div class="login-form">
                                    <h3>Start Designing</h3>
                                    <p class="upload_design_p">
                                        Your selected Artwork will be removed if
                                        you will design this product, Are you
                                        sure?
                                    </p>
                                    <div class="upload_design">
                                        <div
                                            class="d-flex justify-content-center mb_20 start_design_btn_box"
                                        >
                                            <button
                                                class="btn btn_orange bg_primary_orange text_white mx_6"
                                                type="button"
                                                @click="startDesign()"
                                            >
                                                Continue
                                            </button>
                                            <a
                                                href="javascript:void(0)"
                                                class="btn btn_outline_primary border_primary_blue text_primary_blue mx_6"
                                                data-dismiss="modal"
                                                >Cancel</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PREVIEW MODEL -->
                <div
                    v-if="
                        getUrlExtension(preview_artwork_images) != 'ai' &&
                        getUrlExtension(preview_artwork_images) != 'eps'
                    "
                    class="modal fade cart_preview"
                    id="preview_modals"
                    data-backdrop="static"
                    data-keyboard="false"
                    tabindex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div
                        class="modal-dialog modal-dialog-centered modal-xl large_popup"
                    >
                        <div class="modal-content">
                            <div class="modal-header border-bottom-0 p-0">
                                <button
                                    @click="cancelPreviewImages"
                                    type="button"
                                    class="close py-2 pr-3"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <img src="/maincss/images/cancel.svg" />
                                </button>
                            </div>
                            <!-- <img v-else alt="" :id="`default-artwork-${index}`" src="/maincss/images/mug_2.png" /> -->
                            <div class="modal-body pt-0">
                                <div
                                    v-if="
                                        getUrlExtension(
                                            preview_artwork_images
                                        ) == 'pdf'
                                    "
                                    class="mx-auto preview-image mb_20"
                                >
                                    <!-- <img  :src="preview_artwork_images" alt="pdf"> -->
                                    <iframe
                                        :src="preview_artwork_images"
                                        width="500px"
                                        height="300px"
                                    ></iframe>
                                </div>
                                <div v-else class="mx-auto preview-image mb_20">
                                    <img :src="preview_artwork_images" alt="" />
                                </div>
                                <div class="mx-auto preview-image">
                                    <!-- <button class="btn btn_orange bg_primary_orange text_white" type="button" @click="downloadArtwork(item.NewOrderItemDecoration ? item.NewOrderItemDecoration.final_proof_image : '', 'FinalProofImage', index)">Download</button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div
            v-else-if="!isBusy"
            class="accessdenie border-0"
            style="background-color: #fff"
        >
            <div class="subhead page_404_box">
                <p class="mb_20">This product is no longer available</p>
                <router-link
                    class="btn btn_primary bg_primary_blue text_white"
                    :to="{ name: 'home' }"
                    >Back to home page</router-link
                >
            </div>
        </div>

        <section
            class="smilar_product pb-0 pt-0 smilar_product_align product_similar"
            v-if="companion_products.length > 0"
        >
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="heading2">Similar products</h2>
                    </div>
                </div>
                <div class="row mt_30">
                    <div
                        class="col-md-4 col-lg-2"
                        v-for="(similarproducts, index) in companion_products"
                        :key="index"
                    >
                        <div class="product">
                            <div
                                class="product_image position-relative d-flex justify-content-center align-items-center"
                            >
                                <router-link
                                    :to="{
                                        name: 'product_details_new',
                                        params: {
                                            id_of_product: similarproducts.id
                                        }
                                    }"
                                >
                                    <img
                                        v-if="!is_tshirt_24_hour"
                                        :src="
                                            similarproducts.product_default_image
                                        "
                                    />
                                    <img
                                        v-else
                                        :src="
                                            similarproducts.t_shirt_24_hour_image
                                        "
                                    />
                                </router-link>
                            </div>
                            <div class="product_content p-sm-0">
                                <h5 class="font_size_18">
                                    {{ similarproducts.product_number }}
                                </h5>
                                <p>
                                    {{
                                        similarproducts.Brand
                                            ? similarproducts.Brand.name
                                            : ""
                                    }}
                                </p>
                                <p>{{ similarproducts.name }}</p>
                                <p>
                                    <DisplayProductPrice
                                        :product="similarproducts"
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>

        <!-- Cart Conflict Warning Modal Component -->
        <CartConflictWarningModal
            :show="showCartConflictWarning"
            :cart-item="cartConflictItem"
            :product-name="product.name"
            :color-name="conflictColorName"
            :service-name="conflictServiceName"
            @cancel="cancelCartConflict"
            @proceed="proceedWithDesignAfterConflict"
        />
    </div>
</template>
<script>
import Fuse from "fuse.js";
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import DisplayProductPrice from "@/components/DisplayProductPriceNew";
import { SITE_URL } from "@/common/config";
import ImprintCityPriceBreakdown from "./components/ImprintCityPriceBreakdown.vue";
import PCNAPriceBreakdown from "./components/PCNAPriceBreakdown.vue";
import CartConflictWarningModal from "./components/CartConflictWarningModal.vue";
import {
    FETCH_DECORATION_PRICES,
    FETCH_DECORATION_TEMPLATE
} from "@/store/actions.type";
import { ecommDisplayNameMixin } from "@/common/ecommDisplayName.service";
import {
    isCapCategoryProduct,
    doesImageUrlContainHatTag,
    shouldApplyCapCategoryClass as shouldApplyCapCategoryClassService,
    shouldApplyCapCategoryClassStrict as shouldApplyCapCategoryClassStrictService
} from "@/common/capCategoryImage.service";
export default {
    name: "ProductDetails",
    mixins: [ecommDisplayNameMixin],
    metaInfo() {
        return {
            title: this.product ? this.product.name : "",
            titleTemplate: "%s | Imprintcity",
            meta: [
                {
                    vmid: "title",
                    name: "title",
                    content: this.product
                        ? `${this.product.name} | Imprintcity`
                        : ""
                },
                {
                    vmid: "description",
                    name: "description",
                    content:
                        this.product && this.product.description
                            ? this.product.description.replace(/<[^>]+>/g, "")
                            : ""
                },
                {
                    vmid: "keywords",
                    name: "keywords",
                    content: this.product ? this.product.keywords : ""
                }
            ]
        };
    },
    components: {
        DisplayProductPrice,
        PCNAPriceBreakdown,
        ImprintCityPriceBreakdown,
        CartConflictWarningModal
    },

    data() {
        return {
            croppieImage: "",
            image_width: "",
            images_name: "",
            image_height: "",
            preview_artwork_images: "",
            crop_image_validation: 0,
            image_size_validation: 0,
            temp_product_artwork: "",
            product_artwork: "",
            image_uploaded: null,
            uploadedImages: [],
            isHovering: false,
            isBusy: false,
            size_list: [],
            gender_age_list: [],
            imprint_colors_array_for_template: [],
            books: [
                {
                    author: "author 11",
                    title: "title 11"
                },
                {
                    author: "author 22",
                    title: "title 22"
                }
            ],
            default_imprint_colors: [
                {
                    id: 1,
                    value: "1-colors"
                },
                {
                    id: 2,
                    value: "2-colors"
                },
                {
                    id: 3,
                    value: "3-colors"
                },
                {
                    id: 4,
                    value: "4-colors"
                },
                {
                    id: 5,
                    value: "5-colors"
                },
                {
                    id: 6,
                    value: "6-colors"
                }
            ],
            imprintcityColors: [],
            imprint_locations: [],
            is_favorite_product: false,
            favorite_product: [],
            is_imprint_location: false,
            is_color_show_more: false,
            product: {},
            estimatedShipDate: "",
            rushOptionsVisible: false,
            rushOptions: [],
            selectedRushOptionId: null,
            vendorServices: [], // Store vendor services data for rush pricing
            holidays: [], // Store holidays list from API
            vendorStandardShippingDays: null, // Store vendor's standard_shipping_days for rush_package
            decoration_price_template_values: [],
            decoration_price_template_values_for_imprint: [],
            decoration_price_template_location2: [],
            product_color: [],
            is_active: false,
            is_active_bottom: false,
            qty: [],
            total_uantity: 0,
            total_cost: 0,
            companion_products: [],
            more_decoration_list: [],
            tier_list: [],
            hashcolor: [],
            color_size_qty: [],
            decoration_type: "",
            retail_price_without_price_template: 0,
            main_retail_price: 0,
            individual_cost: 0,
            option_value: false,
            productTypeName: "",
            productTypePath: "apparel",
            listConfig: {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                brandIds: [],
                gender_age_ids: [],
                searchKeyword: ""
            },
            temp_img: {},
            images: {
                thumbs: [
                    {
                        id: 1,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    },
                    {
                        id: 2,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    }
                ],
                normal_size: [
                    {
                        id: 1,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    },
                    {
                        id: 2,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    }
                ]
            },
            zoomerOptions: {
                zoomFactor: 3, // scale for zoomer
                pane: "pane", // three type of pane ['pane', 'container-round', 'container']
                hoverDelay: 300, // how long after the zoomer take effect
                namespace: "zoomer", // add a namespace for zoomer component, useful when on page have mutiple zoomer
                move_by_click: false, // move image by click thumb image or by mouseover
                scroll_items: 500, // thumbs for scroll
                choosed_thumb_border_color: "#bbdefb", // choosed thumb border color
                scroller_button_style: "line",
                scroller_position: "left",
                zoomer_pane_position: "right"
            },
            //gender groups
            gender_groups: [],
            groupedSizesByColors: [], //sizes grouped by color
            colors: [], //colors list from sub products
            sizesby_selected_color: [], //sizes list according to selected color
            selected_color: "",
            setup_fee: false,
            setup_fee_applied_gender_index: -1,
            design_fee: 0,
            cart_items: [],
            showCartConflictWarning: false,
            cartConflictItem: null,
            conflictColorName: "",
            conflictServiceName: "",
            proceedToDesignStudio: false,
            current_cart_quantity: 0,
            choose_imprint_locations: false,
            max_cart_count: 2000,
            error_message: "",
            all_quantity: 0,
            disable_btns: true,
            productLoadError: false,
            productErrorMessage: "",
            productUnavailable: false,
            temp_decoration_services: null,
            decoration_services: [],
            decoration_services_show: false,
            decoration_methods: [],
            print_templates_id: null,
            embroidery_template_ids: null,
            promotional_template_ids: null,
            decoration_method_template_ids: [],
            xl_has_quantity: false,
            site_url: "",
            current_product_type: null,
            same_artwork_cart_items: [],
            default_selected_color: null,
            start_designing_with: "scratch",
            minimum_quantity_decoration_fee: 0,
            print_areas: [],
            markup_tiers: [],
            is_tshirt_24_hour: false,
            total_decoration_colors_count: 0,
            per_color_setup_cost: 0,
            otherServices: [],
            currentBreakdown: {
                baseCost: 0,
                runCharge: 0,
                setupFee: 0,
                totalCost: 0,
                totalDiscount: 0,
                designFee: 0
            },
            // Patch selection & pricing state (Product Details)
            patchMaterials: [],
            patchesByMaterial: [],
            selectedPatchMaterialId: null,
            selectedPatchId: null,
            selectedPatchData: null,
            patchPricesLoaded: false,
            productPatchCost: 0,
            productPatchCostDetails: [],
            productPatchSlabQuantity: 0,
            productPatchCostWarning: "",
            patchInventory: []
        };
    },

    created() {
        const maxDimensionsRule = {
            getMessage(field, [width, height], data) {
                return (
                    (data && data.message) ||
                    `The ${field} field must be up to ${width} pixels by ${height} pixels.`
                );
            },
            validate(files, [width, height]) {
                const validateImage = (file, width, height) => {
                    const URL = window.URL || window.webkitURL;
                    return new Promise((resolve) => {
                        const image = new Image();
                        image.onerror = () => resolve({ valid: false });
                        image.onload = () =>
                            resolve({
                                valid:
                                    image.width <= Number(width) &&
                                    image.height <= Number(height) // only change from official rule
                            });

                        image.src = URL.createObjectURL(file);
                    });
                };
                const list = [];
                for (let i = 0; i < files.length; i++) {
                    // if file is not an image, reject.
                    if (!/\.(jpg|jpeg|png)$/i.test(files[i].name)) {
                        return false;
                    }
                    list.push(files[i]);
                }
                return Promise.all(
                    list.map((file) => validateImage(file, width, height))
                );
            }
        };

        this.$validator.extend("maxdimensions", maxDimensionsRule);
    },

    beforeMount() {
        this.is_tshirt_24_hour = this.$route.name == "24hoursTShirts";
    },

    mounted() {
        /* eslint-disable */
        $("#crop_btn").prop("disabled", true);
        $(".cr-slider").prop("disabled", true);
        document.body.classList.remove("bg_primary_light_white");
        var _this = this;

        _this.getSingleProductData();
        _this.getTiers();
        _this.activeLink(0);
        _this.fetchHolidays();

        if (this.isAuthenticatedClient) {
            _this.loadPatchInventory();
            // setTimeout(function () { _this.UploadedImages() }, 2000);
            _this.getCartItems();
        }
        $(document).on("hide.bs.modal", "#add-art-work", function () {
            _this.$validator.reset();
            _this.image_uploaded = null;
            if (_this.$refs.fileInput) {
                _this.$refs.fileInput.value = null;
            }
            //Do stuff here
        });
        /* eslint-enable */
        this.site_url = SITE_URL;
    },

    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "decorationPrices",
            "decorationTemplate",
            "printTemplates",
            "embroideryTemplates",
            "patchTemplates",
            "isAdminLoggedIn"
        ]),
        displayShipDate() {
            // Use dynamic rush options if available, otherwise fall back to static
            const options =
                this.dynamicRushOptions.length > 0
                    ? this.dynamicRushOptions
                    : this.rushOptions;
            const selected = options.find(
                (opt) => opt.id === this.selectedRushOptionId
            );

            // If a rush option is selected, use its estimated date (formatted as MM/DD/YYYY)
            if (selected) {
                // Use estimatedDate if available (from dynamicRushOptions)
                if (selected.estimatedDate) {
                    return this.formatRushDate(selected.estimatedDate);
                }
                // Fallback to shipDate if estimatedDate is not available
                if (selected.shipDate) {
                    return selected.shipDate;
                }
            }

            // If no rush option is selected, calculate date based on standard_shipping_days with holidays
            const standardShippingDays = this.vendorStandardShippingDays || 10; // Default to 10 if not set
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const estimatedDate = this.calculateEstimatedDateWithHolidays(
                today,
                standardShippingDays
            );
            return this.formatRushDate(estimatedDate);
        },
        isPreviewMode() {
            return this.$route.name === "product_details_preview";
        },
        sortedColors() {
            if (!this.colors || !this.colors.length) {
                return [];
            }
            return [...this.colors].sort((a, b) =>
                (a.color_name || "").localeCompare(b.color_name || "")
            );
        },
        activeDecorationService() {
            // ADD THIS COMPUTED PROPERTY
            if (
                !this.decoration_services ||
                this.decoration_services.length === 0
            ) {
                return null;
            }
            return this.decoration_services.find((s) => s.isActive);
        },
        activeServicePriceText() {
            const active = this.activeDecorationService;
            if (!active || !active.master_service) {
                return "";
            }
            const raw = active.master_service.service_price_text;
            if (raw == null) {
                return "";
            }
            const t = String(raw).trim();
            return t;
        },
        isPatchEnabledForActiveService() {
            const service = this.activeDecorationService;
            if (!service) return false;

            // OR condition: service name is "Patch Application" (case-insensitive)
            const serviceName = (
                (service.master_service && service.master_service.service_name) ||
                service.name ||
                ""
            ).trim().toLowerCase();
            if (serviceName === "patch application") return true;

            // Existing condition: Vendor + Product Apply Patch flags
            const productPatchEnabled =
                service.patch_enabled === true ||
                service.patch_enabled === 1 ||
                service.patch_enabled === "1" ||
                service.patch_enabled === "true";
            if (!productPatchEnabled) return false;
            const vs =
                this.vendorServices &&
                this.vendorServices.find(
                    (v) =>
                        v.id === service.id ||
                        v.service_id === (service.master_service && service.master_service.id)
                );
            const vendorPatchEnabled =
                vs &&
                (vs.vendor_patch_enabled === true ||
                    vs.vendor_patch_enabled === 1 ||
                    vs.vendor_patch_enabled === "1" ||
                    vs.vendor_patch_enabled === "true");
            return !!vendorPatchEnabled;
        },
        selectedPatchDimensions() {
            if (!this.selectedPatchData) return null;
            const h = this.selectedPatchData.height;
            const w = this.selectedPatchData.width;
            if (h && w) return w + '" * ' + h + '"';
            return null;
        },
        patchInventoryForProduct() {
            if (!this.patchInventory || this.patchInventory.length === 0) return [];
            return this.patchInventory.filter(inv => inv.remaining_quantity > 0);
        },
        patchPricePerTier() {
            if (!this.selectedPatchData || !this.selectedPatchData.prices || this.priceTableData.length === 0) return [];
            const prices = this.selectedPatchData.prices || [];
            return this.priceTableData.map((item) => {
                const slab = this.getSlabForQuantity(item.quantity);
                const match = prices.find((p) => parseInt(p.quantity) === slab);
                return {
                    quantity: item.quantity,
                    slab: slab,
                    net_price: match ? parseFloat(match.net_price) || 0 : 0,
                    retail_price: match ? parseFloat(match.retail_price) || 0 : 0,
                    has_price: !!match
                };
            });
        },
        isProductAvailable() {
            // Check if product is available (not in error state)
            return !this.productLoadError && !this.productUnavailable;
        },
        shouldDisableActions() {
            // Disable actions if product is unavailable, has errors, or no quantity selected
            return (
                this.disable_btns ||
                this.productLoadError ||
                this.productUnavailable
            );
        },
        dynamicRushOptions() {
            // Return empty array if no active service
            if (!this.activeDecorationService) {
                return [];
            }

            const activeService = this.activeDecorationService;
            const rushOptions = [];

            // Get rush flags from the service in decoration_type_list
            // We need to get this from the original product decorations structure
            let serviceRushFlags = null;
            if (this.product && this.product.decorations) {
                try {
                    // Handle both string and already-parsed decorations
                    let decorations = this.product.decorations;
                    if (typeof decorations === "string") {
                        decorations = JSON.parse(decorations);
                    }

                    if (
                        decorations &&
                        decorations.length > 0 &&
                        decorations[0].decoration_type_list
                    ) {
                        const serviceInList =
                            decorations[0].decoration_type_list.find(
                                (s) => s.id === activeService.id
                            );
                        if (serviceInList) {
                            serviceRushFlags = {
                                rush1:
                                    serviceInList.rush1 === true ||
                                    serviceInList.rush1 === 1,
                                rush3:
                                    serviceInList.rush3 === true ||
                                    serviceInList.rush3 === 1,
                                rush5:
                                    serviceInList.rush5 === true ||
                                    serviceInList.rush5 === 1,
                                rush7:
                                    serviceInList.rush7 === true ||
                                    serviceInList.rush7 === 1,
                                rush_package:
                                    serviceInList.rush_package === true ||
                                    serviceInList.rush_package === 1
                            };
                        }
                    }
                } catch (e) {
                    console.error("Error parsing decorations:", e);
                }
            }

            // If no rush flags found, return empty array
            if (!serviceRushFlags) {
                return [];
            }

            // Find vendor service for pricing
            const vendorService = this.vendorServices.find(
                (vs) => vs.id === activeService.id
            );

            // Base date is today
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            // Rush 1 Day
            if (serviceRushFlags.rush1) {
                const price = vendorService
                    ? parseFloat(vendorService.rush1 || 0)
                    : 0;
                const estimatedDate = this.calculateEstimatedDateWithHolidays(
                    today,
                    1
                );
                rushOptions.push({
                    id: "rush1",
                    label: "Rush 1 Day",
                    price: price,
                    shipDate: this.formatRushDateForDisplay(estimatedDate),
                    estimatedDate: estimatedDate
                });
            }

            // Rush 3 Days
            if (serviceRushFlags.rush3) {
                const price = vendorService
                    ? parseFloat(vendorService.rush3 || 0)
                    : 0;
                const estimatedDate = this.calculateEstimatedDateWithHolidays(
                    today,
                    3
                );
                rushOptions.push({
                    id: "rush3",
                    label: "Rush 3 Day",
                    price: price,
                    shipDate: this.formatRushDateForDisplay(estimatedDate),
                    estimatedDate: estimatedDate
                });
            }

            // Rush 5 Days
            if (serviceRushFlags.rush5) {
                const price = vendorService
                    ? parseFloat(vendorService.rush5 || 0)
                    : 0;
                const estimatedDate = this.calculateEstimatedDateWithHolidays(
                    today,
                    5
                );
                rushOptions.push({
                    id: "rush5",
                    label: "Rush 5 Day",
                    price: price,
                    shipDate: this.formatRushDateForDisplay(estimatedDate),
                    estimatedDate: estimatedDate
                });
            }

            // Rush 7 Days
            if (serviceRushFlags.rush7) {
                const price = vendorService
                    ? parseFloat(vendorService.rush7 || 0)
                    : 0;
                const estimatedDate = this.calculateEstimatedDateWithHolidays(
                    today,
                    7
                );
                rushOptions.push({
                    id: "rush7",
                    label: "Rush 7 Day",
                    price: price,
                    shipDate: this.formatRushDateForDisplay(estimatedDate),
                    estimatedDate: estimatedDate
                });
            }

            // Rush Package
            if (serviceRushFlags.rush_package) {
                const price = vendorService
                    ? parseFloat(vendorService.rush_package || 0)
                    : 0;
                // Rush package ships the next day after order (considering holidays)
                const estimatedDate = this.calculateEstimatedDateWithHolidays(
                    today,
                    1
                );
                rushOptions.push({
                    id: "rush_package",
                    label: "Rush Package",
                    price: price,
                    shipDate: this.formatRushDateForDisplay(estimatedDate),
                    estimatedDate: estimatedDate
                });
            }

            return rushOptions;
        },
        // Sort decoration services: default service first, then by service name
        sortedDecorationServices() {
            if (
                !this.decoration_services ||
                this.decoration_services.length === 0
            ) {
                return [];
            }
            // Create a copy to avoid mutating the original array
            const sorted = [...this.decoration_services];
            sorted.sort((a, b) => {
                const aIsDefault =
                    a.is_default === true ||
                    a.is_default === 1 ||
                    a.is_default === "1";
                const bIsDefault =
                    b.is_default === true ||
                    b.is_default === 1 ||
                    b.is_default === "1";

                // If one is default and the other isn't, default comes first
                if (aIsDefault && !bIsDefault) return -1;
                if (!aIsDefault && bIsDefault) return 1;

                // If both are default or both are not, sort by service name
                const aName = a.name || "";
                const bName = b.name || "";
                return aName.localeCompare(bName);
            });
            return sorted;
        },
        minimumOrderQuantity() {
            // Get first quantity from price_decoration_bulk
            if (
                !this.activeDecorationService ||
                !this.activeDecorationService.price_decoration_bulk
            ) {
                // Fallback to default values if no price data
                if (
                    this.product.decoration_type === 0 ||
                    this.product.decoration_type === 1
                ) {
                    return 12;
                } else if (this.product.decoration_type === 2 || this.product.decoration_type === 4) {
                    return 1;
                }
                return 12;
            }

            const service = this.activeDecorationService;
            let priceData;
            let firstQuantity = null;

            if (service.use_imprintcity_price_template === 0) {
                // New PCNA pricing structure
                priceData = service.price_decoration_bulk;
                if (Array.isArray(priceData) && priceData.length > 0) {
                    firstQuantity = priceData[0].quantity;
                }
            } else {
                // Old Imprint City template pricing structure
                const isPrint =
                    this.decoration_type == 1 || this.decoration_type == 5;

                if (isPrint) {
                    priceData = Array.isArray(service.price_decoration_bulk)
                        ? service.price_decoration_bulk
                        : service.price_decoration_bulk.print_location1;
                } else {
                    // Embroidery
                    priceData = service.price_decoration_bulk;
                }

                if (Array.isArray(priceData) && priceData.length > 0) {
                    firstQuantity =
                        priceData[0].quantity || priceData[0].quantity1;
                }
            }

            // Return the first quantity if found, otherwise fallback to defaults
            if (firstQuantity !== null && firstQuantity !== undefined) {
                return firstQuantity;
            }

            // Fallback to default values
            if (
                this.product.decoration_type === 0 ||
                this.product.decoration_type === 1
            ) {
                return 12;
            } else if (this.product.decoration_type === 2 || this.product.decoration_type === 4) {
                return 1;
            }
            return 12;
        },
        activeProductDiscount() {
            const discount = this.product.MainNewProductDiscount;

            // Return null if there's no discount or its status is inactive
            if (!discount || !discount.status) {
                return null;
            }

            const today = new Date();
            // Set time to the beginning of the day for a consistent date-only comparison
            today.setHours(0, 0, 0, 0);

            // Check if the discount has a start date and if it has already started
            if (discount.start_date) {
                const startDate = new Date(discount.start_date);
                startDate.setHours(0, 0, 0, 0); // Normalize to start of day for accurate comparison
                if (today < startDate) {
                    return null; // Discount hasn't started yet
                }
            }

            // Check if the discount has an end date and if it has expired
            if (discount.end_date) {
                const endDate = new Date(discount.end_date);
                endDate.setHours(23, 59, 59, 999); // Normalize to end of day for accurate comparison
                if (today > endDate) {
                    return null; // Discount has expired
                }
            }

            // If all checks pass, the discount is active
            return discount;
        },
        activeProductDiscountEndDate() {
            if (!this.activeProductDiscount || !this.activeProductDiscount.end_date) {
                return "";
            }

            const endDate = new Date(this.activeProductDiscount.end_date);
            const month = endDate.toLocaleDateString("en-US", {
                month: "long"
            });
            const day = endDate.getDate();
            let suffix = "th";
            if (day <= 3 || day >= 21) {
                const mod = day % 10;
                if (mod === 1) suffix = "st";
                else if (mod === 2) suffix = "nd";
                else if (mod === 3) suffix = "rd";
            }
            return `${month} ${day}${suffix}`;
        },

        priceTableData() {
            if (
                !this.activeDecorationService ||
                !this.activeDecorationService.price_decoration_bulk
            ) {
                return [];
            }

            const service = this.activeDecorationService;
            let priceData;

            if (service.use_imprintcity_price_template === 0) {
                priceData = service.price_decoration_bulk;
                if (
                    !priceData ||
                    !Array.isArray(priceData) ||
                    priceData.length === 0
                ) {
                    return [];
                }
                let useRetailEqp = false;
                if (
                    this.product &&
                    this.product.Decorators &&
                    this.product.default_decorator_id
                ) {
                    const defaultDecorator = this.product.Decorators.find(
                        (decorator) =>
                            decorator.id === this.product.default_decorator_id
                    );

                    if (defaultDecorator) {
                        useRetailEqp = defaultDecorator.use_retail_eqp;
                    }
                }

                // Helper function to calculate on_sale_price
                const calculateOnSalePrice = (retailCost) => {
                    const activeDiscount = this.activeProductDiscount;
                    if (!activeDiscount || !activeDiscount.status) {
                        return null;
                    }
                    const discountType = activeDiscount.discount_type;
                    const discountValue = parseFloat(
                        activeDiscount.discount_value || 0
                    );
                    if (discountType === "Percent") {
                        return parseFloat(
                            (retailCost * (1 - discountValue / 100)).toFixed(2)
                        );
                    } else {
                        // Fixed amount discount
                        return parseFloat(
                            Math.max(0, retailCost - discountValue).toFixed(2)
                        );
                    }
                };

                if (useRetailEqp) {
                    const lastTier = priceData[priceData.length - 1];
                    const retailCost = parseFloat(lastTier.retail_cost || 0);
                    const discount = parseFloat(lastTier.discount || 0);
                    const finalNetCost = retailCost * (1 - discount / 100);

                    return priceData.map((item) => {
                        const itemRetailCost = parseFloat(
                            item.retail_cost || 0
                        );
                        return {
                            quantity: item.quantity,
                            retail_cost: itemRetailCost,
                            net_cost: finalNetCost,
                            on_sale_price: calculateOnSalePrice(itemRetailCost)
                        };
                    });
                } else {
                    return priceData.map((item) => {
                        const retail = parseFloat(item.retail_cost || 0);
                        const discount = parseFloat(item.discount || 0);
                        const net = retail * (1 - discount / 100);
                        return {
                            quantity: item.quantity,
                            retail_cost: retail,
                            net_cost: net,
                            on_sale_price: calculateOnSalePrice(retail)
                        };
                    });
                }
            } else {
                const isPrint = this.decoration_type == 1 || this.decoration_type == 5;

                if (isPrint) {
                    priceData = Array.isArray(service.price_decoration_bulk)
                        ? service.price_decoration_bulk
                        : service.price_decoration_bulk.print_location1;
                } else {
                    // Embroidery
                    priceData = service.price_decoration_bulk;
                }

                if (!priceData || !Array.isArray(priceData)) return [];

                // Helper function to calculate on_sale_price
                const calculateOnSalePrice = (retailCost) => {
                    const activeDiscount = this.activeProductDiscount;
                    if (!activeDiscount || !activeDiscount.status) {
                        return null;
                    }
                    const discountType = activeDiscount.discount_type;
                    const discountValue = parseFloat(
                        activeDiscount.discount_value || 0
                    );
                    if (discountType === "Percent") {
                        return parseFloat(
                            (retailCost * (1 - discountValue / 100)).toFixed(2)
                        );
                    } else {
                        // Fixed amount discount
                        return parseFloat(
                            Math.max(0, retailCost - discountValue).toFixed(2)
                        );
                    }
                };

                return priceData.map((item) => {
                    const quantity = item.quantity || item.quantity1;
                    const decoration_cost = parseFloat(
                        item.cost || item.colour1 || 0
                    );
                    const decoration_discount_percent = parseFloat(
                        item.discount || 0
                    );
                    // OLD BEHAVIOR (kept for future rollback):
                    // Template discount was applied directly on single-location decoration cost.
                    // const decoration_discount_amount =
                    //     (decoration_cost * decoration_discount_percent) / 100;
                    // const discounted_decoration_cost =
                    //     decoration_cost - decoration_discount_amount;

                    const basePriceForMarkup = parseFloat(
                        (this.default_selected_color &&
                            this.default_selected_color.price_base) ||
                            this.product.price_base ||
                            0
                    );
                    const markup_percentage =
                        this.getResolvedMarkupPercentage(
                            basePriceForMarkup,
                            this.product.decoration_type,
                            this.product.decoration_price_template,
                            service.markup_percentage
                        );
                    let markup_value = parseFloat(((basePriceForMarkup * parseFloat(markup_percentage)) /
                        100).toFixed(2));

                    const color_category_price = this.getDarkLightFees(
                        this.default_selected_color
                    );

                    // Build Product Base Price first, then apply template discount on that full base.
                    // This aligns with UseImprintCalculator behavior for decoration types 1/2/4.
                    let final_retail_cost =
                        basePriceForMarkup +
                        markup_value +
                        decoration_cost +
                        color_category_price;

                    let net_cost =
                        basePriceForMarkup +
                        decoration_cost +
                        color_category_price;

                    const decorationType = parseInt(
                        this.product.decoration_type
                    );
                    if (
                        (decorationType === 1 ||
                            decorationType === 2 ||
                            decorationType === 4) || decorationType === 5 &&
                        decoration_discount_percent > 0
                    ) {
                        final_retail_cost =
                            final_retail_cost *
                            (1 - decoration_discount_percent / 100);
                        net_cost =
                            net_cost * (1 - decoration_discount_percent / 100);
                    }

                    return {
                        quantity: quantity,
                        retail_cost: final_retail_cost,
                        net_cost: net_cost,
                        on_sale_price: calculateOnSalePrice(final_retail_cost)
                    };
                });
            }
        }
    },
    methods: {
        isCapCategoryProduct() {
            const categoryId =
                this.product && this.product.category_id
                    ? this.product.category_id
                    : null;
            return isCapCategoryProduct(categoryId);
        },
        doesImageUrlContainHatTag(imageUrl) {
            return doesImageUrlContainHatTag(imageUrl);
        },
        shouldApplyCapCategoryClass(imageUrl) {
            const categoryId =
                this.product && this.product.category_id
                    ? this.product.category_id
                    : null;
            return shouldApplyCapCategoryClassService(categoryId, imageUrl);
        },
        shouldApplyCapCategoryClassStrict(imageUrl) {
            const categoryId =
                this.product && this.product.category_id
                    ? this.product.category_id
                    : null;
            return shouldApplyCapCategoryClassStrictService(categoryId, imageUrl);
        },
        getPrimaryImageUrlForCapClass() {
            if (!this.images || !Array.isArray(this.images.normal_size)) return "";
            const firstImage = this.images.normal_size.find(
                (img) => img && img.type === "image" && img.url
            );
            return firstImage ? firstImage.url : "";
        },
        /** Vendor row for a decoration service (vendorServices is fresh before this.product updates). */
        resolveVendorDecorationServiceRow(serviceLike) {
            const vds =
                Array.isArray(this.vendorServices) &&
                this.vendorServices.length > 0
                    ? this.vendorServices
                    : (this.product && this.product.VendorDecorationServices) ||
                      [];
            if (!serviceLike || !vds.length) return null;
            const findRow = (pred) => vds.find(pred) || null;

            let row = findRow((vs) => vs.id == serviceLike.id);
            if (row) return row;

            const ms = serviceLike.master_service;
            if (ms) {
                row = findRow((vs) => vs.id == ms.id);
                if (row) return row;
                const mids = [
                    ms.master_service_id,
                    ms.service_id,
                    ms.id
                ].filter((x) => x != null);
                for (let i = 0; i < mids.length; i++) {
                    const mid = mids[i];
                    row =
                        findRow((vs) => vs.service_id == mid) ||
                        findRow((vs) => vs.master_service_id == mid);
                    if (row) return row;
                }
            }
            return null;
        },
        // ========== Patch Selection & Pricing Methods ==========
        getSlabForQuantity(qty) {
            const slabs = [50, 100, 250, 500, 1000, 2500, 5000];
            const n = parseInt(qty, 10) || 0;
            const found = slabs.find((s) => s >= n);
            return found != null ? found : slabs[slabs.length - 1];
        },
        async loadPatchMaterials() {
            try {
                const { data } = await ApiService.get("/all-designStudioPatchMaterials");
                this.patchMaterials = (data.material_list && data.material_list.rows) || data.material_list || [];
            } catch (e) {
                console.warn("Failed to load patch materials", e);
                this.patchMaterials = [];
            }
        },
        async loadPatchesByMaterial(materialId) {
            if (!materialId) {
                this.patchesByMaterial = [];
                return;
            }
            try {
                const { data } = await ApiService.get("/all-patches-with-prices?material_id=" + materialId);
                this.patchesByMaterial = data.patches || [];
            } catch (e) {
                console.warn("Failed to load patches for material " + materialId, e);
                this.patchesByMaterial = [];
            }
        },
        onPatchMaterialChange() {
            this.selectedPatchId = null;
            this.selectedPatchData = null;
            this.resetProductPatchCost();
            if (this.selectedPatchMaterialId) {
                this.loadPatchesByMaterial(this.selectedPatchMaterialId);
            } else {
                this.patchesByMaterial = [];
            }
        },
         onPatchNameChange() {
            if (!this.selectedPatchId) {
                this.selectedPatchData = null;
                this.resetProductPatchCost();
                return;
            }
            const patch = this.patchesByMaterial.find((p) => p.id === this.selectedPatchId);
            this.selectedPatchData = patch || null;
            this.calculateProductPatchCost();
        },
        resetProductPatchCost() {
            this.productPatchCost = 0;
            this.productPatchCostDetails = [];
            this.productPatchSlabQuantity = 0;
            this.productPatchCostWarning = "";
        },
        calculateProductPatchCost() {
            if (!this.selectedPatchData || !this.selectedPatchData.prices) {
                this.resetProductPatchCost();
                return;
            }
            let totalQty = 0;
            if (this.gender_groups && this.gender_groups.length > 0) {
                this.gender_groups.forEach((g) => {
                    totalQty += (g.total_qty_gender_wise || 0);
                });
            }
            const slab = this.getSlabForQuantity(totalQty);
            this.productPatchSlabQuantity = slab;
            if (totalQty > 0 && totalQty < 50) {
                this.productPatchCostWarning = "Minimum 50 patches are required for the selected product.";
            } else {
                this.productPatchCostWarning = "";
            }
            const prices = this.selectedPatchData.prices || [];
            const match = prices.find((p) => parseInt(p.quantity) === slab);
            const perPatchRetail = match ? parseFloat(match.retail_price) || 0 : 0;
            const perPatchNet = match ? parseFloat(match.net_price) || 0 : 0;
            const patchId = this.selectedPatchId ? parseInt(this.selectedPatchId, 10) : 0;
            const materialId = this.selectedPatchMaterialId ? parseInt(this.selectedPatchMaterialId, 10) : 0;
            const selectedMaterial = (this.patchMaterials || []).find(
                (mat) => parseInt(mat.id, 10) === materialId
            );
            let available = 0;
            (this.patchInventoryForProduct || []).forEach((inv) => {
                if (
                    inv.patch_id === patchId &&
                    inv.patch_material_id === materialId
                ) {
                    available += parseInt(inv.remaining_quantity || 0, 10);
                }
            });

            // New rule:
            // If inventory covers product qty, no slab charging.
            const inventorySufficient = totalQty <= available;
            const inventoryUsed = inventorySufficient ? totalQty : available;
            const billableQty = totalQty > 0 ? Math.max(totalQty, 50) : 0;
            const chargedQty = inventorySufficient
                ? 0
                : Math.max(0, billableQty - inventoryUsed);
            const total = perPatchRetail * chargedQty;
            const patchName = this.selectedPatchData.image_name || "Patch";
            this.productPatchCost = parseFloat(total.toFixed(2));
            this.productPatchCostDetails = [{
                patchName: patchName,
                materialName: selectedMaterial && selectedMaterial.name ? selectedMaterial.name : "",
                width: this.selectedPatchData.width || null,
                height: this.selectedPatchData.height || null,
                slab: slab,
                quantity: totalQty,
                perPatchPrice: perPatchRetail,
                perPatchNetPrice: perPatchNet,
                total: total,
                patch_id: patchId,
                material_id: materialId,
                inventory_used: inventoryUsed,
                charged_quantity: chargedQty
            }];
        },
        loadPatchInventory() {
            ApiService.get("/my-patch-inventory")
                .then(({ data }) => {
                    this.patchInventory = data.inventory || [];
                })
                .catch(() => {
                    this.patchInventory = [];
                });
        },
        clearPatchSelection() {
            this.selectedPatchMaterialId = null;
            this.selectedPatchId = null;
            this.selectedPatchData = null;
            this.patchesByMaterial = [];
            this.resetProductPatchCost();
        },
        goToPatchApplicationDetail() {
            if (!this.activeDecorationService) {
                this.$toast.error("Active decoration service is required.");
                return;
            }

            if (!this.activeDecorationService.master_service) {
                this.$toast.error("Master service details are required.");
                return;
            }

            const masterServiceId = this.activeDecorationService.master_service.service_id;
            if (!masterServiceId) {
                this.$toast.error("Patch Application master service id is required.");
                return;
            }

            const serviceName = this.activeDecorationService.master_service.service_name;
            if (!serviceName) {
                this.$toast.error("Patch Application service name is required.");
                return;
            }

            if (String(serviceName).trim().toLowerCase() !== "patch application") {
                this.$toast.error("Selected decoration service must be Patch Application.");
                return;
            }

            const routeData = this.$router.resolve({
                name: "DecorationServiceDetail",
                params: { id: masterServiceId }
            });
            window.open(routeData.href, "_blank");
        },
        // ========== End Patch Methods ==========

        async initializeRushOptions(product) {
            // Set base estimated ship date
            const baseDateString =
                (product &&
                    (product.estimated_ship_date ||
                        product.estimated_ship ||
                        product.ship_date)) ||
                null;
            const baseDate = baseDateString
                ? new Date(baseDateString)
                : this.addDays(new Date(), 7);

            this.estimatedShipDate = this.formatRushDate(baseDate);
            this.selectedRushOptionId = null;

            // Extract vendor services from product.VendorDecorationServices
            if (product && product.VendorDecorationServices) {
                this.vendorServices = product.VendorDecorationServices;
            } else {
                this.vendorServices = [];
            }

            // Extract vendor standard_shipping_days from product.Vendor
            if (product && product.Vendor) {
                this.vendorStandardShippingDays =
                    product.Vendor.standard_shipping_days || null;
            } else {
                this.vendorStandardShippingDays = null;
            }

            // Rush options will be computed dynamically via computed property
            // This method now just initializes the base state
        },
        async fetchHolidays() {
            try {
                const { data } = await ApiService.get("/get-socialLinks");
                const holidaysLink =
                    data.links &&
                    data.links.find((link) => link.option_key === "holidays");

                if (holidaysLink && holidaysLink.option_value) {
                    try {
                        this.holidays = JSON.parse(holidaysLink.option_value);
                    } catch (e) {
                        console.error("Error parsing holidays:", e);
                        this.holidays = [];
                    }
                } else {
                    this.holidays = [];
                }
            } catch (error) {
                console.error("Error fetching holidays:", error);
                this.holidays = [];
            }
        },
        // calculateEstimatedDateWithHolidays(baseDate, daysToAdd) {
        //     // Start from base date (today)
        //     let currentDate = new Date(baseDate);
        //     currentDate.setHours(0, 0, 0, 0);
        //     let daysAdded = 0;

        //     // Convert holidays to Date objects for comparison
        //     const holidayDates = this.holidays.map((h) => {
        //         const d = new Date(h);
        //         d.setHours(0, 0, 0, 0);
        //         return d;
        //     });

        //     // Add days one by one, skipping holidays
        //     while (daysAdded < daysToAdd) {
        //         currentDate.setDate(currentDate.getDate() + 1);

        //         // Check if current date is a holiday
        //         const currentDateOnly = new Date(currentDate);
        //         currentDateOnly.setHours(0, 0, 0, 0);

        //         const isHoliday = holidayDates.some((h) => {
        //             return h.getTime() === currentDateOnly.getTime();
        //         });

        //         // Only count non-holiday days
        //         if (!isHoliday) {
        //             daysAdded++;
        //         }
        //         // If it's a holiday, we just continue to the next day without incrementing daysAdded
        //     }

        //     // Ensure final date is not a holiday (add extra days if needed)
        //     let finalDateOnly = new Date(currentDate);
        //     finalDateOnly.setHours(0, 0, 0, 0);
        //     while (
        //         holidayDates.some(
        //             (h) => h.getTime() === finalDateOnly.getTime()
        //         )
        //     ) {
        //         currentDate.setDate(currentDate.getDate() + 1);
        //         finalDateOnly = new Date(currentDate);
        //         finalDateOnly.setHours(0, 0, 0, 0);
        //     }

        //     return currentDate;
        // },
       calculateEstimatedDateWithHolidays(baseDate, daysToAdd) {
            // Helper: get YYYY-MM-DD date string in New York timezone
            // This makes holiday comparison universal across all timezones
            var toNYDateString = function(date) {
                return new Intl.DateTimeFormat("en-CA", {
                    timeZone: "America/New_York",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                }).format(date);
            };

            // Build a Set of NY holiday date strings
            // API returns "YYYY-MM-DD" strings — treat them as NY calendar dates directly
            // (no Date parsing needed, avoids UTC-shift problem entirely)
            var holidaySet = new Set(
                this.holidays.map(function(h) {
                    if (typeof h === "string" && /^\d{4}-\d{2}-\d{2}$/.test(h)) {
                        return h; // Already a NY calendar date string, use as-is
                    }
                    return toNYDateString(new Date(h)); // Fallback for other formats
                })
            );

            // Start from base date
            var currentDate = new Date(baseDate);
            var daysAdded = 0;

            // Add days one by one, skipping holidays (compared in NY timezone)
            while (daysAdded < daysToAdd) {
                currentDate.setDate(currentDate.getDate() + 1);
                if (!holidaySet.has(toNYDateString(currentDate))) {
                    daysAdded++;
                }
            }

            // Ensure final date is not a holiday (push forward if needed)
            while (holidaySet.has(toNYDateString(currentDate))) {
                currentDate.setDate(currentDate.getDate() + 1);
            }

            return currentDate;
        },

  
        formatRushDateForDisplay(date) {
            if (!date) return "--";
            const d = new Date(date);
            const monthNames = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ];
            const month = monthNames[d.getMonth()];
            const day = d.getDate();
            const year = d.getFullYear();
            return `${month} ${day}, ${year}`;
        },
        toggleRushOptions() {
            this.rushOptionsVisible = !this.rushOptionsVisible;
        },
        selectRushOption(option) {
            this.selectedRushOptionId = option.id;
        },
        addDays(date, days) {
            const result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        },
        formatRushDate(date) {
            if (!date) return "--";
            const d = new Date(date);
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            const yyyy = d.getFullYear();
            return `${mm}/${dd}/${yyyy}`;
        },
        // Prepare color-size combinations array for price breakdown
        getColorSizeCombinations(gender) {
            if (
                !gender ||
                !gender.selected_colors ||
                !Array.isArray(gender.selected_colors)
            ) {
                return [];
            }

            const combinations = [];

            gender.selected_colors.forEach((color) => {
                if (!color.unique_sizes || !Array.isArray(color.unique_sizes)) {
                    return;
                }

                color.unique_sizes.forEach((size) => {
                    // Only include sizes with quantity > 0
                    if (size.quantity && parseInt(size.quantity) > 0) {
                        // Extract only size abbreviation (XS, S, M, L, XL, etc.)
                        let sizeAbbr = "N/A";
                        if (size.Size && size.Size.size) {
                            sizeAbbr = size.Size.size;
                        } else if (size.size) {
                            // If size contains full product name, extract last word (size abbreviation)
                            const sizeParts = size.size.trim().split(/\s+/);
                            sizeAbbr = sizeParts[sizeParts.length - 1];
                        } else if (size.name) {
                            // If name contains full product name, extract last word (size abbreviation)
                            const nameParts = size.name.trim().split(/\s+/);
                            sizeAbbr = nameParts[nameParts.length - 1];
                        }

                        // Get color value and ensure it has # prefix
                        // Try multiple possible property names: color_value, hex, hash
                        let colorValue =
                            color.color_value || color.hex || color.hash || "";
                        if (colorValue && !colorValue.startsWith("#")) {
                            colorValue = "#" + colorValue;
                        }
                        if (!colorValue) {
                            colorValue = "#cccccc";
                        }

                        combinations.push({
                            color_id: color.id || color.color_id,
                            color_name:
                                color.name || color.color_name || "Color",
                            color_value: colorValue,
                            hex: colorValue,
                            size: sizeAbbr,
                            quantity: parseInt(size.quantity) || 0,
                            cost: parseFloat(size.cost) || 0,
                            total_cost: parseFloat(size.total_cost) || 0
                        });
                    }
                });
            });

            return combinations;
        },
        filterOtherServices() {
            if (!this.product || !this.product.VendorOtherServices) {
                this.otherServices = [];
                return;
            }

            // Get selected service IDs from active decoration service
            const activeService = this.activeDecorationService;
            let applicableServiceIds = [];
            if (
                activeService &&
                activeService.other_services_list &&
                Array.isArray(activeService.other_services_list)
            ) {
                applicableServiceIds = activeService.other_services_list.map(
                    (s) => s.id
                );
            }

            // Filter services to include:
            // 1. Selected services (from other_services_list)
            // 2. Services whose fee structure is NOT "per item" and NOT "per product"
            const filteredServices = this.product.VendorOtherServices.filter(
                (service) => {
                    // Always include if it's in the selected services
                    if (applicableServiceIds.includes(service.id)) {
                        return true;
                    }

                    // Check fee structure - include if NOT "per item" and NOT "per product"
                    const feeStructureName = service.fee_structure;
                    if (feeStructureName) {
                        const name = String(feeStructureName)
                            .toLowerCase()
                            .trim();
                        // Exclude "per item" and "per product" fee structures
                        if (name === "per item" || name === "per product") {
                            return false;
                        }
                    }

                    // Include all other services (those without "per item" or "per product" fee structure)
                    return true;
                }
            );
            this.otherServices = filteredServices;
        },
        /**
         * Update product error status in database
         * Called when product fails to load or has data issues
         */
        async updateProductErrorStatusInDB(errorMessage) {
            try {
                const productId = this.$route.params.id_of_product;

                if (!productId) {
                    console.error(
                        "Cannot update error status: Product ID not found"
                    );
                    return;
                }

                // Don't call API if product is already disabled
                if (this.product && this.product.status === "Disabled") {
                    console.log(
                        `Product ${productId} is already disabled. Skipping API call.`
                    );
                    return;
                }

                // Call API to update product status to Disabled
                await ApiService.post(
                    "/main-new-products/update-error-status",
                    {
                        product_id: productId,
                        error_message: errorMessage
                    }
                );

                console.log(`Product ${productId} marked as disabled`);
            } catch (error) {
                // Silent fail - don't show error to user since they already see the product error
                console.error(
                    "Failed to update product error status in database:",
                    error
                );
            }
        },

        getPrintArea(product_type_id, design_areas = null) {
            let _this = this;
            _this.isBusy = true;

            // Use design_areas directly from product JSON (no API call needed)
            return new Promise((resolve, reject) => {
                try {
                    // If design_areas is provided, use it directly
                    if (design_areas) {
                        let parsed_design_areas = design_areas;
                        if (typeof design_areas === "string") {
                            parsed_design_areas = JSON.parse(design_areas);
                        }

                        // Set print_areas from design_areas JSON
                        if (Array.isArray(parsed_design_areas)) {
                            _this.print_areas = parsed_design_areas.filter(
                                (area) => area && area.selected !== false
                            );
                        } else if (
                            typeof parsed_design_areas === "object" &&
                            parsed_design_areas !== null
                        ) {
                            _this.print_areas = Object.values(
                                parsed_design_areas
                            ).filter((area) => area && area.selected !== false);
                        } else {
                            _this.print_areas = [];
                        }

                        _this.isBusy = false;
                        resolve({
                            success: true,
                            print_areas: _this.print_areas
                        });
                        return;
                    }

                    // Fallback: If design_areas not provided and product_type_id is null, return empty
                    if (!product_type_id) {
                        _this.print_areas = [];
                        _this.isBusy = false;
                        resolve({ success: true, print_areas: [] });
                        return;
                    }

                    // Fallback to API only if design_areas not available (shouldn't happen normally)
                    ApiService.get("/product-types/" + product_type_id)
                        .then(({ data }) => {
                            if (data.product_type.canvas_design_areas) {
                                _this.print_areas = JSON.parse(
                                    data.product_type.canvas_design_areas
                                );
                            }
                            _this.isBusy = false;
                            resolve(data);
                        })
                        .catch(({ response }) => {
                            console.log(response);
                            _this.isBusy = false;
                            reject(response);
                        });
                } catch (error) {
                    console.error("Error parsing design_areas:", error);
                    _this.print_areas = [];
                    _this.isBusy = false;
                    reject(error);
                }
            });
        },
        getSingleProductData() {
            var _this = this;
            _this.isBusy = true;
            _this.productLoadError = false;
            _this.productErrorMessage = "";
            _this.productUnavailable = false;

            new Promise(() => {
                ApiService.get(
                    "/home-single-newproduct-new/" +
                        this.$route.params.id_of_product
                )
                    .then(async ({ data }) => {
                        try {
                            if (data.success == true && data.product != null) {
                                await this.getAllMarkupTiers();
                                await this.getDecorationMethods();

                                if (
                                    data.product.design_areas &&
                                    JSON.parse(data.product.design_areas)
                                        .length > 0
                                ) {
                                    // Pass design_areas directly to getPrintArea (no API call needed)
                                    await this.getPrintArea(
                                        data.product.product_type_id,
                                        data.product.design_areas
                                    );
                                    this.resetImprintLocations(
                                        JSON.parse(data.product.design_areas)
                                    );
                                }

                                _this.decoration_services_show = true;

                                // IMPORTANT: Set vendorServices BEFORE parsing decorations JSON
                                // This is needed for is_full_color check which requires vendor service fee_structure
                                if (
                                    data.product &&
                                    data.product.VendorDecorationServices
                                ) {
                                    _this.vendorServices =
                                        data.product.VendorDecorationServices;
                                } else {
                                    _this.vendorServices = [];
                                }

                                let decorations = JSON.parse(
                                    data.product.decorations
                                );
                                _this.decoration_services = [];
                                // Check if the new structure exists
                                if (
                                    decorations &&
                                    decorations.length > 0 &&
                                    decorations[0].decoration_type_list
                                ) {
                                    // Find the default service object first
                                    const defaultService =
                                        decorations[0].decoration_type_list.find(
                                            function (service) {
                                                // Correctly check if the service's ID matches the is_default value
                                                return (
                                                    service.is_default === 1 ||
                                                    service.is_default ===
                                                        true ||
                                                    service.is_default === "1"
                                                );
                                            }
                                        );
                                    // Then, safely get its ID only if it was found
                                    const defaultServiceId = defaultService
                                        ? defaultService.id
                                        : null;

                                    decorations[0].decoration_type_list.forEach(
                                        function (service) {
                                            // Skip services that are inactive in VendorDecorationServices
                                            const vendorServiceMatch =
                                                _this.resolveVendorDecorationServiceRow(
                                                    service
                                                );
                                            if (
                                                vendorServiceMatch &&
                                                vendorServiceMatch.is_active ===
                                                    false
                                            ) {
                                                return; // do not show inactive vendor service
                                            }

                                            // Push each available service into the decoration_services array
                                            _this.decoration_services.push({
                                                id: service.id, // Use the specific service ID
                                                decoration_type:
                                                    service.decoration_type,
                                                decoration_price_template:
                                                    service.selected_pricing_template_id,
                                                name: service.name,
                                                more_decorations:
                                                    service.more_decoration,
                                                other_services_list:
                                                    service.other_service,
                                                price_decoration_bulk:
                                                    service.price_decoration_bulk,
                                                // Set 'isActive' to true if this service is the default one
                                                isActive:
                                                    service.id ===
                                                    defaultServiceId,
                                                is_default:
                                                    service.is_default || false, // Store is_default flag for sorting
                                                price_dark:
                                                    service.price_dark || 0,
                                                price_light:
                                                    service.price_light || 0,
                                                use_imprintcity_price_template:
                                                    service.use_imprintcity_price_template,
                                                master_service: (() => {
                                                    const ms =
                                                        service.master_service;
                                                    const vd =
                                                        vendorServiceMatch;
                                                    const code =
                                                        vd && vd.service_code;
                                                    const priceText =
                                                        vd &&
                                                        vd.service_price_text !=
                                                            null &&
                                                        String(
                                                            vd.service_price_text
                                                        ).trim() !== ""
                                                            ? String(
                                                                  vd.service_price_text
                                                              ).trim()
                                                            : null;
                                                    if (!ms) {
                                                        if (
                                                            code == null &&
                                                            !priceText
                                                        ) {
                                                            return ms;
                                                        }
                                                        const o = {};
                                                        if (code != null) {
                                                            o.service_code =
                                                                code;
                                                        }
                                                        if (priceText) {
                                                            o.service_price_text =
                                                                priceText;
                                                        }
                                                        return o;
                                                    }
                                                    const patch = {};
                                                    if (code != null) {
                                                        patch.service_code =
                                                            code;
                                                    }
                                                    if (priceText) {
                                                        patch.service_price_text =
                                                            priceText;
                                                    }
                                                    return Object.keys(patch)
                                                        .length
                                                        ? Object.assign(
                                                              {},
                                                              ms,
                                                              patch
                                                          )
                                                        : ms;
                                                })(),
                                                // Keep original JSON master service values for setup fee sourcing.
                                                product_master_service:
                                                    service.master_service
                                                        ? Object.assign(
                                                              {},
                                                              service.master_service
                                                          )
                                                        : {},                                                    
                                                max_colors: service.max_colors,
                                                markup_percentage:
                                                    service.markup_percentage ||
                                                    0,
                                                // Check is_full_color from JSON AND fee_structure from VendorDecorationService
                                                // Both must be true: JSON is_full_color == true AND vendor fee_structure == 2
                                                is_full_color: (() => {
                                                    // 1. Get is_full_color value directly from JSON
                                                    const jsonIsFullColor =
                                                        service.is_full_color ===
                                                            true ||
                                                        service.is_full_color ===
                                                            1 ||
                                                        service.is_full_color ===
                                                            "true" ||
                                                        service.is_full_color ===
                                                            "1";

                                                    // 2. Find matching vendor service
                                                    let vendorService = null;
                                                    if (
                                                        service.master_service &&
                                                        service.master_service
                                                            .id
                                                    ) {
                                                        vendorService =
                                                            _this.vendorServices.find(
                                                                (vs) =>
                                                                    vs.service_id ===
                                                                        service
                                                                            .master_service
                                                                            .id ||
                                                                    vs.id ===
                                                                        service.id
                                                            );
                                                    } else if (service.id) {
                                                        vendorService =
                                                            _this.vendorServices.find(
                                                                (vs) =>
                                                                    vs.id ===
                                                                    service.id
                                                            );
                                                    }

                                                    // 3. Check vendor service fee_structure == 2
                                                    const vendorFeeStructure2 =
                                                        vendorService &&
                                                        (vendorService.fee_structure ==
                                                            2 ||
                                                            vendorService.fee_structure ===
                                                                "2");

                                                    // 4. Both conditions must be true
                                                    return (
                                                        jsonIsFullColor &&
                                                        vendorFeeStructure2
                                                    );
                                                })(),
                                                full_color:
                                                    service.full_color || 0,
                                                patch_enabled:
                                                    service.patch_enabled === true ||
                                                    service.patch_enabled === 1 ||
                                                    service.patch_enabled === "1" ||
                                                    service.patch_enabled === "true"
                                            });
                                
                                            // Store template IDs for later use if needed
                                            if (
                                                service.decoration_type == "1"
                                            ) {
                                                _this.print_templates_id =
                                                    service.selected_pricing_template_id;
                                            }
                                            if (
                                                service.decoration_type == "2"
                                            ) {
                                                _this.embroidery_template_ids =
                                                    service.selected_pricing_template_id;
                                            }
                                            if (
                                                service.decoration_type == "3"
                                            ) {
                                                _this.promotional_template_ids =
                                                    service.selected_pricing_template_id;
                                            }
                                        }
                                    );
                                    // If default was inactive and skipped, set first visible service as active
                                    if (
                                        _this.decoration_services.length > 0 &&
                                        !_this.decoration_services.some(
                                            (s) => s.isActive
                                        )
                                    ) {
                                        _this.decoration_services[0].isActive =
                                            true;
                                    }
                                }

                                // No active decoration services (all is_active false) → disable product
                                if (_this.decoration_services.length === 0) {
                                    _this.product = data.product;
                                    _this.productUnavailable = true;
                                    _this.productErrorMessage =
                                        "This product is currently unavailable. Please contact the administrator for more information.";
                                    _this.disable_btns = true;
                                    _this.isBusy = false;
                                    _this.updateProductErrorStatusInDB(
                                        "No active decoration services available"
                                    );
                                    this.$toast.error(
                                        _this.productErrorMessage,
                                        {
                                            position: "top-right",
                                            queue: true,
                                            duration: 5000
                                        }
                                    );
                                    return;
                                }

                                _this.temp_decoration_services = JSON.parse(
                                    JSON.stringify(_this.decoration_services)
                                );
                                const initialActiveServiceIndex =
                                    _this.decoration_services.findIndex(
                                        (s) => s.isActive
                                    );

                                // Assign product and fetch prices before calling changeDecorationService
                                var thumb_array = [];
                                var normal_array = [];

                                if (this.is_tshirt_24_hour) {
                                    data.product.MainNewSubProducts =
                                        data.product.MainNewSubProducts.filter(
                                            (sub_product_data) =>
                                                sub_product_data.Color.name ==
                                                "White"
                                        );
                                }

                                _this.product = data.product; // ASSIGNED EARLY

                                this.initializeRushOptions(_this.product);
                                this.loadPatchMaterials();

                                _this.product.price_decoration_bulk =
                                    JSON.parse(
                                        _this.product.price_decoration_bulk
                                    );
                                this.filterOtherServices(); // This will be handled by changeDecorationService

                                // FETCHING LATEST PRICES FROM DECORATION TEMPLATES
                                if (
                                    data.product.decoration_price_type ==
                                    "global_price"
                                ) {
                                    await this.$store
                                        .dispatch(FETCH_DECORATION_PRICES, {
                                            decoration_type:
                                                data.product.decoration_type,
                                            decoration_price_template_id:
                                                data.product
                                                    .decoration_price_template
                                        })
                                        .then(() => {
                                            _this.product.price_decoration_bulk =
                                                _this.decorationPrices;
                                        });
                                    if (
                                        (_this.product.decoration_type === 1 ||
                                            _this.product.decoration_type === 5) &&
                                        _this.product.PrintTemplate
                                    ) {
                                        _this.product.price_decoration_bulk.no_of_colors =
                                            _this.product.PrintTemplate.no_of_colors;
                                        _this.product.price_color_category_dark =
                                            _this.product.PrintTemplate.price_dark;
                                        _this.product.price_color_category_light =
                                            _this.product.PrintTemplate.price_light;
                                    } else if (
                                        (_this.product.decoration_type === 2 || _this.product.decoration_type === 4) &&
                                        _this.product.Embroidery
                                    ) {
                                        _this.product.price_color_category_dark =
                                            _this.product.Embroidery.price_dark;
                                        _this.product.price_color_category_light =
                                            _this.product.Embroidery.price_light;
                                    }
                                }

                                if (initialActiveServiceIndex !== -1) {
                                    _this.changeDecorationService(
                                        initialActiveServiceIndex,
                                        true
                                    );
                                }

                                _this.product.more_decoration = JSON.parse(
                                    _this.product.more_decoration
                                );

                                let sorted_size_names =
                                    this.sizesArrangmentSorting(
                                        _this.product.MainNewSubProducts.map(
                                            (s) => s.Size.size
                                        )
                                    );
                                let sorted_sub_products = [];
                                sorted_size_names.forEach(
                                    (sorted_size_name) => {
                                        _this.product.MainNewSubProducts.forEach(
                                            (new_sub_product) => {
                                                if (
                                                    new_sub_product.Size.size ==
                                                    sorted_size_name
                                                ) {
                                                    sorted_sub_products.push(
                                                        new_sub_product
                                                    );
                                                }
                                            }
                                        );
                                    }
                                );
                                _this.product.MainNewSubProducts =
                                    sorted_sub_products;

                                //if video url in product table
                                if (
                                    data.product.video_url &&
                                    data.product.video_url.trim() != ""
                                ) {
                                    thumb_array.push({
                                        id: data.product.id,
                                        url: data.product.video_url,
                                        thumb_url: data.product.video_url,
                                        type: "video"
                                    });
                                    normal_array.push({
                                        id: data.product.id,
                                        url: data.product.video_url,
                                        type: "video"
                                    });
                                }

                                //decoration type
                                _this.decoration_type =
                                    data.product.decoration_type;
                                this.loadVendorColors(data.product);

                                //gender and colors
                                _this.groupedSizesByColors =
                                    _this.groupArrayOfObjects(
                                        _this.product.MainNewSubProducts,
                                        "color_id"
                                    );
                                Object.values(
                                    _this.groupedSizesByColors
                                ).forEach((element) => {
                                    let lowest_price = 0;
                                    element.forEach((size, i) => {
                                        let base_price = size.price_base
                                            ? size.price_base
                                            : 0;
                                        if (parseFloat(base_price) > 0) {
                                            if (i == 0) {
                                                lowest_price =
                                                    parseFloat(base_price);
                                            } else if (
                                                parseFloat(lowest_price) >
                                                parseFloat(base_price)
                                            ) {
                                                lowest_price =
                                                    parseFloat(base_price);
                                            }
                                        }
                                    });
                                    _this.colors.push({
                                        id: element[0].Color.id,
                                        color_name: element[0].Color.name,
                                        hash: element[0].Color.hex,
                                        pms: element[0].Color.pms,
                                        swatches: element[0].Color.swatches,
                                        shades: element[0].Color.shades,
                                        category: element[0].Color.category,
                                        default_selection:
                                            element[0].default_selection,
                                        price_base: lowest_price
                                    });
                                });

                                // STORE DEFAULT COLOR
                                if (!this.is_tshirt_24_hour) {
                                    _this.default_selected_color =
                                        _this.colors.find(
                                            (color) =>
                                                color.default_selection == 1
                                        );
                                } else {
                                    _this.default_selected_color =
                                        _this.colors[0];
                                }

                                _this.product.price_base =
                                    _this.default_selected_color.price_base;
                                _this.product.price_markup_value =
                                    (parseFloat(_this.product.price_base) *
                                        parseFloat(
                                            _this.product
                                                .price_markup_percentage
                                        ) /
                                    100).toFixed(2);

                                _this.retail_price_without_price_template =
                                    _this.product.price_base +
                                    _this.product.price_markup_value;

                                //    Decoration
                                this.prepareDecorationPrices(
                                    this.product.decoration_type,
                                    this.product.price_decoration_bulk
                                );

                                await _this.getMoreDecorations(
                                    _this.product.more_decoration
                                );

                                if (!_this.is_tshirt_24_hour) {
                                    // Pass default color ID to show its images initially
                                    const defaultColorId = _this.default_selected_color
                                        ? _this.default_selected_color.id
                                        : null;
                                    await _this.getProductImages(defaultColorId);
                                } else {
                                    await _this.getProductImages(
                                        _this.colors[0].id
                                    );
                                }

                                // if (_this.decoration_method_template_ids) {
                                //     _this.getDecorationPriceFromTemplateIds();
                                // }

                                //genders group (normalize to array of ids)
                                let gendersGroupRaw =
                                    data.product.size_groupings;
                                let gendersGroup;
                                try {
                                    if (
                                        typeof gendersGroupRaw === "string" &&
                                        (gendersGroupRaw
                                            .trim()
                                            .startsWith("[") ||
                                            gendersGroupRaw
                                                .trim()
                                                .startsWith('"') ||
                                            gendersGroupRaw
                                                .trim()
                                                .startsWith("{"))
                                    ) {
                                        gendersGroup =
                                            JSON.parse(gendersGroupRaw);
                                    } else if (
                                        typeof gendersGroupRaw === "string" &&
                                        gendersGroupRaw.trim() !== ""
                                    ) {
                                        // plain id string like "54"
                                        gendersGroup = [
                                            Number(gendersGroupRaw.trim())
                                        ];
                                    } else if (
                                        typeof gendersGroupRaw === "number"
                                    ) {
                                        gendersGroup = [gendersGroupRaw];
                                    } else if (Array.isArray(gendersGroupRaw)) {
                                        gendersGroup = gendersGroupRaw;
                                    } else {
                                        gendersGroup = [];
                                    }
                                } catch (e) {
                                    // fallback for invalid JSON
                                    if (
                                        typeof gendersGroupRaw === "string" &&
                                        gendersGroupRaw.trim() !== ""
                                    ) {
                                        gendersGroup = [
                                            Number(gendersGroupRaw.trim())
                                        ];
                                    } else {
                                        gendersGroup = [];
                                    }
                                }
                                // ensure array of numbers
                                gendersGroup = (gendersGroup || [])
                                    .map((v) => Number(v))
                                    .filter((v) => !isNaN(v));

                                await _this.getGendersGroups(gendersGroup);

                                // Wait for Vue to update the DOM with the new gender groups and colors
                                await _this.$nextTick();

                                // Now that the DOM is rendered, safely click the default color
                                if (_this.default_selected_color) {
                                    const defaultColorEl =
                                        document.getElementById(
                                            `gender_${this.gender_groups[0].id}_color_${_this.default_selected_color.id}`
                                        );
                                    if (defaultColorEl) {
                                        defaultColorEl.click();
                                    } else {
                                        console.error(
                                            "Could not find default color element to click."
                                        );
                                    }
                                }
                                // Check if product is already disabled (after loading all display data)
                                if (_this.product.status === "Disabled") {
                                    _this.productUnavailable = true;
                                    _this.productErrorMessage =
                                        _this.product.error_message ||
                                        "This product is currently unavailable. Please contact the administrator for more information.";
                                    _this.isBusy = false;

                                    // Show toast notification
                                    this.$toast.error(
                                        _this.productErrorMessage,
                                        {
                                            position: "top-right",
                                            queue: true,
                                            duration: 5000
                                        }
                                    );

                                    return; // Stop processing - all display data is loaded
                                }

                                _this.isBusy = false;
                                _this.getCompanionProduct(
                                    this.$route.params.id_of_product
                                );
                            } else {
                                // Handle case when data is not successful or product is null
                                throw new Error(
                                    "Product data not available or invalid"
                                );
                            }
                        } catch (error) {
                            // Handle any errors during data processing
                            console.error(
                                "Error processing product data:",
                                error
                            );
                            _this.productLoadError = true;
                            _this.productUnavailable = true;
                            _this.productErrorMessage =
                                "This product is currently unavailable. Please contact the administrator for more information.";
                            _this.disable_btns = true;
                            _this.isBusy = false;

                            // Update product error status in database
                            _this.updateProductErrorStatusInDB(
                                error.message || "Product data processing error"
                            );

                            this.$toast.error(
                                "Failed to load product details. Please try again later.",
                                {
                                    position: "top-right",
                                    queue: true,
                                    duration: 5000
                                }
                            );
                        }
                    })
                    .catch((error) => {
                        // Handle API call errors (network, 404, 500, etc.)
                        // NOTE: We don't disable product for these errors as they are temporary
                        _this.isBusy = false;
                        _this.productLoadError = true;
                        _this.productUnavailable = true;
                        _this.productErrorMessage =
                            "This product is currently unavailable. Please contact the administrator for more information.";
                        _this.disable_btns = true;

                        console.error("Error fetching product data:", error);

                        let errorMessage = "Failed to load product details.";
                        let errorType = "API_ERROR";

                        if (error.response) {
                            // Server responded with error status
                            if (error.response.status === 404) {
                                errorMessage = "Product not found.";
                                errorType = "PRODUCT_NOT_FOUND";
                            } else if (error.response.status >= 500) {
                                errorMessage =
                                    "Server error. Please try again later.";
                                errorType = "SERVER_ERROR";
                            } else {
                                errorMessage =
                                    (error.response.data &&
                                        error.response.data.message) ||
                                    (error.response.data &&
                                        error.response.data.error) ||
                                    errorMessage;
                            }
                        } else if (error.request) {
                            // Request made but no response
                            errorMessage =
                                "Network error. Please check your connection.";
                            errorType = "NETWORK_ERROR";
                        } else {
                            // Something else happened
                            errorMessage = error.message || errorMessage;
                        }

                        // Do NOT update product status for network/API errors (they are temporary)
                        // Only data processing errors should disable the product

                        this.$toast.error(errorMessage, {
                            position: "top-right",
                            queue: true,
                            duration: 5000
                        });
                    });
            });
        },

        updateDecorationDiscountedPrice(data, decoration_type) {
            if (decoration_type == 1 || decoration_type == 5) {
                if (data.print_location1) {
                    data.print_location1.forEach((row) => {
                        for (
                            let i = 1;
                            i < this.product.PrintTemplate.no_of_colors;
                            i++
                        ) {
                            let discount_colour =
                                (parseFloat(row[`colour${i}`]) *
                                    parseFloat(row.discount)) /
                                100;
                            row[`colour${i}`] = parseFloat(
                                parseFloat(row[`colour${i}`]) -
                                    parseFloat(discount_colour)
                            ).toFixed(2);
                        }
                    });
                }
            } else if (decoration_type == 2 || decoration_type == 4) {
                data.forEach((row) => {
                    let discount_value =
                        (parseFloat(row["cost"]) * parseFloat(row.discount)) /
                        100;
                    row["cost"] = parseFloat(
                        parseFloat(row["cost"]) - parseFloat(discount_value)
                    ).toFixed(2);
                });
            }
            return data;
        },

        deleteImages(image_id) {
            let ids = [];
            if (confirm("Do you really want to delete?")) {
                new Promise(() => {
                    ids.push(image_id);
                    ApiService.post("/delete_userimages", { ids: ids })
                        .then(() => {
                            this.uploadedImages = [];
                            this.UploadedImages();
                            /* eslint-disable */
                            $(".new_artwork_popup").modal("hide");
                            /* eslint-enable */
                            this.$toast.success("Image deleted successfully", {
                                position: "top-right",
                                queue: true
                            });
                        })
                        .catch(({ response }) => {
                            //  console.log(response.status);
                            if (response.status == 401) {
                                this.$router.push({ name: "/client/login" });
                            }
                        });
                });
            }
        },

        previewArtworkImages(images) {
            this.preview_artwork_images = images;
            /* eslint-disable */
            if (
                this.getUrlExtension(images) == "ai" ||
                this.getUrlExtension(images) == "eps"
            ) {
                $("#preview_modals").modal("hide");
                // window.open(this.preview_artwork_images, '_blank');
                this.downloadURI(this.preview_artwork_images, this.images_name);
                this.$toast.success("Files downloaded successfully", {
                    position: "top-right",
                    queue: true
                });
                return;
            }
            $("#add-art-work").modal("hide");
            /* eslint-enable */
        },

        cancelPreviewImages() {
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        downloadURI(uri, name) {
            var link = document.createElement("a");
            link.download = name;
            link.href = uri;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        getsizeByColor(color_obj, event = null) {
            if (!event || !event.target.checked) {
                let selected_colors =
                    this.gender_groups[this.is_active]["selected_colors"];

                if (selected_colors && selected_colors.length) {
                    this.gender_groups[this.is_active]["selected_colors"] =
                        selected_colors.filter(
                            (color) => color.id != color_obj.id
                        );
                    let color_index = this.colors.findIndex(
                        (color) => color.id == color_obj.id
                    );
                    this.colors[color_index].is_selected = false;
                }

                if (
                    this.gender_groups[this.is_active].total_qty_gender_wise ==
                        0 &&
                    selected_colors.length == 0
                ) {
                    this.resetValues();
                }

                if (
                    this.gender_groups[this.is_active]["selected_colors"]
                        .length == 0
                ) {
                    this.choose_imprint_locations = false;
                    this.resetImprintLocations(
                        JSON.parse(this.product.design_areas)
                    );
                }

                this.calculatePricing(this.is_active);
                this.onChangeGenderColor();
                this.$forceUpdate();

                return;
            }

            let image = this.product.NewProductImages.find(
                (productImage) => productImage.color_id == color_obj.id
            );

            if (image && image.url) {
                color_obj["product_image"] = image.url;
            }

            this.selected_color = color_obj;
            let selected_gender = this.gender_groups[this.is_active];
            let sizes = [];
            sizes.push(
                selected_gender.sizes.filter(function (size) {
                    return size.color_id === color_obj.id;
                })
            );
            let sizesby_selected_color = [].concat.apply([], sizes);
            let new_sizeby_selected_color_array = [];
            sizesby_selected_color.forEach((element) => {
                if (element.status) {
                    new_sizeby_selected_color_array.push(element);
                }
            });
            this.sizesby_selected_color = new_sizeby_selected_color_array;

            let colorObj = JSON.parse(JSON.stringify(color_obj));

            let defaultCost = 0;
            const activeService = this.activeDecorationService;

            if (
                activeService &&
                activeService.price_decoration_bulk &&
                Array.isArray(activeService.price_decoration_bulk) &&
                activeService.price_decoration_bulk.length > 0
            ) {
                defaultCost = parseFloat(
                    activeService.price_decoration_bulk[0].retail_cost || 0
                );
            }

            let unique_sizes_with_cost = JSON.parse(
                JSON.stringify(this.sizesby_selected_color)
            );
            unique_sizes_with_cost.forEach((size) => {
                size.cost = defaultCost;
                size.total_cost = 0;
            });
            colorObj["unique_sizes"] = unique_sizes_with_cost;

            colorObj["total_cost_gender_wise"] = 0;
            colorObj["total_qty_gender_wise"] = 0;
            colorObj["total_color_fee"] = 0;
            colorObj["total_dark_category_fee"] = 0;
            colorObj["total_light_category_fee"] = 0;
            colorObj["total_decoration_discount_value"] = 0;
            if (!this.gender_groups[this.is_active]["selected_colors"]) {
                this.gender_groups[this.is_active]["selected_colors"] = [
                    colorObj
                ];
            } else {
                let color_index = this.gender_groups[this.is_active][
                    "selected_colors"
                ].findIndex((color) => color.id == colorObj.id);
                if (color_index < 0) {
                    this.gender_groups[this.is_active]["selected_colors"].push(
                        colorObj
                    );
                }
            }

            if (
                this.gender_groups[this.is_active]["selected_colors"].length > 0
            ) {
                this.choose_imprint_locations = true;
            }

            this.calculatePricing(this.is_active);

            this.onChangeGenderColor();
        },

        fuseSearch(options, search) {
            const fuse = new Fuse(options, {
                keys: ["color_name", "color_value"],
                shouldSort: true
            });
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list;
        },

        //croppie function start
        bind() {
            // Randomize cat photos, nothing special here.
            /* eslint-disable */
            let url = this.images[Math.floor(Math.random() * 4)];
            /* eslint-enable */
            // Just like what we did with .bind({...}) on
            // the mounted() function above.
            this.$refs.croppieRef.bind({
                url: "/maincss/design-studio/img/design-st-upload.jpg",
                zoom: 0
            });
        },

        cropViaEvent() {
            /* eslint-disable */
            this.$refs.croppieRef.result(options);
            /* eslint-enable */
        },

        result(output) {
            this.cropped = output;
        },

        update(val) {
            console.log(val);
        },

        rotate(rotationAngle) {
            // Rotates the image
            this.$refs.croppieRef.rotate(rotationAngle);
        },

        croppie(e) {
            var _this = this;
            /* eslint-disable */
            $(".cr-slider").prop("disabled", false);
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            _this.image_size_validation = 0;
            this.image_size = files[0].size / (1024 * 1024);
            // console.log('check for svg images here==========', files[0]['type']);
            if (
                files[0]["type"] != "image/jpeg" &&
                files[0]["type"] != "image/png" &&
                files[0]["type"] != "image/jpg" &&
                files[0]["type"] != "image/svg+xml" &&
                files[0]["type"] != "application/pdf" &&
                files[0]["type"] != "application/postscript"
            ) {
                this.crop_image_validation = 1;
                console.log(
                    "Incorrect image format.Please upload the Png, Jpg, Jpeg, svg, pdf, ai, eps file formats"
                );
                $("#crop_bdr").val("");
                this.croppieImage = null;
                this.images_name = "";
                // this.$refs.croppieRef.refresh();

                //load default image in croptool
                // this.$refs.croppieRef.bind({
                //     url: '/maincss/design-studio/img/design-st-upload.jpg'
                // });
            } else {
                _this.crop_image_validation = 0;
                _this.image_size_validation = 0;

                var reader = new FileReader();
                reader.onload = (e) => {
                    var image = new Image();
                    image.src = e.target.result;
                    $(".cr-slider").prop("disabled", true);
                    $("#crop_btn").prop("disabled", false);
                    this.croppieImage = e.target.result;
                    this.images_name = files[0]["name"];
                    image.onload = function () {
                        _this.image_height = this.height;
                        _this.image_width = this.width;
                        if (
                            _this.image_height < 100 &&
                            _this.image_width < 100
                        ) {
                            _this.crop_image_validation = 0;
                        } else {
                            _this.image_height = "";
                            _this.image_width = "";
                            _this.image_size_validation = 0;
                        }
                    };
                };
            }
            /* eslint-enable */

            reader.readAsDataURL(files[0]);
        },

        crop() {
            // Options can be updated.
            // Current option will return a base64 version of the uploaded image with a size of 600px X 450px.
            this.image_width = 200;
            this.image_height = 200;
            this.image_uploaded = {
                image: this.croppieImage,
                name: this.images_name,
                size: this.image_size.toFixed(2) + "MB",
                dimension: this.image_width + "x" + this.image_height
            };
            this.uploadedImages.push({ image_path: this.croppieImage });
            if (this.uploadedImages.length == 1) {
                this.temp_product_artwork = this.croppieImage;
            }
            this.NewImageUploads();
            /* eslint-disable */
            $("#crop_modal").modal("hide");
            $("#crop_bdr").val("");
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        uploadArtWork() {
            /* eslint-disable */
            let val = $("#crop_bdr").val();
            this.croppieImage = null;
            this.images_name = null;
            if (!val) {
                $("#crop_btn").prop("disabled", true);
            } else {
                $("#crop_btn").prop("disabled", false);
            }
            $("#add-art-work").modal("hide");
            /* eslint-enable */
        },

        cancelUploadArtwork() {
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        addArtWorkModal() {
            // let decoration_template;
            // if (this.decoration_type == 1) {
            //     decoration_template = this.decoration_price_template_values[0].quantity;
            // } else if (this.decoration_type == 2) {
            //     decoration_template = this.decoration_price_template_values[0].quantity1;
            // }
            // // let color_names = [];
            // let color_names = [];
            // let error = false;
            // let gender_total_quantity = 0;
            // this.gender_groups.forEach(gender => {
            //     gender.selected_colors.forEach(color => {
            //         if (!color.total_qty_gender_wise) {
            //             color_names.push(color.color_name)
            //             error = true;
            //         }
            //         // if (
            //         //     parseInt(color.total_qty_gender_wise) <
            //         //     parseInt(decoration_template)
            //         // ) {
            //         //     color_names.push(color.color_name)
            //         //     error = true;
            //         // }
            //     })
            //     gender_total_quantity+=gender.total_qty_gender_wise;
            // })

            // if (error) {
            //     // this.$toast.error(`${color_names.join(',')} quantity should be equal or greater than ${decoration_template}`, { position: "top-right", queue: true });
            //     this.$toast.error(`${color_names.join(',')}  atleast one single quantity is required`, { position: "top-right", queue: true });
            //     return;
            // }

            // if (gender_total_quantity < decoration_template) {
            //     this.$toast.error(`Quantity should be greater than or equal to ${decoration_template}`,  { position: "top-right", queue: true });
            //     return;
            // }
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        //croppie function end
        artworkDone() {
            if (this.temp_product_artwork) {
                this.product_artwork = this.temp_product_artwork;

                this.updateCartQuantity(true);
                return;
            }
            this.removeArtwork();

            this.updateCartQuantity(true);
        },

        removeArtwork() {
            this.product_artwork = "";
            this.temp_product_artwork = "";
            // this.removeSetupFee();
        },

        removeSetupFee() {
            if (this.setup_fee_applied_gender_index >= 0) {
                let gender =
                    this.gender_groups[this.setup_fee_applied_gender_index];
                if (gender.total_cost_gender_wise != 0) {
                    gender.total_cost_gender_wise =
                        parseFloat(gender.total_cost_gender_wise) -
                        gender["selected_colors"][0].setup_fee;
                    gender["selected_colors"][0].total_cost_gender_wise =
                        parseFloat(
                            gender["selected_colors"][0].total_cost_gender_wise
                        ) - gender["selected_colors"][0].setup_fee;
                }
                gender["selected_colors"][0].setup_fee = 0.0;
            }
            this.setup_fee = false;
            this.setup_fee_applied_gender_index = -1;
        },

        UploadedImages() {
            this.uploadedImages = [];
            new Promise(() => {
                ApiService.post("/userimages")
                    .then(({ data }) => {
                        this.uploadedImages = data.userImages.filter((image) =>
                            this.isValidHttpUrl(image.image_path)
                        );
                    })
                    .catch(({ response }) => {
                        //  console.log(response.status);
                        if (response.status == 401) {
                            this.$router.push({ name: "/client/login" });
                        }
                    });
            });
        },

        NewImageUploads() {
            if (this.image_uploaded) {
                var _this = this;
                _this.isBusy = true;
                new Promise(() => {
                    ApiService.post("/image_upload", this.image_uploaded)
                        .then(({ data }) => {
                            _this.isBusy = false;

                            if (data.success == false) {
                                _this.$toast.error(data.error, {
                                    position: "top-right",
                                    queue: true
                                });
                                return false;
                            }
                            _this.temp_product_artwork = data.image.image_path;
                            _this.image_uploaded = null;
                            if (_this.$refs.fileInput) {
                                _this.$refs.fileInput.value = null;
                            }
                            // _this.UploadedImages();
                            _this.artworkDone();
                            // $("#add-art-work").modal("hide");
                        })
                        .catch((response) => {
                            _this.isBusy = false;
                            _this.$toast.error(response, {
                                position: "top-right",
                                queue: true
                            });
                            console.log(response);
                            if (response.status == 401) {
                                this.$router.push({ name: "/client/login" });
                            }
                        });
                });
            }
        },

        resetValues() {
            this.removeArtwork();
            this.removeSetupFee();
            this.disable_btns = true;
            this.gender_groups.forEach((gender) => {
                gender["total_cost_gender_wise"] = 0.0;
                gender["selected_colors"] = [];
                gender["total_color_fee"] = 0.0;
                gender["total_qty_gender_wise"] = 0.0;
            });
            this.colors.forEach((color) => {
                color.is_selected = false;
            });

            this.imprint_locations = [];
            if (JSON.parse(this.product.design_areas).length > 0) {
                this.resetImprintLocations(
                    JSON.parse(this.product.design_areas)
                );
            }

            this.hashcolor = [];
            this.current_cart_quantity = 0;
        },

        resetImprintLocations(design_areas) {
            this.imprint_locations = [];
            design_areas.forEach((area) => {
                if (area.selected) {
                    let selectedArea = this.print_areas.filter((printArea) => {
                        return printArea.label == area.label;
                    });
                    this.imprint_locations.push({
                        location: area.label_show.trim() || area.label.trim(),
                        image_path:
                            selectedArea.length > 0
                                ? area.short_thumbnail_image
                                : selectedArea[0].short_thumbnail_image,
                        is_selected: false,
                        no_of_color: null,
                        price: 0,
                        total_price: 0,
                        colors: []
                    });
                }
            });
            if (this.imprint_locations.length > 0) {
                const first = this.imprint_locations[0];
                first.is_selected = true;
                first.no_of_color = 1;
                first.colors = [
                    {
                        color: null,
                        color_cost: 0.0,
                        cost_cost: 0.0,
                        cost_sum_added: false
                    }
                ];
            }
        },

        converToCamel(text) {
            return text.replace(
                /(^\w|\s\w)(\S*)/g,
                (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
            );
        },

        // This function not using
        // addTocart() {
        //     var _this = this;

        //     let is_colors_empty = false;
        //     let is_locations_selected = false;
        //     let is_area_colors_empty = false;
        //     for (let location of _this.imprint_locations) {
        //         if (location.is_selected) {
        //             is_locations_selected = true;
        //             if (location.colors.length == 0) {
        //                 is_area_colors_empty = true;
        //                 break;
        //             } else {
        //                 let is_selected = location.colors.find(
        //                     (color) => color.color == null
        //                 );
        //                 if (is_selected) {
        //                     is_colors_empty = true;
        //                     break;
        //                 }
        //             }
        //         }
        //     }

        //     let errorText = "";
        //     if (_this.product.decoration_type == 1) {
        //         errorText = "imprint locations";
        //     } else if (_this.product.decoration_type == 2) {
        //         errorText = "embroidery locations";
        //     }

        //     if (!is_locations_selected) {
        //         _this.$toast.error(`Please select ${errorText}.`, {
        //             position: "top-right",
        //             queue: true
        //         });
        //         return;
        //     } else if (is_colors_empty) {
        //         _this.$toast.error(
        //             `Please select all imprint colors for selected ${errorText}.`,
        //             { position: "top-right", queue: true }
        //         );
        //         return;
        //     } else if (is_area_colors_empty) {
        //         _this.$toast.error(
        //             `Please select colors for selected ${errorText}.`,
        //             { position: "top-right", queue: true }
        //         );
        //         return;
        //     }

        //     if (!this.product_artwork) {
        //         _this.$toast.error("Please Select or Upload Artwork", {
        //             position: "top-right",
        //             queue: true
        //         });
        //         return;
        //     }

        //     let minimum_quantity;
        //     if (this.decoration_type == 1) {
        //         minimum_quantity =
        //             this.decoration_price_template_values[0].quantity;
        //     } else if (this.decoration_type == 2) {
        //         minimum_quantity =
        //             this.decoration_price_template_values[0].quantity1;
        //     }
        //     // let color_names = [];
        //     let color_names = [];
        //     let is_color_quantity_empty = false;
        //     let gender_total_quantity = 0;
        //     this.gender_groups.forEach((gender) => {
        //         gender.selected_colors.forEach((color) => {
        //             if (!color.total_qty_gender_wise) {
        //                 color_names.push(color.color_name);
        //                 is_color_quantity_empty = true;
        //             }
        //         });
        //         gender_total_quantity += gender.total_qty_gender_wise;
        //     });

        //     if (is_color_quantity_empty) {
        //         this.$toast.error(
        //             `${color_names.join(
        //                 ","
        //             )}  atleast one single quantity is required`,
        //             { position: "top-right", queue: true }
        //         );
        //         return;
        //     }

        //     if (
        //         gender_total_quantity + this.current_cart_quantity <
        //         minimum_quantity
        //     ) {
        //         this.$toast.error(
        //             `Quantity should be greater than or equal to ${minimum_quantity}`,
        //             { position: "top-right", queue: true }
        //         );
        //         return;
        //     }
        //     _this.addIncart();
        // },

        // This function not using
        // addIncart() {
        //     var _this = this;
        //     let selectedProductQty = [];
        //     let allitems = [];

        //     if (_this.gender_groups) {
        //         selectedProductQty = _this.gender_groups.filter(
        //             (element) => element.total_qty_gender_wise > 0
        //         );
        //     }

        //     if (selectedProductQty) {
        //         selectedProductQty.forEach((element) => {
        //             element["selected_colors"].forEach((color) => {
        //                 let items = [];
        //                 color["unique_sizes"].forEach((size) => {
        //                     items.push({
        //                         sub_product_id: size.id,
        //                         user_id: _this.currentUserClient.id,
        //                         case_price: size.price_base,
        //                         markup_price: size.markup_price,
        //                         markup_percentage:
        //                             _this.product.price_markup_percentage,
        //                         ink_price: size.ink_price || 0,
        //                         single_location_price:
        //                             size.single_location_price || 0,
        //                         quantity: size.quantity || 0,
        //                         discount: size.discount ? size.discount : 0.0,
        //                         unit_price: size.cost || 0,
        //                         total_price: size.total_cost || 0
        //                     });
        //                     // }
        //                 });

        //                 allitems.push({
        //                     user_id: _this.currentUserClient.id,
        //                     item_id: _this.product.id,
        //                     gender_size_id: element.id,
        //                     color_id: color.id,
        //                     product_image: color.product_image,
        //                     decoration_type: _this.product.decoration_type,
        //                     price_decoration_bulk:
        //                         _this.product.price_decoration_bulk,
        //                     more_decorations: _this.product.more_decoration,
        //                     items: items,
        //                     imprint_locations: color.imprint_locations,
        //                     total_design_fee: color.total_design_fee,
        //                     total_dark_category_fee:
        //                         color.total_dark_category_fee,
        //                     total_light_category_fee:
        //                         color.total_light_category_fee,
        //                     total_quantity: color.total_qty_gender_wise,
        //                     total_price: color.total_cost_gender_wise,
        //                     setup_fee: color.setup_fee ? color.setup_fee : 0.0,
        //                     imprint_locations_price: color.total_color_fee,
        //                     subtotal_price: color.total_cost_gender_wise,
        //                     artwork: _this.product_artwork
        //                 });
        //             });
        //         });
        //     }
        //     if (_this.currentUserClient.id) {
        //         _this.isBusy = true;
        //         new Promise(() => {
        //             ApiService.post("/add-to-cart", allitems)
        //                 .then(async ({ data }) => {
        //                     if (!data.success) {
        //                         _this.$toast.error(data.error, {
        //                             position: "top-right",
        //                             queue: true
        //                         });
        //                         _this.isBusy = false;
        //                         return;
        //                     }
        //                     await _this.updateCartItems();
        //                     _this.$toast.success(
        //                         "Product has been added into the cart successfully.",
        //                         { position: "top-right", queue: true }
        //                     );
        //                     _this.$root.$emit("update-cart", {
        //                         type: "success"
        //                     });
        //                     /* eslint-disable */
        //                     $("#add-art-work").modal("hide");
        //                     /* eslint-enable */
        //                     _this.resetValues();
        //                     _this.getCartItems();

        //                     // setTimeout(() => {
        //                     //     let default_selected_color = this.colors.find(color => color.default_selection == 1);
        //                     //     if (default_selected_color) {
        //                     //         document.getElementById(`gender_${this.gender_groups[0].id}_color_${default_selected_color.id}`).click();
        //                     //     }
        //                     // }, 100);
        //                     _this.isBusy = false;
        //                 })
        //                 .catch((err) => {
        //                     console.log(err);
        //                 });
        //         });
        //     } else {
        //         selectedProductQty.filter((element) => {
        //             let items = [];
        //             let total_quantity = 0;
        //             let total_price = 0;
        //             let color_id = "";
        //             element["unique_sizes"].forEach((elem) => {
        //                 if (elem.quantity > 0) {
        //                     total_quantity =
        //                         total_quantity + parseInt(elem.quantity);
        //                     total_price =
        //                         total_price + parseFloat(elem.total_cost);
        //                     color_id = elem.color_id;
        //                     items.push({
        //                         sub_product_id: elem.id,
        //                         user_id: _this.currentUserClient.id,
        //                         quantity: elem.quantity,
        //                         unit_price: elem.cost,
        //                         total_price: elem.total_cost,
        //                         sub_prodcut: elem
        //                     });
        //                 }
        //             });
        //             allitems.push({
        //                 user_id: _this.currentUserClient.id,
        //                 item_id: _this.product.id,
        //                 gender_size_id: element.id,
        //                 color_id: color_id,
        //                 imprint_locations: _this.imprint_locations,
        //                 total_quantity: total_quantity,
        //                 total_price: total_price,
        //                 artwork: _this.product_artwork,
        //                 product: _this.product,
        //                 Genderagesize: element,
        //                 CartChildItems: items
        //             });
        //         });
        //         localStorage.setItem("cart", JSON.stringify(allitems));
        //         console.log("completed storing in the local database");
        //         _this.$toast.success(
        //             "Product has been added into the cart successfully.",
        //             { position: "top-right" }
        //         );
        //         _this.$root.$emit("update-cart", { type: "success" });
        //         _this.resetValues();
        //         _this.isBusy = false;
        //     }
        // },

        // This function not using
        // updateCartItems() {
        //     let params = [];
        //     this.same_artwork_cart_items.forEach((item) => {
        //         let child_items = [];
        //         item.CartChildItems.forEach((childItem) => {
        //             child_items.push({
        //                 id: childItem.id,
        //                 sub_product_id: childItem.sub_product_id,
        //                 case_price: childItem.case_price,
        //                 markup_price: childItem.markup_price,
        //                 markup_percentage: childItem.markup_percentage,
        //                 ink_price: childItem.ink_price,
        //                 single_location_price: childItem.single_location_price,
        //                 quantity: childItem.quantity || 0,
        //                 discount: childItem.discount || 0,
        //                 unit_price: childItem.unit_price || 0,
        //                 total_price: childItem.total_price || 0
        //             });
        //         });
        //         params.push({
        //             cart_id: item.id,
        //             child_items: child_items,
        //             total_dark_category_fee: item.total_dark_category_fee,
        //             total_light_category_fee: item.total_light_category_fee,
        //             name_number_fees: item.name_number_fees,
        //             non_standard_fees: item.non_standard_fees,
        //             imprint_locations_price: item.imprint_locations_price,
        //             imprint_locations: item.imprint_locations,
        //             total_quantity: item.total_quantity,
        //             subtotal_price: item.subtotal_price,
        //             total_price: item.total_price
        //         });
        //     });

        //     return new Promise((resolve, reject) => {
        //         ApiService.post("/update-cart", params)
        //             .then(({ data }) => {
        //                 if (!data.success) {
        //                     this.$toast.error(data.error, {
        //                         position: "top-right",
        //                         queue: true
        //                     });
        //                     reject(data);
        //                 }
        //                 resolve(data);
        //             })
        //             .catch((err) => {
        //                 reject(err);
        //             });
        //     });
        // },

        openStartDesignModal() {
            let minimum_quantity;

            let total_qty = 0;
            let error = false;
            let color_names = [];
            this.gender_groups.forEach((gender) => {
                if (gender.selected_colors) {
                    gender.selected_colors.forEach((color) => {
                        if (!color.total_qty_gender_wise) {
                            color_names.push(color.color_name);
                            error = true;
                        }
                    });
                }

                total_qty = total_qty + gender.total_qty_gender_wise;
            });

            if (this.decoration_type == 1 || this.decoration_type == 5) {
                minimum_quantity =
                    this.decoration_price_template_values[0].quantity;
            } else if (this.decoration_type == 2 || this.decoration_type == 4) {
                minimum_quantity =
                    this.decoration_price_template_values[0].quantity1;
            }

            if (error) {
                this.$toast.error(
                    `${color_names.join(
                        ","
                    )} atleast one single quantity is required`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            if (total_qty == 0) {
                this.$toast.error(
                    "Please select color and quantity to design",
                    { position: "top-right", queue: true }
                );
                return;
            } else if (parseInt(total_qty) < parseInt(minimum_quantity)) {
                this.$toast.error(
                    "Quantity should be greater than or equal to " +
                        minimum_quantity,
                    { position: "top-right", queue: true }
                );
                return;
            }

            let is_locations_selected = false;
            let is_area_colors_empty = false;
            for (let location of this.imprint_locations) {
                if (location.is_selected) {
                    is_locations_selected = true;
                    // Check if full color is selected - if yes, skip color validation
                    const isFullColor =
                        location.is_full_color_selected === true ||
                        location.no_of_color === "full_color";
                    if (!isFullColor && location.colors.length == 0) {
                        is_area_colors_empty = true;
                        break;
                    }
                }
            }

            let errorText = "";
            if (
                this.product.decoration_type == 1 ||
                this.product.decoration_type == 5
            ) {
                errorText = "imprint locations";
            } else if (this.product.decoration_type == 2 || this.product.decoration_type == 4) {
                errorText = "embroidery locations";
            }

            if (!is_locations_selected) {
                this.$toast.error(`Please select ${errorText}.`, {
                    position: "top-right",
                    queue: true
                });
                return;
            } else if (is_area_colors_empty) {
                this.$toast.error(
                    `Please select colors for selected ${errorText}.`,
                    { position: "top-right", queue: true }
                );
                return;
            }
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        /**
         * Check if the product + color + service combination already exists in cart
         * Returns the matching cart item if found, null otherwise
         */
        checkCartConflict() {
            if (!this.cart_items || this.cart_items.length === 0) {
                return null;
            }

            // Get active service and selected color
            const activeService = this.activeDecorationService;
            if (!activeService) {
                return null;
            }

            let selectedColorId = null;
            if (
                this.is_active >= 0 &&
                this.gender_groups[this.is_active] &&
                this.gender_groups[this.is_active].selected_colors.length > 0
            ) {
                selectedColorId =
                    this.gender_groups[this.is_active].selected_colors[0].id;
            }

            if (!selectedColorId) {
                return null;
            }

            const activeServiceId =
                (activeService.master_service && activeService.master_service.service_id) ||
                (activeService.master_service && activeService.master_service.id) ||
                activeService.id ||
                null;

            const conflictItem = this.cart_items.find((item) => {
                if (!item || item.item_id !== this.product.id) {
                    return false;
                }

                if (item.color_id !== selectedColorId) {
                    return false;
                }

                const cartServiceId =
                    (item.decoration &&
                        item.decoration.master_service &&
                        item.decoration.master_service.service_id) ||
                    (item.decoration &&
                        item.decoration.master_service &&
                        item.decoration.master_service.id) ||
                    (item.decoration && item.decoration.id) ||
                    null;

                if (!activeServiceId || !cartServiceId) {
                    return false;
                }

                return cartServiceId === activeServiceId;
            });

            return conflictItem || null;
        },

        /**
         * Show cart conflict warning modal if conflict found
         * Returns true if conflict found (and warning shown), false otherwise
         */
        showCartConflictIfExists() {
            const conflictItem = this.checkCartConflict();

            if (conflictItem) {
                // Set conflict data
                this.cartConflictItem = conflictItem;
                this.conflictColorName =
                    this.gender_groups[this.is_active].selected_colors[0]
                        .color_name || "Selected Color";
                const activeService = this.activeDecorationService;
                const activeServiceLabel =
                    (activeService.master_service &&
                        activeService.master_service.ecomm_display) ||
                    (activeService.master_service &&
                        activeService.master_service.service_name) ||
                    (activeService.master_service &&
                        activeService.master_service.name) ||
                    activeService.name ||
                    "Service";

                this.conflictServiceName = activeServiceLabel;

                // Close the design modal behind the warning
                /* eslint-disable */
                $("#add-art-work").modal("hide");
                /* eslint-enable */

                // Show the warning modal
                this.showCartConflictWarning = true;
                return true;
            }

            return false;
        },

        /**
         * Cancel cart conflict and close modal
         */
        cancelCartConflict() {
            this.showCartConflictWarning = false;
            this.cartConflictItem = null;
            /* eslint-disable */
            $("#add-art-work").modal("hide");
            /* eslint-enable */
        },

        /**
         * Proceed with design after user confirms they want to update
         */
        proceedWithDesignAfterConflict() {
            this.showCartConflictWarning = false;
            this.proceedToDesignStudio = true;
            // Continue with the design studio opening (call the design studio logic)
            this.openDesignStudioModal();
        },

        /**
         * Main startDesign method that checks for cart conflicts before opening design studio
         */
        startDesign() {
            // Check if there are any quantities selected
            let total_qty = 0;
            this.gender_groups.forEach((gender) => {
                total_qty += gender.total_qty_gender_wise;
            });

            if (total_qty === 0) {
                this.$toast.error(
                    "Please select quantity for at least one item.",
                    {
                        position: "top-right",
                        queue: true
                    }
                );
                return;
            }

            // Check for cart conflicts
            if (this.showCartConflictIfExists()) {
                // Conflict found - modal is shown, wait for user action
                return;
            }

            // No conflict - proceed to design studio
            this.openDesignStudioModal();
        },

        async openDesignStudioModal() {
            var _this = this;
            let cart = [];
            /* eslint-disable */
            $("#add-art-work").modal("hide");
            /* eslint-enable */

            // Minimum quantity check
            let total_qty = 0;
            this.gender_groups.forEach((gender) => {
                total_qty += gender.total_qty_gender_wise;
            });

            let minimum_quantity = 0;
            const activeService = this.activeDecorationService;
            if (!activeService) {
                this.$toast.error("Please select a decoration service.", {
                    position: "top-right"
                });
                return;
            }

            // Determine minimum quantity based on the active service
            if (
                activeService.price_decoration_bulk &&
                activeService.price_decoration_bulk.length > 0
            ) {
                if (activeService.use_imprintcity_price_template === 0) {
                    // New PCNA pricing structure
                    minimum_quantity =
                        activeService.price_decoration_bulk[0].quantity;
                } else {
                    // Old Imprint City template pricing structure
                    if (
                        (this.decoration_type == 1 || this.decoration_type == 5) &&
                        this.decoration_price_template_values &&
                        this.decoration_price_template_values.length > 0
                    ) {
                        minimum_quantity =
                            this.decoration_price_template_values[0].quantity;
                    } else if (
                        (this.decoration_type == 2 || this.decoration_type == 4) &&
                        this.decoration_price_template_values &&
                        this.decoration_price_template_values.length > 0
                    ) {
                        minimum_quantity =
                            this.decoration_price_template_values[0].quantity1;
                    }
                }
            }

            if (total_qty < minimum_quantity) {
                this.$toast.error(
                    "Quantity should be greater than or equal to " +
                        minimum_quantity,
                    { position: "top-right", queue: true }
                );
                return;
            }

            let productForDesignStudio = JSON.parse(
                JSON.stringify(_this.product)
            );

            // Update the 'is_default' flag in the decorations array based on the activeService
            try {
                let decorationsData = JSON.parse(
                    productForDesignStudio.decorations
                );
                if (
                    decorationsData &&
                    decorationsData[0] &&
                    decorationsData[0].decoration_type_list
                ) {
                    decorationsData[0].decoration_type_list.forEach(
                        (service) => {
                            // Set is_default based on whether the service ID matches the active service ID
                            service.is_default =
                                service.id === activeService.id;
                        }
                    );
                    productForDesignStudio.decorations =
                        JSON.stringify(decorationsData);
                }
            } catch (e) {
                console.error("Could not update default decoration:", e);
            }

            // Update decoration_type based on active service
            productForDesignStudio.decoration_type =
                activeService.decoration_type;

            if (activeService.use_imprintcity_price_template === 1) {
                // If using Imprint City template pricing
                productForDesignStudio.decoration_price_template =
                    activeService.decoration_price_template; // Set the correct template ID from active service

                // Also update PrintTemplate/Embroidery objects based on the type
                if (
                    activeService.decoration_type === 1 ||
                    activeService.decoration_type === 5
                ) {
                    const template = this.printTemplates.find(
                        (t) => t.id === activeService.decoration_price_template
                    );
                    productForDesignStudio.PrintTemplate = template || null;
                    productForDesignStudio.Embroidery = null; // Ensure Embroidery is null
                } else if (activeService.decoration_type === 2 || activeService.decoration_type === 4) {
                    const templateList =
                        activeService.decoration_type === 4
                            ? this.patchTemplates
                            : this.embroideryTemplates;
                    const template = templateList.find(
                        (t) => t.id === activeService.decoration_price_template
                    );
                    productForDesignStudio.Embroidery = template || null;
                    // Optionally update PrintTemplate object to reflect Embroidery details if needed, or set to null
                    if (template) {
                        productForDesignStudio.PrintTemplate = null;
                    } else {
                        productForDesignStudio.PrintTemplate = null;
                    }
                } else {
                    // Handle other decoration types if necessary, otherwise clear templates
                    productForDesignStudio.PrintTemplate = null;
                    productForDesignStudio.Embroidery = null;
                }
            } else {
                // If using PCNA pricing (flag is 0)
                productForDesignStudio.decoration_price_template = null; // Set template ID to null
                productForDesignStudio.PrintTemplate = null; // Clear related templates
                productForDesignStudio.Embroidery = null;
            }

            // Ensure Vendor.newVendorColors exists (it might be set earlier)
            if (
                productForDesignStudio.Vendor &&
                !productForDesignStudio.Vendor.VendorColors
            ) {
                productForDesignStudio.Vendor.VendorColors =
                    _this.imprint_colors_array_for_template || [];
            }

            // Loop through gender groups to prepare the 'cart' array
            this.gender_groups.forEach((gender) => {
                if (gender.total_qty_gender_wise > 0) {
                    const colorsForDesignStudio = gender.selected_colors
                        .filter((color) =>
                            // Only include colors where at least one size has quantity > 0
                            color.unique_sizes.some((size) => size.quantity > 0)
                        )
                        .map((color) => {
                            // Create a deep copy of the color object to avoid modifying the original
                            let newColorObject = JSON.parse(
                                JSON.stringify(color)
                            );
                            // Attach the current imprint locations state to this color object
                            newColorObject.imprint_locations = JSON.parse(
                                JSON.stringify(_this.imprint_locations)
                            );
                            return newColorObject;
                        });

                    // Only add to cart if there are actually selected colors with quantities
                    if (colorsForDesignStudio.length > 0) {
                        cart.push({
                            item: productForDesignStudio, // Use the MODIFIED product object
                            color: colorsForDesignStudio[0], // Keep the first selected color reference if needed
                            colors: colorsForDesignStudio, // Array of selected colors with quantities and imprint locations
                            gender_name: gender.gender,
                            gender_id: gender.id,
                            base_price: _this.product.price_base, // Base price might need re-evaluation based on logic
                            total_qty: gender.total_qty_gender_wise,
                            subtotal: gender.subtotal,
                            total_color_fee: gender.total_color_fee || 0,
                            total_cost: gender.total_cost_gender_wise,
                            total_design_fee: gender.total_design_fee,
                            total_discount_value: gender.total_discount_value,
                            total_setup_fee: _this.setup_fee, // Ensure setup_fee is correctly calculated and available
                            imprint_locations: _this.imprint_locations, // Main imprint locations state
                            artwork: _this.product_artwork,
                            markup_percentage:
                                _this.product.price_markup_percentage,
                            activeServiceData: (() => {
                                // Create a deep copy of activeDecorationService
                                const activeServiceData = JSON.parse(
                                    JSON.stringify(this.activeDecorationService)
                                );

                                const vdRow =
                                    _this.resolveVendorDecorationServiceRow(
                                        activeServiceData
                                    );
                                if (vdRow && activeServiceData) {
                                    if (!activeServiceData.master_service) {
                                        activeServiceData.master_service = {};
                                    }
                                    if (vdRow.service_code != null) {
                                        activeServiceData.master_service.service_code =
                                            vdRow.service_code;
                                    }
                                    if (
                                        vdRow.service_price_text != null &&
                                        String(
                                            vdRow.service_price_text
                                        ).trim() !== ""
                                    ) {
                                        activeServiceData.master_service.service_price_text =
                                            String(
                                                vdRow.service_price_text
                                            ).trim();
                                    }
                                }

                                // Enrich other_services_list with full data from VendorOtherServices
                                // Also include services from this.otherServices that are not in the original list
                                const vendorOtherServices =
                                    _this.product.VendorOtherServices || [];

                                // Start with existing other_services_list from activeServiceData
                                let enrichedOtherServices = [];
                                if (
                                    activeServiceData &&
                                    activeServiceData.other_services_list &&
                                    Array.isArray(
                                        activeServiceData.other_services_list
                                    )
                                ) {
                                    enrichedOtherServices =
                                        activeServiceData.other_services_list.map(
                                            (service) => {
                                                // Find full service data from VendorOtherServices
                                                const fullServiceData =
                                                    vendorOtherServices.find(
                                                        (vs) =>
                                                            vs.id === service.id
                                                    );

                                                return {
                                                    id: service.id,
                                                    name:
                                                        (fullServiceData &&
                                                            fullServiceData.name) ||
                                                        (fullServiceData &&
                                                            fullServiceData.master_service &&
                                                            fullServiceData
                                                                .master_service
                                                                .service_name) ||
                                                        service.name ||
                                                        "",
                                                    ecomm_display:
                                                        (fullServiceData &&
                                                            fullServiceData.ecomm_display) ||
                                                        (fullServiceData &&
                                                            fullServiceData.master_service &&
                                                            fullServiceData
                                                                .master_service
                                                                .ecomm_display) ||
                                                        service.ecomm_display ||
                                                        "",
                                                    fee_structure:
                                                        (fullServiceData &&
                                                            fullServiceData.fee_structure) ||
                                                        (fullServiceData &&
                                                            fullServiceData.rollup_service &&
                                                            fullServiceData
                                                                .rollup_service
                                                                .fee_structure_name) ||
                                                        service.fee_structure ||
                                                        "",
                                                    retail_cost:
                                                        service.retail_cost ||
                                                        (fullServiceData &&
                                                            fullServiceData.retail_cost) ||
                                                        0,
                                                    net_cost:
                                                        service.net_cost ||
                                                        (fullServiceData &&
                                                            fullServiceData.net_cost) ||
                                                        0,
                                                    show_service: (() => {
                                                        const showService =
                                                            fullServiceData &&
                                                            fullServiceData.show_service !==
                                                                undefined
                                                                ? fullServiceData.show_service
                                                                : service.show_service !==
                                                                  undefined
                                                                ? service.show_service
                                                                : false;
                                                        // Keep boolean as is (true/false), convert 0/1 to boolean
                                                        if (
                                                            typeof showService ===
                                                            "boolean"
                                                        ) {
                                                            return showService;
                                                        }
                                                        // Convert 0/1 to boolean
                                                        if (
                                                            showService === 0 ||
                                                            showService === "0"
                                                        ) {
                                                            return false;
                                                        }
                                                        if (
                                                            showService === 1 ||
                                                            showService === "1"
                                                        ) {
                                                            return true;
                                                        }
                                                        // Default to false
                                                        return false;
                                                    })(),
                                                    rollup_fee_id:
                                                        (fullServiceData &&
                                                            fullServiceData.rollup_fee_id) ||
                                                        service.rollup_fee_id ||
                                                        null,
                                                    rollup_fee_name:
                                                        (fullServiceData &&
                                                            fullServiceData.rollup_fee_name) ||
                                                        service.rollup_fee_name ||
                                                        null
                                                };
                                            }
                                        );
                                }

                                // Get IDs already in the enriched list
                                const existingServiceIds =
                                    enrichedOtherServices.map((s) => s.id);

                                // Add services from this.otherServices that are not already included
                                if (
                                    _this.otherServices &&
                                    Array.isArray(_this.otherServices)
                                ) {
                                    _this.otherServices.forEach((service) => {
                                        if (
                                            !existingServiceIds.includes(
                                                service.id
                                            )
                                        ) {
                                            enrichedOtherServices.push({
                                                id: service.id,
                                                name: service.name || "",
                                                ecomm_display:
                                                    service.ecomm_display || "",
                                                fee_structure:
                                                    service.fee_structure || "",
                                                retail_cost:
                                                    service.retail_cost || 0,
                                                net_cost: service.net_cost || 0,
                                                show_service:
                                                    service.show_service ||
                                                    false,
                                                rollup_fee_id:
                                                    service.rollup_fee_id ||
                                                    null,
                                                rollup_fee_name:
                                                    service.rollup_fee_name ||
                                                    null
                                            });
                                        }
                                    });
                                }

                                // Assign the enriched list back to activeServiceData
                                if (activeServiceData) {
                                    activeServiceData.other_services_list =
                                        enrichedOtherServices;

                                    // Check is_full_color from JSON AND fee_structure from VendorDecorationService
                                    // Both must be true: JSON is_full_color == true AND vendor fee_structure == 2
                                    // Get is_full_color value directly from JSON
                                    const jsonIsFullColor =
                                        activeServiceData.is_full_color ===
                                            true ||
                                        activeServiceData.is_full_color === 1 ||
                                        activeServiceData.is_full_color ===
                                            "true" ||
                                        activeServiceData.is_full_color === "1";

                                    // Find matching vendor service
                                    let vendorService = null;
                                    if (
                                        activeServiceData.master_service &&
                                        activeServiceData.master_service.id
                                    ) {
                                        vendorService =
                                            _this.vendorServices.find(
                                                (vs) =>
                                                    vs.service_id ===
                                                        activeServiceData
                                                            .master_service
                                                            .id ||
                                                    vs.id ===
                                                        activeServiceData.id
                                            );
                                    } else if (activeServiceData.id) {
                                        vendorService =
                                            _this.vendorServices.find(
                                                (vs) =>
                                                    vs.id ===
                                                    activeServiceData.id
                                            );
                                    }

                                    // Check vendor service fee_structure == 2
                                    const vendorFeeStructure2 =
                                        vendorService &&
                                        (vendorService.fee_structure == 2 ||
                                            vendorService.fee_structure ===
                                                "2");

                                    // Both conditions must be true
                                    activeServiceData.is_full_color =
                                        jsonIsFullColor && vendorFeeStructure2;
                                }

                                // Add Color Mix Fee value from VendorFees (only the relevant one)
                                if (activeServiceData) {
                                    const vendorFees =
                                        _this.product &&
                                        _this.product.VendorFees
                                            ? _this.product.VendorFees
                                            : [];
                                    const decorationType =
                                        activeServiceData.decoration_type;
                                    const serviceName =
                                        activeServiceData.master_service &&
                                        activeServiceData.master_service
                                            .service_name
                                            ? activeServiceData.master_service
                                                  .service_name
                                            : "";

                                    // Determine if it's embroidery or ink based on decoration type and service name
                                    let targetService = null;

                                    if (decorationType == 2) {
                                        // Decoration type 2 = Embroidery = Thread Mix Fee
                                        targetService = vendorFees.find(
                                            (service) =>
                                                service.type === "thread_fee" ||
                                                (service.ecomm_display &&
                                                    service.ecomm_display
                                                        .toLowerCase()
                                                        .includes(
                                                            "thread mix fee"
                                                        ))
                                        );
                                    } else if (
                                        decorationType == 1 ||
                                        decorationType == 5
                                    ) {
                                        // Decoration type 1 = Screen Print = Ink Mix Fee
                                        targetService = vendorFees.find(
                                            (service) =>
                                                service.type ===
                                                    "custom_ink_mix" ||
                                                (service.ecomm_display &&
                                                    service.ecomm_display
                                                        .toLowerCase()
                                                        .includes(
                                                            "ink mix fee"
                                                        ))
                                        );
                                    } else if (decorationType == 0) {
                                        // Decoration type 0 = PCNA - check service name
                                        const serviceNameLower = serviceName
                                            ? serviceName.toLowerCase()
                                            : "";
                                        const isEmbroidery =
                                            serviceNameLower.includes(
                                                "embroidery"
                                            );
                                        const isPrint =
                                            serviceNameLower.includes("print");

                                        if (isEmbroidery) {
                                            // Embroidery service = Thread Mix Fee
                                            targetService = vendorFees.find(
                                                (service) =>
                                                    service.type ===
                                                        "thread_fee" ||
                                                    (service.ecomm_display &&
                                                        service.ecomm_display
                                                            .toLowerCase()
                                                            .includes(
                                                                "thread mix fee"
                                                            ))
                                            );
                                        } else if (isPrint) {
                                            // Print service = Ink Mix Fee
                                            targetService = vendorFees.find(
                                                (service) =>
                                                    service.type ===
                                                        "custom_ink_mix" ||
                                                    (service.ecomm_display &&
                                                        service.ecomm_display
                                                            .toLowerCase()
                                                            .includes(
                                                                "ink mix fee"
                                                            ))
                                            );
                                        }
                                        // If neither embroidery nor print, targetService remains null (no fee)
                                    }

                                    if (
                                        targetService &&
                                        targetService.retail_cost
                                    ) {
                                        activeServiceData.color_mix_fee =
                                            parseFloat(
                                                targetService.retail_cost
                                            ) || 0;
                                    }
                                }

                                return activeServiceData;
                            })()
                        });
                    }
                }
            });

            if (cart.length > 0) {
                localStorage.setItem("design", JSON.stringify(cart));
                localStorage.setItem("is24Tshirt", this.is_tshirt_24_hour);
                localStorage.setItem("colorIndex", 0); // Reset color index for Design Studio
                // Store rush option data for Design Studio
                localStorage.setItem(
                    "selectedRushOptionId",
                    this.selectedRushOptionId || ""
                );
                localStorage.setItem(
                    "vendorServices",
                    JSON.stringify(this.vendorServices || [])
                );

                // Store selected rush option date
                const options =
                    this.dynamicRushOptions.length > 0
                        ? this.dynamicRushOptions
                        : this.rushOptions;
                const selectedRushOption = options.find(
                    (opt) => opt.id === this.selectedRushOptionId
                );
                if (selectedRushOption && selectedRushOption.estimatedDate) {
                    localStorage.setItem(
                        "selectedRushOptionDate",
                        selectedRushOption.estimatedDate.toISOString()
                    );
                } else {
                    localStorage.removeItem("selectedRushOptionDate");
                }

                // Find the currently active service again to pass the pricing flag
                const currentActiveService = this.decoration_services.find(
                    (service) => service.isActive === true
                );
                const pricingFlag =
                    currentActiveService &&
                    currentActiveService.use_imprintcity_price_template !==
                        undefined
                        ? currentActiveService.use_imprintcity_price_template
                        : 1; // Default to 1 if not found

                // Store the first selected imprint location side for Design Studio
                if (this.imprint_locations && this.imprint_locations.length > 0) {
                    const firstSelectedLocation = this.imprint_locations.find(
                        (location) => location.is_selected === true
                    );
                    
                    if (firstSelectedLocation && firstSelectedLocation.location) {
                        const locationName = firstSelectedLocation.location.toLowerCase().trim();
                        let detectedSide = null;
                        
                        if (locationName.includes("left")) {
                            detectedSide = "left";
                        } else if (locationName.includes("right")) {
                            detectedSide = "right";
                        } else if (locationName.includes("front")) {
                            detectedSide = "front";
                        } else if (locationName.includes("back")) {
                            detectedSide = "back";
                        }
                        
                        if (detectedSide) {
                            localStorage.setItem("active_flip", detectedSide);
                        }
                    }
                }

                // Store selected patch config for Design Studio
                if (this.isPatchEnabledForActiveService && this.selectedPatchData) {
                    localStorage.setItem("selectedPatchConfig", JSON.stringify({
                        material_id: this.selectedPatchMaterialId,
                        patch_id: this.selectedPatchId,
                        patch_name: this.selectedPatchData.image_name || "",
                        height: this.selectedPatchData.height || 0,
                        width: this.selectedPatchData.width || 0,
                        image_path: this.selectedPatchData.image_path || "",
                        prices: this.selectedPatchData.prices || []
                    }));
                } else {
                    localStorage.removeItem("selectedPatchConfig");
                }

                let hashValue = "";
                if (this.start_designing_with == "existing") {
                    hashValue = "#designs";
                } else if (this.start_designing_with == "upload") {
                    hashValue = "#upload";
                }

                // Navigate to Design Studio with the pricing flag in the query
                this.$router.push({
                    name: "DesignStudioV3",
                    query: { pricingFlag: pricingFlag }, // Pass the flag
                    hash: hashValue
                });
            } else {
                // Handle the case where no items have quantity selected
                this.$toast.error(
                    "Please select quantity for at least one item.",
                    {
                        position: "top-right",
                        queue: true
                    }
                );
            }
        },

        // This function not using
        resetAllImprintLocationsData() {
            this.imprint_locations.forEach((locations) => {
                locations.colors = [];
                locations.is_selected = false;
                locations.price = 0;
                locations.total_price = 0;
                locations.no_of_color = null;
            });
        },

        selectImprintLocations(index) {
            if (this.imprint_locations[index].is_selected) {
                this.imprint_locations[index].no_of_color = null;
                this.imprint_locations[index].colors = [];
            }
            this.imprint_locations[index].is_selected =
                !this.imprint_locations[index].is_selected;
            
            // Preselect "1-color" when a location is selected
            if (this.imprint_locations[index].is_selected) {
                // Set no_of_color to 1 (which corresponds to "1-color" option)
                this.imprint_locations[index].no_of_color = 1;
                // Initialize colors array with one color object
                this.imprint_locations[index].colors = [{
                    color: null,
                    color_cost: 0.0,
                    cost_cost: 0.0,
                    cost_sum_added: false
                }];
            }
            
            this.calculatePricing(this.is_active);
            this.$forceUpdate();
        },

        selectNumberOfColors(location, count) {
            // Handle "Full color" selection
            if (count === "full_color" || count === "Full color") {
                location.no_of_color = "full_color";
                location.is_full_color = true;
                location.is_full_color_selected = true; // Set full color flag
                location.colors = []; // No individual color selection for full color
            } else {
                let no_of_colors = parseInt(count) || 0;
                location.no_of_color = parseInt(count) || null;
                location.is_full_color = false;
                location.is_full_color_selected = false; // Clear full color flag when switching to regular color
                location.colors = [];
                for (let i = 0; i < no_of_colors; i++) {
                    location.colors.push({
                        color: null,
                        color_cost: 0.0,
                        cost_cost: 0.0,
                        cost_sum_added: false
                    });
                }
            }
            this.calculatePricing(this.is_active);
        },

        calcImprintLocationByGender(genderIndex) {
            const activeService = this.activeDecorationService;
            if (!activeService) return 0;

            let gender_element = this.gender_groups[genderIndex];
            if (!gender_element) return 0;

            let totalCalculatedDecorationFee = 0;
            let initalLocationIndex = 0;
            const total_gender_quantity =
                this.getTotalItemQuantity(gender_element);
            this.total_decoration_colors_count = 0;

            if (activeService.use_imprintcity_price_template === 0) {
                if (!activeService.master_service) {
                    return 0;
                }
                const pricing = activeService.master_service;

                this.imprint_locations.forEach((location) => {
                    location.decoration_fee = 0;
                    if (location.is_selected) {
                        // Check if "Full color" is selected
                        if (
                            location.no_of_color === "full_color" ||
                            location.is_full_color === true
                        ) {
                            // Use full_color value from VendorDecorationService for run charge
                            const fullColorValue = parseFloat(
                                pricing.full_color || 0
                            );
                            let calculatedFeePerItem = 0;
                            if (initalLocationIndex === 0) {
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(pricing.location_1st || 0);
                            } else {
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(
                                        pricing.additional_location || 0
                                    );
                            }
                            location.decoration_fee = calculatedFeePerItem;
                            location.is_full_color_selected = true;
                            location.full_color_value = fullColorValue;

                            if (total_gender_quantity > 0) {
                                totalCalculatedDecorationFee +=
                                    calculatedFeePerItem *
                                    total_gender_quantity;
                            }
                            this.total_decoration_colors_count += 1; // Count as 1 for full color
                        } else {
                            const color_count =
                                parseInt(location.no_of_color) || 0;
                            this.total_decoration_colors_count += color_count;
                            if (color_count > 0) {
                                let calculatedFeePerItem = 0;
                                if (initalLocationIndex === 0) {
                                    calculatedFeePerItem =
                                        color_count *
                                            parseFloat(
                                                pricing.cost_per_color_1st
                                            ) +
                                        parseFloat(pricing.location_1st);
                                } else {
                                    calculatedFeePerItem =
                                        color_count *
                                            parseFloat(
                                                pricing.cost_per_color_2ndormore
                                            ) +
                                        parseFloat(pricing.additional_location);
                                }
                                location.decoration_fee = calculatedFeePerItem;
                                location.is_full_color_selected = false;

                                if (total_gender_quantity > 0) {
                                    totalCalculatedDecorationFee +=
                                        calculatedFeePerItem *
                                        total_gender_quantity;
                                }
                            }
                        }
                        initalLocationIndex++;
                    }
                });
            } else if (activeService.use_imprintcity_price_template === 1) {
                if (
                    this.product.decoration_type == 1 ||
                    this.product.decoration_type == 5
                ) {
                    // Old Print Logic
                    this.imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            // Check if "Full color" is selected
                            if (
                                location.no_of_color === "full_color" ||
                                location.is_full_color === true
                            ) {
                                // Use full_color value from decoration service JSON for run charge
                                const fullColorValue = parseFloat(
                                    activeService.full_color || 0
                                );
                                let calculatedFeePerItem = 0;

                                // For ImprintCity, we still need to handle location fees
                                if (initalLocationIndex == 0) {
                                    // First location - full color value only (no location fee for first location in old logic)
                                    calculatedFeePerItem = fullColorValue;
                                } else {
                                    // Additional locations - need to get location fee from template
                                    const additionalLocationPrice =
                                        this.getDecorationPrice(
                                            0,
                                            undefined,
                                            true // is additional location
                                        );
                                    calculatedFeePerItem =
                                        fullColorValue +
                                        parseFloat(
                                            additionalLocationPrice || 0
                                        );
                                }

                                location.decoration_fee = calculatedFeePerItem;
                                location.total_decoration_fee =
                                    parseFloat(location.decoration_fee) *
                                    total_gender_quantity;
                                location.is_full_color_selected = true;
                                location.full_color_value = fullColorValue;
                                totalCalculatedDecorationFee +=
                                    location.total_decoration_fee;
                                this.total_decoration_colors_count += 1; // Count as 1 for full color
                            } else {
                                const no_of_colors =
                                    parseInt(location.no_of_color) || 0;
                                const pricing = activeService.master_service || {};
                                const additionalLocationBase = parseFloat(
                                    pricing.additional_location || 0
                                );
                                const addlColorUnit = parseFloat(
                                    pricing.cost_per_color_2ndormore || 0
                                );

                                if (no_of_colors > 0) {
                                    let calculatedFeePerItem = 0;

                                    if (initalLocationIndex === 0) {
                                        // First location: template delta for additional colors only
                                        if (no_of_colors === 1) {
                                            calculatedFeePerItem = 0;
                                        } else {
                                            const decoration_price =
                                                this.getDecorationPrice(
                                                    no_of_colors - 1,
                                                    undefined,
                                                    false
                                                );
                                            const color1_decoration_price =
                                                this.getDecorationPrice(
                                                    0,
                                                    undefined,
                                                    false
                                                );
                                            calculatedFeePerItem =
                                                parseFloat(decoration_price) -
                                                parseFloat(
                                                    color1_decoration_price
                                                );
                                            calculatedFeePerItem +=
                                                addlColorUnit *
                                                Math.max(0, no_of_colors - 1);
                                        }
                                    } else {
                                        // Additional locations (print): match UseImprintCalculator type-1 logic
                                        calculatedFeePerItem += additionalLocationBase;

                                        if (no_of_colors > 0) {
                                            const templateColorN = parseFloat(
                                                this.getDecorationPrice(
                                                    no_of_colors - 1,
                                                    undefined,
                                                    true
                                                ) || 0
                                            );
                                            calculatedFeePerItem +=
                                                (templateColorN + addlColorUnit) *
                                                no_of_colors;
                                        }
                                    }

                                    location.decoration_fee = calculatedFeePerItem;
                                    location.total_decoration_fee =
                                        parseFloat(location.decoration_fee) *
                                        total_gender_quantity;
                                    totalCalculatedDecorationFee +=
                                        location.total_decoration_fee;
                                } else {
                                    location.decoration_fee = 0;
                                    location.total_decoration_fee = 0;
                                }
                                location.is_full_color_selected = false;
                                this.total_decoration_colors_count +=
                                    no_of_colors;
                            }
                            initalLocationIndex++;
                        }
                    });
                } else if (this.product.decoration_type == 2 || this.product.decoration_type == 4) {
                    // Old Embroidery Logic
                    this.imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            // Check if "Full color" is selected
                            if (
                                location.no_of_color === "full_color" ||
                                location.is_full_color === true
                            ) {
                                // Use full_color value from decoration service JSON for run charge
                                const fullColorValue = parseFloat(
                                    activeService.full_color || 0
                                );
                                let calculatedFeePerItem = 0;

                                if (initalLocationIndex == 0) {
                                    // First location - full color value only (no location fee for first location in old logic)
                                    calculatedFeePerItem = fullColorValue;
                                } else {
                                    // Additional locations - need to get location fee from template
                                    let decoration_price =
                                        this.getDecorationPrice(
                                            0,
                                            initalLocationIndex
                                        );
                                    calculatedFeePerItem =
                                        fullColorValue +
                                        parseFloat(decoration_price || 0);
                                }

                                location.decoration_fee = calculatedFeePerItem;
                                location.total_decoration_fee =
                                    parseFloat(location.decoration_fee) *
                                    total_gender_quantity;
                                location.is_full_color_selected = true;
                                location.full_color_value = fullColorValue;
                                totalCalculatedDecorationFee +=
                                    location.total_decoration_fee;
                                this.total_decoration_colors_count += 1; // Count as 1 for full color
                            } else {
                                const no_of_colors =
                                    parseInt(location.no_of_color) || 0;
                                const pricing =
                                    activeService.master_service || {};
                                const additionalLocationBase = parseFloat(
                                    pricing.additional_location || 0
                                );
                                const firstColorUnit = parseFloat(
                                    pricing.cost_per_color_1st || 0
                                );
                                const addlColorUnit = parseFloat(
                                    pricing.cost_per_color_2ndormore || 0
                                );

                                if (initalLocationIndex === 0) {
                                    location.decoration_fee = 0;
                                    location.total_decoration_fee = 0;
                                } else {
                                    const embroideryLocationUnit = parseFloat(
                                        this.getDecorationPrice(
                                            0,
                                            initalLocationIndex
                                        ) || 0
                                    );

                                    let calculatedFeePerItem = 0;
                                    calculatedFeePerItem += embroideryLocationUnit;
                                    calculatedFeePerItem += additionalLocationBase;

                                    if (no_of_colors > 0) {
                                        // For embroidery additional locations, color charge applies
                                        // to all selected colors (no separate first-color row).
                                        calculatedFeePerItem +=
                                            addlColorUnit * no_of_colors;
                                    }

                                    location.decoration_fee = calculatedFeePerItem;
                                    location.total_decoration_fee =
                                        parseFloat(location.decoration_fee) *
                                        total_gender_quantity;
                                    totalCalculatedDecorationFee +=
                                        location.total_decoration_fee;
                                }
                                location.is_full_color_selected = false;
                                // This is not used for embroidery pricing but we keep it for consistency if needed elsewhere.
                                this.total_decoration_colors_count +=
                                    no_of_colors;
                            }
                            initalLocationIndex++;
                        }
                    });
                }
            }

            return totalCalculatedDecorationFee;
        },

        getTotalItemQuantity(gender_element) {
            if (!gender_element || !gender_element.selected_colors) {
                return 0;
            }
            let total_quantity = 0;
            gender_element.selected_colors.forEach((color) => {
                color.unique_sizes.forEach((size) => {
                    if (size.quantity > 0) {
                        total_quantity += parseInt(size.quantity);
                    }
                });
            });
            return total_quantity;
        },

        getRetailPrice(prices) {
            // console.log("prices", prices);
            let item_price = 0;
            if (prices.base_price) {
                item_price += parseFloat(prices.base_price);
            }

            if (prices.markup_price) {
                item_price += parseFloat(prices.markup_price);
            }

            if (prices.single_location_price) {
                item_price += parseFloat(prices.single_location_price);
            }

            if (prices.color_category_price) {
                item_price += parseFloat(prices.color_category_price);
            }

            if (prices.decoration_discount_percentage) {
                let decoration_discount_value =
                    (this.icPriceFormat(item_price, true) *
                        parseFloat(prices.decoration_discount_percentage)) /
                    100;
                item_price -= parseFloat(decoration_discount_value);
            }

            return item_price;
        },

        // Get size cost with discount applied if activeProductDiscount exists
        getSizeCostWithDiscount(originalCost) {
            if (!originalCost || originalCost <= 0) {
                return originalCost;
            }

            const activeDiscount = this.activeProductDiscount;
            if (!activeDiscount) {
                return originalCost;
            }

            const discountType = activeDiscount.discount_type;
            const discountValue = parseFloat(
                activeDiscount.discount_value || 0
            );

            if (discountType === "Percent") {
                return parseFloat(
                    (originalCost * (1 - discountValue / 100)).toFixed(2)
                );
            } else {
                // Fixed amount discount
                return parseFloat(
                    Math.max(0, originalCost - discountValue).toFixed(2)
                );
            }
        },

        calculatePricing(index, size, event = null) {
            var _this = this;
            const activeService = this.activeDecorationService;
            if (!activeService) {
                return;
            }

            const flag = activeService.use_imprintcity_price_template;
            const current_decoration_type = activeService.decoration_type;

            if (flag === 0) {
                this.calculateNewTierPricing(index);
            } else {
                if (
                    current_decoration_type == 1 ||
                    current_decoration_type == 5
                ) {
                    this.calculateOldPrintPricing(index);
                } else if (current_decoration_type == 2 || current_decoration_type == 4) {
                    this.calculateOldEmbroideryPricing(index);
                }
            }
            let total_qty = 0;
            this.gender_groups.forEach((gender) => {
                total_qty += gender.total_qty_gender_wise;
            });
            this.disable_btns = total_qty === 0;
        },

        calculateNewTierPricing(index) {
            let gender_element = this.gender_groups[index];
            if (
                !gender_element ||
                !Array.isArray(gender_element["selected_colors"])
            ) {
                return;
            }
            // Reset all relevant values before recalculating
            gender_element.total_qty_gender_wise = 0;
            gender_element.subtotal = 0; // This will hold the undiscounted base cost of all items.
            gender_element.total_cost_gender_wise = 0;
            gender_element.total_discount_value = 0; // This will store the final calculated discount amount.
            gender_element.total_design_fee = 0;
            gender_element.total_color_fee = 0;

            const activeService = this.activeDecorationService;
            const priceData = activeService.price_decoration_bulk;
            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);
            let found_tier = null;

            // Find the correct pricing tier based on the total quantity.
            if (priceData && priceData.length > 0) {
                found_tier = priceData[0]; // Default to the first tier.
                for (const tier of priceData) {
                    if (tier.quantity <= total_group_quantity) {
                        found_tier = tier;
                    } else {
                        break;
                    }
                }
            }

            let tier_retail_cost = found_tier
                ? parseFloat(found_tier.retail_cost || 0)
                : 0;

            //Calculate subtotal (base cost) for all items WITHOUT applying any discounts
            gender_element["selected_colors"].forEach((color) => {
                // Reset color-specific values
                color.total_qty_gender_wise = 0;
                color.subtotal = 0;
                color.total_cost_gender_wise = 0;
                color.total_discount_value = 0;
                color.total_design_fee = 0;

                if (color.total_qty_gender_wise > 0) {
                    color.total_design_fee = this.design_fee;
                }

                color["unique_sizes"].forEach((size) => {
                    size.cost = tier_retail_cost;
                    size.discount = 0;

                    let color_category_price = this.getDarkLightFees(color);
                    let cost_per_item_with_fee =
                        size.cost + color_category_price;

                    size.total_cost =
                        size.quantity > 0
                            ? cost_per_item_with_fee * parseInt(size.quantity)
                            : 0;

                    if (size.quantity > 0) {
                        color.total_qty_gender_wise += parseInt(size.quantity);
                        color.subtotal += size.total_cost;
                    }
                });

                color.total_cost_gender_wise =
                    color.subtotal + color.total_design_fee;

                // Aggregate values up to the gender level.
                gender_element.total_qty_gender_wise +=
                    color.total_qty_gender_wise;
                gender_element.subtotal += color.subtotal; // `subtotal` is now the sum of all UNDISCOUNTED item prices.
                gender_element.total_design_fee += color.total_design_fee;
            });

            // Calculate all other fees and the total before discount
            const totalDecorationFee = this.calcImprintLocationByGender(index);
            gender_element.total_color_fee = totalDecorationFee;

            this.setup_fee = this.calculateSetupFee(
                activeService,
                gender_element.total_qty_gender_wise,
                this.total_decoration_colors_count
            );

            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        // Multiply by quantity if it's 'Per Item'
                        return total + cost * total_group_quantity;
                    } else {
                        // Otherwise, just add the flat fee
                        return total + cost;
                    }
                },
                0
            );

            // This is the grand total of all charges
            const preDiscountTotal =
                gender_element.subtotal +
                gender_element.total_design_fee +
                totalDecorationFee +
                this.setup_fee +
                otherServicesTotal;

            // Discount calculation removed - no longer applying overall discount
            gender_element.total_discount_value = 0;

            // Total cost is now the pre-discount total (no discount applied)
            gender_element.total_cost_gender_wise = preDiscountTotal;
            const finalTotalCost = preDiscountTotal;

            // Create run charge details array with full color breakdown
            const runChargeDetails = [];
            if (totalDecorationFee > 0) {
                // Build detailed breakdown by location
                this.imprint_locations.forEach((location, locIndex) => {
                    if (location.is_selected && location.decoration_fee > 0) {
                        if (
                            location.is_full_color_selected &&
                            location.full_color_value
                        ) {
                            // Full color location - don't add to runChargeDetails
                            // Location Fee and Full Color entries removed as per requirement
                        } else {
                            // Regular color location
                            // Location-specific Run Charge entries removed - not showing in breakdown
                            // const locationName =
                            //     locIndex === 0
                            //         ? "Location 1"
                            //         : `Location ${locIndex + 1}`;
                            // runChargeDetails.push({
                            //     name: `${locationName} Run Charge`,
                            //     value: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     unitPrice: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     quantity: gender_element.total_qty_gender_wise
                            // });
                        }
                    }
                });

                // If no detailed breakdown, add general location run charge
                // if (runChargeDetails.length === 0) {
                //     runChargeDetails.push({
                //         name: "Location(s) Run Charge",
                //         value: parseFloat(totalDecorationFee.toFixed(2))
                //     });
                // }
            }

            // Populate the `currentBreakdown` object for the display component
            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: totalDecorationFee,
                setupFee: this.setup_fee,
                totalCost: finalTotalCost,
                totalDiscount: gender_element.total_discount_value,
                designFee: gender_element.total_design_fee,
                runChargeDetails: runChargeDetails
            };

            this.$forceUpdate();
        },

        calculateOldPrintPricing(index) {
            const activeService = this.activeDecorationService;
            let gender_element = this.gender_groups[index];
            if (!gender_element) {
                return;
            }
            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);

            // Reset all gender-level totals
            gender_element.total_discount_value = 0;
            gender_element.total_qty_gender_wise = 0;
            gender_element.total_cost_gender_wise = 0;
            gender_element.total_color_fee = 0;
            gender_element.subtotal = 0;
            this.setup_fee = 0;

            if (gender_element["selected_colors"]) {
                // Get the tier-based decoration price and discount ONCE for the current quantity tier.
                let single_location_price = this.getDecorationPrice();
                let decoration_discount_percentage =
                    this.getDecorationDiscount();

                gender_element["selected_colors"].forEach(
                    (selected_color_obj) => {
                        // Reset color-level totals
                        selected_color_obj.total_qty_gender_wise = 0;
                        selected_color_obj.subtotal = 0;
                        selected_color_obj.total_cost_gender_wise = 0;

                        // Loop through each size
                        selected_color_obj["unique_sizes"].forEach((size) => {
                            let base_price =
                                size.price_base || this.product.price_base;

                            const activeService = this.activeDecorationService;
                            const markup_percentage =
                                this.getResolvedMarkupPercentage(
                                    base_price,
                                    this.product.decoration_type,
                                    this.product.decoration_price_template,
                                    activeService
                                        ? activeService.markup_percentage
                                        : null
                                );
                            let mark_up_cost = parseFloat(
                                (
                                    (parseFloat(base_price) *
                                        parseFloat(markup_percentage)) /
                                    100
                                ).toFixed(2)
                            );
                            size.markup_price = mark_up_cost;
                            let color_category_price =
                                this.getDarkLightFees(selected_color_obj);

                            // OLD BEHAVIOR (kept for future rollback):
                            // Discount was applied only on single-location price.
                            // let decoration_discount_amount =
                            //     (parseFloat(single_location_price) *
                            //         parseFloat(
                            //             decoration_discount_percentage
                            //         )) /
                            //     100;
                            // let discounted_decoration_price =
                            //     parseFloat(single_location_price) -
                            //     decoration_discount_amount;

                            // Apply template discount on combined size Product Base Price
                            // (base + markup + single-location + color category).
                            let sizeBaseCostBeforeDiscount =
                                parseFloat(base_price) +
                                parseFloat(mark_up_cost) +
                                parseFloat(color_category_price) +
                                parseFloat(single_location_price);

                            if (parseFloat(decoration_discount_percentage) > 0) {
                                sizeBaseCostBeforeDiscount =
                                    sizeBaseCostBeforeDiscount *
                                    (1 -
                                        parseFloat(
                                            decoration_discount_percentage
                                        ) /
                                            100);
                            }

                            size.cost = sizeBaseCostBeforeDiscount;

                            size.single_location_price = single_location_price;
                            size.decoration_discount_percentage =
                                decoration_discount_percentage;

                            // Only if there is a quantity, calculate totals
                            if (size.quantity && size.quantity > 0) {
                                size.total_cost =
                                    this.icPriceFormat(size.cost, true) *
                                    parseInt(size.quantity);
                                selected_color_obj.subtotal += parseFloat(
                                    size.total_cost
                                );
                                selected_color_obj.total_cost_gender_wise +=
                                    parseFloat(size.total_cost);
                                selected_color_obj.total_qty_gender_wise +=
                                    parseInt(size.quantity);
                            } else {
                                size.total_cost = 0;
                            }
                        });

                        // Aggregate up to the gender level
                        gender_element.subtotal += parseFloat(
                            selected_color_obj.subtotal
                        );
                        gender_element.total_qty_gender_wise += parseFloat(
                            selected_color_obj.total_qty_gender_wise
                        );
                    }
                );
            }

            const total_decoration_fee =
                this.calcImprintLocationByGender(index);
            this.setup_fee = this.calculateSetupFee(
                activeService,
                gender_element.total_qty_gender_wise,
                this.total_decoration_colors_count
            );
            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        return total + cost * total_group_quantity;
                    } else {
                        return total + cost;
                    }
                },
                0
            );

            const preDiscountTotal =
                gender_element.subtotal +
                total_decoration_fee +
                this.setup_fee +
                otherServicesTotal;

            // Discount calculation removed - no longer applying overall discount
            gender_element.total_discount_value = 0;

            gender_element.total_color_fee = parseFloat(total_decoration_fee);
            gender_element.total_cost_gender_wise = preDiscountTotal;

            // Create run charge details array with full color breakdown
            const runChargeDetails = [];
            if (gender_element.total_color_fee > 0) {
                // Build detailed breakdown by location
                this.imprint_locations.forEach((location, locIndex) => {
                    if (location.is_selected && location.decoration_fee > 0) {
                        if (
                            location.is_full_color_selected &&
                            location.full_color_value
                        ) {
                            // Full color location
                            const locationName =
                                locIndex === 0
                                    ? "Location 1"
                                    : `Location ${locIndex + 1}`;
                            // Full Color entry removed - not added to runChargeDetails
                            // Add location fee if applicable (for additional locations)
                            if (
                                locIndex > 0 &&
                                location.total_decoration_fee >
                                    location.full_color_value *
                                        gender_element.total_qty_gender_wise
                            ) {
                                const locationFee =
                                    (location.total_decoration_fee -
                                        location.full_color_value *
                                            gender_element.total_qty_gender_wise) /
                                    gender_element.total_qty_gender_wise;
                                if (locationFee > 0) {
                                    // Location Fee entry removed - not added to runChargeDetails
                                }
                            }
                        } else {
                            // Regular color location
                            // Location-specific Run Charge entries removed - not showing in breakdown
                            // const locationName =
                            //     locIndex === 0
                            //         ? "Location 1"
                            //         : `Location ${locIndex + 1}`;
                            // runChargeDetails.push({
                            //     name: `${locationName} Run Charge`,
                            //     value: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     unitPrice: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     quantity: gender_element.total_qty_gender_wise
                            // });
                        }
                    }
                });

                // If no detailed breakdown, add general location run charge
                // if (runChargeDetails.length === 0) {
                //     runChargeDetails.push({
                //         name: "Location(s) Run Charge",
                //         value: parseFloat(
                //             gender_element.total_color_fee.toFixed(2)
                //         )
                //     });
                // }
            }

            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: gender_element.total_color_fee,
                setupFee: this.setup_fee,
                totalCost: gender_element.total_cost_gender_wise,
                totalDiscount: gender_element.total_discount_value,
                designFee: 0,
                runChargeDetails: runChargeDetails
            };

            this.$forceUpdate();
        },
        calculateOldEmbroideryPricing(index) {
            const activeService = this.activeDecorationService;
            let gender_element = this.gender_groups[index];
            if (!gender_element) {
                return;
            }
            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);
            // Reset all gender-level totals
            gender_element.total_discount_value = 0; // Promotional Discount
            gender_element.total_qty_gender_wise = 0;
            gender_element.total_cost_gender_wise = 0;
            gender_element.total_color_fee = 0;
            gender_element.subtotal = 0; // Item total (after decoration discount)
            this.setup_fee = 0;

            if (gender_element["selected_colors"]) {
                // Get tier price and discount ONCE
                let single_location_price = this.getDecorationPrice();
                let decoration_discount_percentage =
                    this.getDecorationDiscount();

                gender_element["selected_colors"].forEach(
                    (selected_color_obj) => {
                        // Reset color-level totals
                        selected_color_obj.total_qty_gender_wise = 0;
                        selected_color_obj.subtotal = 0;
                        selected_color_obj.total_cost_gender_wise = 0;

                        // Loop through each size
                        selected_color_obj["unique_sizes"].forEach((size) => {
                            // Store current tier's price and discount on the size object
                            size.single_location_price = single_location_price;
                            size.decoration_discount_percentage =
                                decoration_discount_percentage;

                            let base_price =
                                size.price_base || this.product.price_base;
                            const activeService = this.activeDecorationService;
                            const markup_percentage =
                                this.getResolvedMarkupPercentage(
                                    base_price,
                                    this.product.decoration_type,
                                    this.product.decoration_price_template,
                                    activeService
                                        ? activeService.markup_percentage
                                        : null
                                );
                            let mark_up_cost = parseFloat(
                                (
                                    (parseFloat(base_price) *
                                        parseFloat(markup_percentage)) /
                                    100
                                ).toFixed(2)
                            );
                            size.markup_price = mark_up_cost;
                            let color_category_price =
                                this.getDarkLightFees(selected_color_obj);

                            // OLD BEHAVIOR (kept for future rollback):
                            // Discount was applied only on single-location price.
                            // let decoration_discount_amount =
                            //     (parseFloat(size.single_location_price) *
                            //         parseFloat(
                            //             size.decoration_discount_percentage
                            //         )) /
                            //     100;
                            // let discounted_decoration_price =
                            //     parseFloat(size.single_location_price) -
                            //     decoration_discount_amount;

                            // Apply template discount on combined size Product Base Price
                            // (base + markup + single-location + color category).
                            let sizeBaseCostBeforeDiscount =
                                parseFloat(base_price) +
                                parseFloat(mark_up_cost) +
                                parseFloat(color_category_price) +
                                parseFloat(size.single_location_price);

                            if (
                                parseFloat(size.decoration_discount_percentage) >
                                0
                            ) {
                                sizeBaseCostBeforeDiscount =
                                    sizeBaseCostBeforeDiscount *
                                    (1 -
                                        parseFloat(
                                            size.decoration_discount_percentage
                                        ) /
                                            100);
                            }

                            size.cost = sizeBaseCostBeforeDiscount;

                            // Calculate totals only if quantity exists
                            if (size.quantity && size.quantity > 0) {
                                size.total_cost =
                                    this.icPriceFormat(size.cost, true) *
                                    parseInt(size.quantity);
                                selected_color_obj.subtotal += parseFloat(
                                    size.total_cost
                                );
                                selected_color_obj.total_cost_gender_wise +=
                                    parseFloat(size.total_cost);
                                selected_color_obj.total_qty_gender_wise +=
                                    parseInt(size.quantity);
                            } else {
                                size.total_cost = 0;
                            }
                        });

                        // Aggregate up to the gender level
                        gender_element.subtotal += parseFloat(
                            selected_color_obj.subtotal
                        );
                        gender_element.total_qty_gender_wise += parseFloat(
                            selected_color_obj.total_qty_gender_wise
                        );
                    }
                );
            }

            const total_decoration_fee =
                this.calcImprintLocationByGender(index);
            this.setup_fee = this.calculateSetupFee(
                activeService,
                gender_element.total_qty_gender_wise,
                this.total_decoration_colors_count
            );
            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        return total + cost * total_group_quantity;
                    } else {
                        return total + cost;
                    }
                },
                0
            );

            const preDiscountTotal =
                gender_element.subtotal +
                total_decoration_fee +
                this.setup_fee +
                otherServicesTotal;

            // Discount calculation removed - no longer applying overall discount
            gender_element.total_discount_value = 0;

            gender_element.total_color_fee = parseFloat(total_decoration_fee);
            gender_element.total_cost_gender_wise = preDiscountTotal;

            // Create run charge details array with full color breakdown
            const runChargeDetails = [];
            if (gender_element.total_color_fee > 0) {
                // Build detailed breakdown by location
                this.imprint_locations.forEach((location, locIndex) => {
                    if (location.is_selected && location.decoration_fee > 0) {
                        if (
                            location.is_full_color_selected &&
                            location.full_color_value
                        ) {
                            // Full color location
                            const locationName =
                                locIndex === 0
                                    ? "Location 1"
                                    : `Location ${locIndex + 1}`;
                            // Full Color entry removed - not added to runChargeDetails
                            // Add location fee if applicable (for additional locations)
                            if (
                                locIndex > 0 &&
                                location.total_decoration_fee >
                                    location.full_color_value *
                                        gender_element.total_qty_gender_wise
                            ) {
                                const locationFee =
                                    (location.total_decoration_fee -
                                        location.full_color_value *
                                            gender_element.total_qty_gender_wise) /
                                    gender_element.total_qty_gender_wise;
                                if (locationFee > 0) {
                                    // Location Fee entry removed - not added to runChargeDetails
                                }
                            }
                        } else {
                            // Regular color location
                            // Location-specific Run Charge entries removed - not showing in breakdown
                            // const locationName =
                            //     locIndex === 0
                            //         ? "Location 1"
                            //         : `Location ${locIndex + 1}`;
                            // runChargeDetails.push({
                            //     name: `${locationName} Run Charge`,
                            //     value: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     unitPrice: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     quantity: gender_element.total_qty_gender_wise
                            // });
                        }
                    }
                });

                // If no detailed breakdown, add general location run charge
                // if (runChargeDetails.length === 0) {
                //     runChargeDetails.push({
                //         name: "Location(s) Run Charge",
                //         value: parseFloat(
                //             gender_element.total_color_fee.toFixed(2)
                //         )
                //     });
                // }
            }

            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: gender_element.total_color_fee,
                setupFee: this.setup_fee,
                totalCost: gender_element.total_cost_gender_wise,
                totalDiscount: gender_element.total_discount_value,
                designFee: 0,
                runChargeDetails: runChargeDetails
            };
            this.$forceUpdate();
        },

        calculateSetupFee(activeService, totalQuantity, totalColors) {
            if (!activeService || totalQuantity <= 0) {
                return 0;
            }

            const decorationType =
                parseInt(activeService.decoration_type) ||
                parseInt(this.product.decoration_type) ||
                0;
            const useProductSetupFeeSource =
                decorationType === 1 ||
                decorationType === 5 ||
                decorationType === 2 ||
                decorationType === 4;
            const pricing = useProductSetupFeeSource
                ? activeService.product_master_service || {}
                : activeService.master_service || {};
            if (!pricing || Object.keys(pricing).length === 0) {
                return 0;
            }
            const feeStructure = pricing.fee_structure;
            let calculatedFee = 0;

            // Check if any location has full color selected
            let hasFullColor = false;
            if (this.imprint_locations && this.imprint_locations.length > 0) {
                hasFullColor = this.imprint_locations.some(
                    (location) =>
                        location.is_selected &&
                        (location.is_full_color_selected === true ||
                            location.no_of_color === "full_color")
                );
            }

            // If full color is selected, use setup_fee_multicolor (independent of fee structure)
            if (hasFullColor) {
                calculatedFee = parseFloat(pricing.setup_fee_multicolor || 0);
            } else {
                // Normal logic when full color is not selected
                if (feeStructure == "1") {
                    calculatedFee =
                        parseFloat(pricing.setup_fee_color1 || 0) * totalColors;
                } else if (feeStructure == "2") {
                    if (totalColors === 1) {
                        calculatedFee = parseFloat(
                            pricing.setup_fee_color1 || 0
                        );
                    } else if (totalColors > 1) {
                        calculatedFee = parseFloat(
                            pricing.setup_fee_multicolor || 0
                        );
                    }
                }
            }
            return calculatedFee;
        },
        getDecorationPrice(
            colorIndex = 0,
            locationIndex = undefined,
            additional = false
        ) {
            let qty_wise_color_price = 0;

            let total_qty_gender_wise = this.getTotalItemQuantity(
                this.gender_groups[this.is_active]
            );

            if (
                this.product.decoration_type == 1 ||
                this.product.decoration_type == 5
            ) {
                let decoration_data;

                if (!additional) {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location1;
                } else {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location2;
                }

                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity <= total_group_quantity ||
                        index == 0
                    ) {
                        qty_wise_color_price =
                            element[`colour${colorIndex + 1}`];
                    }
                }
            } else if (this.product.decoration_type == 2 || this.product.decoration_type == 4) {
                let decoration_data = this.product.price_decoration_bulk;
                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity1 <= total_group_quantity ||
                        index == 0
                    ) {
                        if (locationIndex > 0) {
                            qty_wise_color_price =
                                element[`location${locationIndex + 1}`];
                        } else {
                            qty_wise_color_price = element["cost"];
                        }
                    }
                }
            }

            return parseFloat(qty_wise_color_price || 0);
        },

        getDecorationDiscount(additional = false) {
            let discount = 0;

            let total_qty_gender_wise = this.getTotalItemQuantity(
                this.gender_groups[this.is_active]
            );

            if (
                this.product.decoration_type == 1 ||
                this.product.decoration_type == 5
            ) {
                let decoration_data;

                if (!additional) {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location1;
                } else {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location2;
                }

                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity <= total_group_quantity ||
                        index == 0
                    ) {
                        discount = element["discount"];
                    }
                }
            } else if (this.product.decoration_type == 2 || this.product.decoration_type == 4) {
                let decoration_data = this.product.price_decoration_bulk;
                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity1 <= total_group_quantity ||
                        index == 0
                    ) {
                        discount = element["discount"];
                    }
                }
            }

            return parseFloat(discount || 0);
        },

        onChangeGenderColor() {
            let _this = this;
            let final_thumb_array = [];
            let final_normal_array = [];
            let common_thumb_array = [];
            let common_normal_array = [];

            // Get selected colors array (maintains FIFO order - first selected first)
            let selected_colors = [];
            if (
                _this.gender_groups &&
                _this.gender_groups[_this.is_active] &&
                _this.gender_groups[_this.is_active]["selected_colors"] &&
                Array.isArray(
                    _this.gender_groups[_this.is_active]["selected_colors"]
                )
            ) {
                selected_colors =
                    _this.gender_groups[_this.is_active]["selected_colors"];
            }

            // If no colors selected, use default color as fallback
            if (selected_colors.length === 0 && _this.default_selected_color) {
                selected_colors = [_this.default_selected_color];
            }

            if (_this.product.NewProductImages) {
                // Process each selected color sequentially (one color's images complete, then next color)
                selected_colors.forEach((selectedColor) => {
                    if (!selectedColor || !selectedColor.id) return;

                    // For this color, collect images by view type so order is always F, B, L, R, then others
                    const frontImages = [];
                    const backImages = [];
                    const leftImages = [];
                    const rightImages = [];
                    const otherImages = [];

                    _this.product.NewProductImages.forEach((element) => {
                        if (!element.color_id || element.color_id !== selectedColor.id) {
                            return;
                        }

                        const imageType = (element.type || "").toLowerCase();
                        const isFront =
                            imageType === "front" || imageType === "f";
                        const isBack =
                            imageType === "back" || imageType === "b";
                        const isLeft =
                            imageType === "left" || imageType === "l";
                        const isRight =
                            imageType === "right" || imageType === "r";

                        const targetArray = isFront
                            ? frontImages
                            : isBack
                            ? backImages
                            : isLeft
                            ? leftImages
                            : isRight
                            ? rightImages
                            : otherImages;

                        targetArray.push({
                            id: element.id,
                            url: element.url,
                            thumb_url: element.thumbnail,
                            type: "image"
                        });
                    });

                    const orderedForColor = [
                        ...frontImages,
                        ...backImages,
                        ...leftImages,
                        ...rightImages,
                        ...otherImages
                    ];

                    orderedForColor.forEach((img) => {
                        final_thumb_array.push({
                            id: img.id,
                            url: img.url,
                            thumb_url: img.thumb_url,
                            type: img.type
                        });
                        final_normal_array.push({
                            id: img.id,
                            url: img.url,
                            type: img.type
                        });
                    });
                });

                // Finally, add all generic images (without color_id) at the end
                _this.product.NewProductImages.forEach((element) => {
                    if (!element.color_id) {
                        common_thumb_array.push({
                            id: element.id,
                            url: element.url,
                            thumb_url: element.thumbnail,
                            type: "image"
                        });
                        common_normal_array.push({
                            id: element.id,
                            url: element.url,
                            type: "image"
                        });
                    }
                });
            }

            // Combine: all selected colors' images (in order), then generic images
            final_thumb_array = [...final_thumb_array, ...common_thumb_array];
            final_normal_array = [...final_normal_array, ...common_normal_array];

            // Add video if it exists
            if (
                _this.product.video_url &&
                _this.product.video_url.trim() != ""
            ) {
                final_thumb_array.push({
                    id: _this.product.id,
                    url: _this.product.video_url,
                    thumb_url: _this.product.video_url,
                    type: "video"
                });
                final_normal_array.push({
                    id: _this.product.id,
                    url: _this.product.video_url,
                    type: "video"
                });
            }

            _this.images = {
                thumbs: final_thumb_array,
                normal_size: final_normal_array
            };
        },

        getFavoriteProduct(product) {
            var _this = this;
            if (_this.currentUserClient.id) {
                new Promise(() => {
                    _this.isBusy = true;
                    ApiService.get("/favorite-product/" + product.id)
                        .then(({ data }) => {
                            _this.favorite_product = data.favorite_product;
                            _this.is_favorite_product = data.favorite_product.id
                                ? true
                                : false;
                            _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            console.log(response);
                        });
                });
            }
        },

        addToFavorite(product) {
            var _this = this;
            // setTimeout(() => {
            if (_this.currentUserClient.id) {
                new Promise(() => {
                    // _this.isBusy = true;
                    let post_data = { product_id: product.id };
                    ApiService.post("/favorite-product", post_data)
                        .then(({ data }) => {
                            if (data.success) {
                                _this.$toast.success(data.message, {
                                    position: "top-right",
                                    queue: true
                                });
                            }
                            _this.is_favorite_product = true;
                            _this.getFavoriteProduct(_this.product);
                            // _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            console.log(response);
                        });
                });
            }
            // }, 1000);
        },

        getGendersGroups(gendersGroup) {
            return new Promise((resolve, reject) => {
                ApiService.post("/gender-age-sizes-byIds/", gendersGroup)
                    .then(({ data }) => {
                        if (data.success == true) {
                            data.genderagesize.forEach((elem) => {
                                let allsizes = [];
                                let usizes = [];
                                let sizes = JSON.parse(elem.sizes);
                                // sizes.forEach(element => {
                                this.product.MainNewSubProducts.forEach(
                                    (elm) => {
                                        if (sizes.includes(elm.size_id)) {
                                            if (
                                                !allsizes.find(
                                                    (s) =>
                                                        s.size_id == elm.size_id
                                                )
                                            ) {
                                                usizes.push(elm);
                                            }
                                            allsizes.push(elm);
                                        }
                                    }
                                );
                                // });
                                if (allsizes.length > 0) {
                                    this.gender_groups.push({
                                        id: elem.id,
                                        prod_type_id: elem.prod_type_id,
                                        gender: elem.gender,
                                        total_cost_gender_wise: 0,
                                        total_qty_gender_wise: 0,
                                        total_cost: 0,
                                        sizes: allsizes,
                                        selected_colors: []
                                    });
                                }
                            });
                        } else {
                            this.$toast.error(data.error, {
                                position: "top-right"
                            });
                        }
                        resolve(data);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },

        /**
         * Get the minimum and maximum available sizes for a gender group
         * Only considers sizes with status = true from the original product data (not user-entered quantities)
         * @param {Object} gender - The gender group object
         * @returns {String} - Size range string like "XS-3XL" or the original gender name if no sizes available
         */
        getAvailableSizeRange(gender) {
            if (!gender) {
                return "";
            }

            // Collect all available sizes based on original product data (status), not user-entered quantities
            const availableSizes = new Set();
            
            // Check all sizes in gender group - use status property to determine availability
            // This is based on the original product data, not user-entered quantities
            if (gender.sizes && Array.isArray(gender.sizes)) {
                gender.sizes.forEach((size) => {
                    // Only check status property - this indicates if size is available in the product
                    // Do NOT check quantity as that is user input and changes dynamically
                    const isAvailable = size.status === true || size.status === 1 || size.status === "1";
                    
                    if (isAvailable) {
                        // Extract size abbreviation
                        let sizeAbbr = null;
                        if (size.Size && size.Size.size) {
                            sizeAbbr = size.Size.size;
                        } else if (size.size_name) {
                            sizeAbbr = size.size_name;
                        } else if (size.size) {
                            const sizeParts = size.size.trim().split(/\s+/);
                            sizeAbbr = sizeParts[sizeParts.length - 1];
                        } else if (size.name) {
                            const nameParts = size.name.trim().split(/\s+/);
                            sizeAbbr = nameParts[nameParts.length - 1];
                        }

                        if (sizeAbbr) {
                            availableSizes.add(sizeAbbr);
                        }
                    }
                });
            }

            // If no available sizes found, return the original gender name
            if (availableSizes.size === 0) {
                return gender.gender || "";
            }

            // Convert Set to Array and sort using the size ordering logic
            const sizeArray = Array.from(availableSizes);
            let sortedSizes = this.sizesArrangmentSorting(sizeArray);

            // If sorting didn't work or returned empty, try to sort manually
            if (!sortedSizes || sortedSizes.length === 0) {
                // Fallback: use the standard size order
                const standardSizeOrder = [
                    "XS", "S", "M", "L", "XL", "XXL", "2XL", "3XL", "4XL", "5XL", "6XL", "7XL", "8XL", "9XL", "10XL", "11XL", "12XL", "13XL", "14XL"
                ];
                sortedSizes = sizeArray.sort((a, b) => {
                    const indexA = standardSizeOrder.indexOf(a);
                    const indexB = standardSizeOrder.indexOf(b);
                    if (indexA === -1 && indexB === -1) return a.localeCompare(b);
                    if (indexA === -1) return 1;
                    if (indexB === -1) return -1;
                    return indexA - indexB;
                });
            }

            // Get min and max
            if (sortedSizes.length === 0) {
                return gender.gender || "";
            }

            const minSize = sortedSizes[0];
            const maxSize = sortedSizes[sortedSizes.length - 1];

            // Extract the base gender name by removing all size patterns
            // This handles cases like:
            // - "Adult Sizes: S/M L/XL" -> "Adult Sizes"
            // - "Adult Sizes XS-6XL" -> "Adult Sizes"
            // - "Men's XS-6XL" -> "Men's"
            let genderName = "";
            if (gender.gender) {
                // First, split by colon to get the base name (before any colon)
                let baseName = gender.gender.split(":")[0].trim();
                
                // Remove all size patterns more aggressively:
                // Pattern 1: Dash-separated size ranges (e.g., "XS-6XL", "S-5XL", "XS-3XL")
                baseName = baseName.replace(/\s*[A-Z0-9\/]+\s*-\s*[0-9]*[A-Z\/]+\s*/gi, "");
                
                // Pattern 2: Space-separated size ranges (e.g., "XS 6XL", "S 5XL")
                baseName = baseName.replace(/\s+[A-Z0-9\/]+\s+[0-9]*[A-Z\/]+\s*/gi, "");
                
                // Pattern 3: Slash-separated sizes (e.g., "S/M", "L/XL", "S/M L/XL")
                baseName = baseName.replace(/\s+[A-Z0-9]+\/[A-Z0-9]+(\s+[A-Z0-9]+\/[A-Z0-9]+)*\s*/gi, "");
                
                // Pattern 4: Individual sizes at the end (e.g., "XS", "S", "M", "L", "XL", "2XL", etc.)
                baseName = baseName.replace(/\s+(XS|S|M|L|XL|XXL|[0-9]+XL)\s*$/i, "");
                
                // Pattern 5: Remove any remaining size-like patterns (numbers followed by XL, XXL, etc.)
                baseName = baseName.replace(/\s+[0-9]*[Xx][Ll]+\s*/gi, "");
                
                // Clean up multiple spaces and trim
                baseName = baseName.replace(/\s+/g, " ").trim();
                
                genderName = baseName;
            }

            // Build the size range string
            let sizeRange = "";
            if (minSize === maxSize) {
                sizeRange = minSize;
            } else {
                sizeRange = `${minSize}-${maxSize}`;
            }

            // Return formatted string
            return genderName ? `${genderName}: ${sizeRange}` : sizeRange;
        },

        loadVendorColors(product) {
            this.imprint_colors_array_for_template = [];
            if (product.Decorators && product.Decorators.length) {
                let vendorColors = [];
                if (product.default_decorator_id) {
                    let default_decorator = product.Decorators.find(
                        (decorator) =>
                            decorator.id == product.default_decorator_id
                    );
                    vendorColors = default_decorator.VendorColors;
                } else {
                    vendorColors = product.Decorators[0].VendorColors;
                }
                // Added Colors
                if (vendorColors.length > 0) {
                    for (const color of vendorColors) {
                        let colorExist =
                            this.imprint_colors_array_for_template.find(
                                (vendorColor) =>
                                    vendorColor.color_id == color.color_id
                            );
                        if (!color.Color || colorExist) {
                            continue;
                        }
                        let colorsData = {
                            color_id: color.color_id,
                            color_name: color.Color.name,
                            color_pms: color.Color.pms,
                            decor_upcharge: color.decor_upcharge,
                            color_value: color.Color.hex,
                            swatches: color.Color.swatches,
                            category: color.Color.category,
                            shades: color.Color.shades
                                ? JSON.parse(color.Color.shades)
                                : []
                        };

                        if (
                            color.Color.type == "ink" &&
                            (this.decoration_type == 1 ||
                                this.decoration_type == 5)
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        } else if (
                            color.Color.type == "thread" &&
                            this.decoration_type == 2 || this.decoration_type == 4
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        } else if (
                            color.Color.type == "vinyl" &&
                            this.decoration_type != 1 &&
                            this.decoration_type != 2 && this.decoration_type != 4
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        }
                    }
                    // Added new color Data in Product objects
                    if (product.Vendor) {
                        this.product.Vendor.newVendorColors =
                            this.imprint_colors_array_for_template;
                    }
                } else if (product.Vendor) {
                    let vendor_colors = product.Vendor.vendor_colors
                        ? JSON.parse(product.Vendor.vendor_colors)
                        : [];

                    if (
                        this.decoration_type == 1 ||
                        this.decoration_type == 5
                    ) {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_ink;
                    } else if (this.decoration_type == 2 || this.decoration_type == 4) {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_thread;
                    } else {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_vinyl;
                    }
                }
            }
        },

        // Get Product Images
        // getProductImages(color_id = null) {
        //     let _this = this;
        //     let thumb_array = [];
        //     let normal_array = [];
        //     return new Promise(() => {
        //         ApiService.get(
        //             "/get-main-product-images/" +
        //                 this.$route.params.id_of_product
        //         ).then(({ data }) => {
        //             _this.product.NewProductImages = data.product_images;
        //             if (_this.product.NewProductImages) {
        //                 // First, add generic images (those without a color_id)
        //                 _this.product.NewProductImages.forEach((element) => {
        //                     if (!element.color_id) {
        //                         thumb_array.push({
        //                             id: element.id,
        //                             url: element.url,
        //                             thumb_url: element.thumbnail,
        //                             type: "image"
        //                         });
        //                         normal_array.push({
        //                             id: element.id,
        //                             url: element.url,
        //                             type: "image"
        //                         });
        //                     }
        //                 });

        //                 // Then, if a color is selected, add its specific images
        //                 if (color_id) {
        //                     _this.product.NewProductImages.forEach(
        //                         (element) => {
        //                             if (element.color_id == color_id) {
        //                                 thumb_array.push({
        //                                     id: element.id,
        //                                     url: element.url,
        //                                     thumb_url: element.thumbnail,
        //                                     type: "image"
        //                                 });
        //                                 normal_array.push({
        //                                     id: element.id,
        //                                     url: element.url,
        //                                     type: "image"
        //                                 });
        //                             }
        //                         }
        //                     );
        //                 }

        //                 _this.images = {
        //                     thumbs: thumb_array,
        //                     normal_size: normal_array
        //                 };
        //             }
        //         });
        //     });
        // },

        getProductImages(color_id = null) {
            let _this = this;
            let color_front_back_thumb_array = [];
            let color_front_back_normal_array = [];
            let thumb_array = [];
            let normal_array = [];
            let common_thumb_array = [];
            let common_normal_array = [];

            // We return the ApiService.get() promise directly
            return ApiService.get(
                "/get-main-product-images/" + this.$route.params.id_of_product
            ).then(({ data }) => {
                _this.product.NewProductImages = data.product_images;

                if (_this.product.NewProductImages) {
                    // If a color is selected, order its images as Front, Back, Left, Right, then others
                    if (color_id) {
                        const frontImages = [];
                        const backImages = [];
                        const leftImages = [];
                        const rightImages = [];
                        const otherImages = [];

                        _this.product.NewProductImages.forEach((element) => {
                            if (element.color_id != color_id) {
                                return;
                            }

                            const imageType = (element.type || "").toLowerCase();
                            const isFront =
                                imageType === "front" || imageType === "f";
                            const isBack =
                                imageType === "back" || imageType === "b";
                            const isLeft =
                                imageType === "left" || imageType === "l";
                            const isRight =
                                imageType === "right" || imageType === "r";

                            const targetArray = isFront
                                ? frontImages
                                : isBack
                                ? backImages
                                : isLeft
                                ? leftImages
                                : isRight
                                ? rightImages
                                : otherImages;

                            targetArray.push({
                                id: element.id,
                                url: element.url,
                                thumb_url: element.thumbnail,
                                type: "image"
                            });
                        });

                        const orderedForColor = [
                            ...frontImages,
                            ...backImages,
                            ...leftImages,
                            ...rightImages,
                            ...otherImages
                        ];

                        orderedForColor.forEach((img) => {
                            color_front_back_thumb_array.push({
                                id: img.id,
                                url: img.url,
                                thumb_url: img.thumb_url,
                                type: img.type
                            });
                            color_front_back_normal_array.push({
                                id: img.id,
                                url: img.url,
                                type: img.type
                            });
                        });
                    }

                    // Then, add all generic images (without color_id) at the end
                    _this.product.NewProductImages.forEach((element) => {
                        if (!element.color_id) {
                            common_thumb_array.push({
                                id: element.id,
                                url: element.url,
                                thumb_url: element.thumbnail,
                                type: "image"
                            });
                            common_normal_array.push({
                                id: element.id,
                                url: element.url,
                                type: "image"
                            });
                        }
                    });

                    // Combine: selected color's front/back images first, then other color images, then generic images
                    let final_thumb_array = [
                        ...color_front_back_thumb_array,
                        ...thumb_array,
                        ...common_thumb_array
                    ];
                    let final_normal_array = [
                        ...color_front_back_normal_array,
                        ...normal_array,
                        ...common_normal_array
                    ];

                    // Add video if it exists
                    if (
                        _this.product.video_url &&
                        _this.product.video_url.trim() != ""
                    ) {
                        final_thumb_array.push({
                            id: _this.product.id,
                            url: _this.product.video_url,
                            thumb_url: _this.product.video_url,
                            type: "video"
                        });
                        final_normal_array.push({
                            id: _this.product.id,
                            url: _this.product.video_url,
                            type: "video"
                        });
                    }

                    _this.images = {
                        thumbs: final_thumb_array,
                        normal_size: final_normal_array
                    };
                }
            });
        },

        prepareDecorationPrices(decoration_type, price_decoration_bulk) {
            this.product.price_decoration_bulk = price_decoration_bulk;
            const activeService = this.activeDecorationService;

            let noOfColorsCount = 0;
            if (activeService) {
                // Prioritize the new max_colors property from the active service
                if (activeService.max_colors) {
                    noOfColorsCount = activeService.max_colors;
                } else if (activeService.use_imprintcity_price_template === 1) {
                    // Fallback to old template logic if max_colors isn't available
                    if (
                        (decoration_type == 1 || decoration_type == 5) &&
                        this.product.PrintTemplate
                    ) {
                        noOfColorsCount =
                            this.product.PrintTemplate.no_of_colors;
                    } else if (
                        (decoration_type == 2 || decoration_type == 4) &&
                        this.product.Embroidery
                    ) {
                        noOfColorsCount = this.product.Embroidery.no_of_colors;
                    }
                } else {
                    // Default for new PCNA-style services if max_colors is missing
                    noOfColorsCount = 6;
                }
            }

            // Build the options array for the color dropdown
            this.imprintcityColors = [];
            // Check if full color option should be shown
            // is_full_color is already set based on BOTH JSON (is_full_color) AND VendorDecorationService (fee_structure == 2)
            if (activeService && activeService.is_full_color == true) {
                // Show only "1 color" and "Full color" options
                this.imprintcityColors.push({
                    id: 1,
                    value: "1-color"
                });
                this.imprintcityColors.push({
                    id: "full_color",
                    value: "Full color"
                });
            } else if (noOfColorsCount > 0) {
                // Normal color options
                for (let i = 1; i <= noOfColorsCount; i++) {
                    this.imprintcityColors.push({
                        id: i,
                        value: `${i}-color${i > 1 ? "s" : ""}` // e.g., "1-color", "2-colors"
                    });
                }
            }

            // The rest of the method now only handles pricing tiers, not the color dropdown options.
            if (
                activeService &&
                activeService.use_imprintcity_price_template === 0
            ) {
                //NEW STRUCTURE LOGIC
                this.decoration_price_template_values = price_decoration_bulk;

                if (price_decoration_bulk && price_decoration_bulk.length > 0) {
                    this.minimum_quantity_decoration_fee =
                        price_decoration_bulk[0].retail_cost;
                }
            } else {
                //OLD STRUCTURE LOGIC (with safety checks)
                if (decoration_type == 1 || decoration_type == 5) {
                    if (!this.product.PrintTemplate) return; // Prevents crash if template isn't loaded

                    // OLD BEHAVIOR (kept for future rollback):
                    // This block mutates print_location1 colour costs by applying template discount
                    // directly on decoration columns during service preparation.
                    // if (this.product.PrintTemplate.discount_enable) {
                    //     price_decoration_bulk.print_location1.forEach((row) => {
                    //         for (
                    //             let i = 1;
                    //             i < this.product.PrintTemplate.no_of_colors;
                    //             i++
                    //         ) {
                    //             let discount_colour =
                    //                 (parseFloat(row[`colour${i}`]) *
                    //                     parseFloat(row.discount)) /
                    //                 100;
                    //             row[`colour${i}`] = parseFloat(
                    //                 parseFloat(row[`colour${i}`]) -
                    //                     parseFloat(discount_colour)
                    //             ).toFixed(2);
                    //         }
                    //     });
                    // }
                    // New behavior:
                    // Keep decoration tiers raw; template discount is applied later
                    // on combined Product Base Price (base + markup + decoration + fees).

                    this.decoration_price_template_values =
                        price_decoration_bulk.print_location1;
                    this.decoration_price_template_location2 =
                        price_decoration_bulk.print_location2;
                    if (
                        this.decoration_price_template_values &&
                        this.decoration_price_template_values.length > 0
                    ) {
                        this.minimum_quantity_decoration_fee =
                            this.decoration_price_template_values[0].colour1;
                    }
                } else if (decoration_type == 2 || decoration_type == 4) {
                    if (!this.product.Embroidery) return; // Prevents crash if template isn't loaded

                    this.decoration_price_template_values =
                        price_decoration_bulk;
                    if (
                        this.decoration_price_template_values &&
                        this.decoration_price_template_values.length > 0
                    ) {
                        this.minimum_quantity_decoration_fee =
                            this.decoration_price_template_values[0].cost;
                    }
                } else if (decoration_type == 3) {
                    this.decoration_price_template_values =
                        price_decoration_bulk;
                }
            }
        },

        getCompanionProduct(id) {
            let companion_values = {
                parent_id: id,
                t_shirt_24_hour: this.is_tshirt_24_hour
            };
            new Promise(() => {
                ApiService.post(
                    "/home-companion-new-product-new",
                    companion_values
                )
                    .then(({ data }) => {
                        this.companion_products = data.product;
                        this.companion_products.forEach((product) => {
                            product["default_color_id"] = null;
                            if (product.MainNewSubProducts) {
                                if (this.is_tshirt_24_hour) {
                                    product.MainNewSubProducts =
                                        product.MainNewSubProducts.filter(
                                            (sub_product_data) =>
                                                sub_product_data.Color.name ==
                                                "White"
                                        );
                                }
                                let sub_product =
                                    product.MainNewSubProducts.find(
                                        (sub_product) =>
                                            sub_product.default_selection
                                    );
                                if (sub_product) {
                                    product["default_color_id"] =
                                        sub_product.color_id;
                                }
                            }

                            if (
                                product.decoration_price_type == "global_price"
                            ) {
                                product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        product.price_base,
                                        product.decoration_type,
                                        product.decoration_price_template
                                    );
                                product.price_markup_value =
                                    (parseFloat(product.price_base) *
                                        parseFloat(
                                            product.price_markup_percentage
                                        )) /
                                    100;
                                if (
                                    product.decoration_type == 1 ||
                                    product.decoration_type == 5
                                ) {
                                    let decoration_price_template =
                                        this.printTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.PrintTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify({
                                                print_location1:
                                                    decoration_price_template.PrintLocation1Templates
                                            });
                                    }
                                } else if (product.decoration_type == 2 || product.decoration_type == 4) {
                                    const templateList =
                                        product.decoration_type == 4
                                            ? this.patchTemplates
                                            : this.embroideryTemplates;
                                    let decoration_price_template =
                                        templateList.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.EmbroideryTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify(
                                                decoration_price_template.EmbroideryQuantities
                                            );
                                    }
                                }
                            }
                        });
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            });
        },

        getMoreDecorations(more_decoration) {
            this.design_fee = 0;
            return new Promise((resolve, reject) => {
                if (more_decoration) {
                    let decoration_values = more_decoration
                        ? more_decoration
                        : [];
                    let more_decoration_values = {
                        decoration_ids: decoration_values
                    };
                    ApiService.post(
                        "/home-decoration-values",
                        more_decoration_values
                    )
                        .then(({ data }) => {
                            this.more_decoration_list = data.decoration;
                            this.more_decoration_list.forEach((decoration) => {
                                this.design_fee += parseFloat(decoration.price);
                            });
                            this.design_fee = parseFloat(
                                parseFloat(this.design_fee).toFixed(2)
                            );
                            resolve(data);
                        })
                        .catch((err) => {
                            console.log(err);
                            reject(err);
                        });
                }
                resolve();
            });
            // return false;
        },

        activeLink(index) {
            var _this = this;
            let currTab = _this.is_active;
            _this.is_active = index;
            /* eslint-disable */
            _this.images = jQuery.extend(true, {}, _this.temp_img);
            /* eslint-enable */
            this.onChangeGenderColor();
            if (currTab !== index) {
                _this.is_imprint_location = false;
            }

            if (this.gender_groups[this.is_active]) {
                const selected_color_ids = this.gender_groups[
                    this.is_active
                ].selected_colors.map((color) => color.id);
                this.colors.forEach((color) => {
                    color.is_selected = selected_color_ids.includes(color.id);
                });
            }
        },

        showMore(list) {
            var _this = this;
            _this[list] = _this[list] ? false : true;
        },

        getTiers() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/tiers")
                    .then(({ data }) => {
                        _this.tier_list = data.tiers;
                    })
                    .catch(({ response }) => {
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },

        tireName(tier) {
            var unit_names = [];
            let tier_name = "";
            this.tier_list.forEach((element) => {
                if (tier == element.id) {
                    element.TierUnits.forEach((elm) => {
                        tier_name = element.name;
                        let unit_value =
                            `<div class="col pl-0 mx_2"> <p class="m-0">` +
                            elm.quantity +
                            `</p><p class="m-0">$` +
                            elm.price.toFixed(2) +
                            `</p></div>`;
                        unit_names.push(unit_value);
                    });
                }
            });

            let final_html =
                `<div class="dropdown">
<a href="#" class="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">` +
                tier_name +
                `
</a>
<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
<h4 class="font_size_16 text_primary_blue py_2 px_20">Tier</h4>
<div class="scroll">
<div class="dropdown-item d-flex align-items-center">
` +
                unit_names.join(" ") +
                `
</div></div> </div></div>`;

            return final_html;
        },

        getCartItems() {
            new Promise((resolve, reject) => {
                ApiService.get("/cart-new")
                    .then(({ data }) => {
                        this.cart_items = data.cart_items;
                        this.updateCartQuantity();
                        if (data.max_cart_count) {
                            this.max_cart_count = parseInt(data.max_cart_count);
                        }
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },

        getUrlExtension(url) {
            if (!url) {
                return false;
            }
            let matchs = url.includes("data:application/pdf;base64");
            let postscript = url.includes("data:application/postscript;base64");
            if (postscript && this.images_name) {
                url = this.images_name.split(".")[1];
                return url;
            }
            if (matchs) {
                url = "pdf";
                return url;
                // return url.split(/[#?]/)[0].split('.').pop().trim();
            }
            return url.split(/[#?]/)[0].split(".").pop().trim();
        },

        isValidHttpUrl(string) {
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;
            }
            return url.protocol === "http:" || url.protocol === "https:";
        },

        async changeDecorationService(serviceIdOrIndex, isInitialLoad = false) {
            if (!this.product || !this.product.id) {
                return;
            }
            if (!isInitialLoad) {
                this.isBusy = true;
            }


            // Find the index in the original decoration_services array
            let index = -1;
            if (
                typeof serviceIdOrIndex === "number" &&
                serviceIdOrIndex < this.decoration_services.length
            ) {
                // If it's already an index (for backward compatibility)
                index = serviceIdOrIndex;
            } else {
                // If it's a service ID, find the index
                index = this.decoration_services.findIndex(
                    (item) => item.id === serviceIdOrIndex
                );
            }

            if (index === -1) {
                console.error("Service not found:", serviceIdOrIndex);
                if (!isInitialLoad) {
                    this.isBusy = false;
                }
                return;
            }

            this.decoration_services.forEach((item, indx) => {
                item.isActive = indx === index;
            });

            // Reset selected rush option when service changes
            this.selectedRushOptionId = null;

            // Reset patch selection when service changes
            this.clearPatchSelection();

            this.product.PrintTemplate = null;
            this.product.Embroidery = null;

            if (this.product && this.product.design_areas) {
                this.resetImprintLocations(
                    JSON.parse(this.product.design_areas)
                );
            }

            const activeService = this.activeDecorationService;

            if (activeService) {
                const liveServiceData =
                    this.resolveVendorDecorationServiceRow(activeService);
                if (liveServiceData) {
                    // Live vendor row + alias so legacy code using master_service.service_name still works
                    activeService.master_service = Object.assign(
                        {},
                        liveServiceData,
                        {
                            service_name: liveServiceData.name
                        }
                    );

                    // Check is_full_color from JSON AND fee_structure from VendorDecorationService
                    // Both must be true: JSON is_full_color == true AND vendor fee_structure == 2
                    // Get is_full_color value directly from JSON (preserve original value)
                    const jsonIsFullColor =
                        activeService.is_full_color === true ||
                        activeService.is_full_color === 1 ||
                        activeService.is_full_color === "true" ||
                        activeService.is_full_color === "1";

                    // Check vendor service fee_structure == 2
                    const vendorFeeStructure2 =
                        liveServiceData.fee_structure == 2 ||
                        liveServiceData.fee_structure === "2";

                    // Both conditions must be true
                    activeService.is_full_color =
                        jsonIsFullColor && vendorFeeStructure2;
                } else if (activeService.master_service) {
                    // Even if liveServiceData is not found, check with vendorServices
                    // Get is_full_color value directly from JSON
                    const jsonIsFullColor =
                        activeService.is_full_color === true ||
                        activeService.is_full_color === 1 ||
                        activeService.is_full_color === "true" ||
                        activeService.is_full_color === "1";

                    // Try to find vendor service by master_service.id
                    let vendorService = null;
                    if (activeService.master_service.id) {
                        vendorService =
                            this.product.VendorDecorationServices.find(
                                (vs) =>
                                    vs.service_id ===
                                        activeService.master_service.id ||
                                    vs.id === activeService.id
                            );
                    }

                    // Check vendor service fee_structure == 2
                    const vendorFeeStructure2 =
                        vendorService &&
                        (vendorService.fee_structure == 2 ||
                            vendorService.fee_structure === "2");

                    // Both conditions must be true
                    activeService.is_full_color =
                        jsonIsFullColor && vendorFeeStructure2;
                } else {
                    // If no master_service, set is_full_color to false
                    activeService.is_full_color = false;
                }
                // If it's a PCNA case, fetch ONLY the live fees
                if (activeService.use_imprintcity_price_template === 0) {
                    this.filterOtherServices();
                }
                // For old logic, fetch the PrintTemplate if needed
                else if (activeService.decoration_price_template) {
                    await this.$store
                        .dispatch(FETCH_DECORATION_TEMPLATE, {
                            decoration_type: activeService.decoration_type,
                            decoration_price_template_id:
                                activeService.decoration_price_template
                        })
                        .then(() => {
                            if (
                                activeService.decoration_type === 1 ||
                                activeService.decoration_type === 5
                            )
                                this.product.PrintTemplate =
                                    this.decorationTemplate;
                            else if (activeService.decoration_type === 2 || activeService.decoration_type === 4)
                                this.product.Embroidery =
                                    this.decorationTemplate;
                        });
                }

                this.decoration_type = activeService.decoration_type || 1;
                this.product.decoration_type =
                    activeService.decoration_type || 1;

                this.prepareDecorationPrices(
                    this.product.decoration_type,
                    activeService.price_decoration_bulk
                );
                this.getMoreDecorations(activeService.more_decorations).then(
                    () => {
                        this.calculatePricing(this.is_active);
                    }
                );
                this.loadVendorColors(this.product);
            }

            if (!isInitialLoad) {
                this.isBusy = false;
            }
        },

        getDecorationMethods() {
            return new Promise((resolve, reject) => {
                ApiService.get("/decoration-methods")
                    .then(({ data }) => {
                        this.decoration_methods = data.decoration_methods;
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getDecorationPriceFromTemplateIds() {
            let config_data = {
                print_template_ids: this.print_templates_id,
                embroidery_template_ids: this.embroidery_template_ids,
                promotional_template_ids: this.promotional_template_ids
            };
            return new Promise((resolve, reject) => {
                ApiService.post("/get-decoration-pricing", config_data)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        showBreakupCharges(gender) {
            if (
                this.setup_fee_applied_gender_index >= 0 &&
                this.setup_fee > 0
            ) {
                return true;
            } else if (gender.total_discount_value > 0) {
                return true;
            } else if (gender.total_design_fee > 0) {
                return true;
            } else if (gender.total_color_fee > 0) {
                return true;
            }

            return false;
        },

        shareOnFacebook() {
            const navUrl =
                "https://www.facebook.com/sharer/sharer.php?u=" +
                this.site_url +
                "product-details/" +
                this.product.id;
            window.open(navUrl, "_blank");
        },

        shareOnTwitter() {
            const navUrl =
                "https://twitter.com/intent/tweet?url=" +
                this.site_url +
                "product-details/" +
                this.product.id +
                "&text=Hello+Everyone+I+found+this+awesome+customisable+product+by+Imprint+City&hashtags=imprintCity,customizedPersonal,brand";
            window.open(navUrl, "_blank");
        },

        shareOnInstagram() {
            const navUrl =
                "https://www.instagram.com/sharer/sharer.php?u=" +
                this.site_url +
                "product-details/" +
                this.product.id +
                "&text=Hello+Everyone+I+found+this+awesome+customisable+product+by+Imprint+City&hashtags=imprintCity,customizedPersonal,brand";
            window.open(navUrl, "_blank");
        },

        updateCartQuantity(recalculate = false) {
            // this.current_cart_quantity = 0;
            // let selected_color_ids = [];
            // if (this.gender_groups[this.is_active]) {
            //     selected_color_ids = this.gender_groups[this.is_active].selected_colors.map(color => color.id);
            // }

            // this.same_artwork_cart_items = [];
            // if (this.product_artwork) {
            //     this.cart_items.forEach(item => {
            //         if (!item.build_id && (item.item_id == this.product.id)) {
            //             if (!selected_color_ids.includes(item.color_id) && (this.product_artwork == item.artwork)) {
            //                 this.current_cart_quantity += parseInt(item.total_quantity);
            //                 let cart_item = JSON.parse(JSON.stringify(item));
            //                 cart_item.imprint_locations = cart_item.imprint_locations
            //                     ? JSON.parse(cart_item.imprint_locations)
            //                     : []
            //                 this.same_artwork_cart_items.push(cart_item);
            //             } else if (selected_color_ids.includes(item.color_id) && (this.product_artwork == item.artwork)) {
            //                 this.gender_groups[this.is_active].selected_colors.forEach(selectedColor => {
            //                     if (selectedColor.id === item.color_id) {
            //                         selectedColor.existing_cart_quantity = parseInt(item.total_quantity);
            //                     }
            //                 })
            //             }
            //         }

            //     })
            // }

            if (recalculate) {
                this.calculatePricing(this.is_active);
            }
        },

        recalculateCartItems(cart_items) {
            let total_group_quantity = this.getTotalItemQuantity(
                this.gender_groups[this.is_active]
            );
            let single_location_price = this.calculateCostOfQtyForPrint(
                total_group_quantity + this.current_cart_quantity
            );

            cart_items.forEach((cart_item) => {
                cart_item.total_price =
                    parseFloat(cart_item.total_price) -
                    parseFloat(cart_item.subtotal_price) -
                    parseFloat(cart_item.imprint_locations_price);
                cart_item.imprint_locations_price = 0;
                cart_item.subtotal_price = 0;

                // UPDATING PRICES WITH NEW SINGLE LOCATION FOR EACH SIZE
                cart_item.CartChildItems.forEach((childItem) => {
                    childItem.unit_price =
                        parseFloat(childItem.unit_price) -
                        parseFloat(childItem.single_location_price);

                    childItem.total_price =
                        parseFloat(childItem.total_price) -
                        parseFloat(childItem.single_location_price) *
                            parseInt(childItem.quantity);

                    childItem.single_location_price = single_location_price;
                    childItem.unit_price =
                        parseFloat(childItem.unit_price) +
                        parseFloat(childItem.single_location_price);
                    childItem.total_price =
                        parseFloat(childItem.total_price) +
                        parseFloat(childItem.single_location_price) *
                            parseInt(childItem.quantity);

                    cart_item.subtotal_price =
                        parseFloat(cart_item.subtotal_price) +
                        parseFloat(childItem.total_price);
                });

                // UPDATING IMPRINT LOCATIONS PRICE WITH NEW SINGLE LOCATION
                if (cart_item.imprint_locations) {
                    let highest_price_location_index =
                        this.getHighestPriceLocation(
                            cart_item.imprint_locations
                        );
                    cart_item.imprint_locations.forEach(
                        (location, locationIndex) => {
                            location.colors.forEach(
                                (imprint_color, colorIndex) => {
                                    let qty_wise_color_price =
                                        this.getDecorationPrice(
                                            colorIndex,
                                            this.is_active,
                                            this.product.decoration_type
                                        );

                                    if (
                                        highest_price_location_index ==
                                        locationIndex
                                    ) {
                                        qty_wise_color_price =
                                            this.getDecorationPrice(
                                                colorIndex,
                                                this.is_active,
                                                this.product.decoration_type
                                            );
                                    } else {
                                        qty_wise_color_price =
                                            this.getDecorationPrice(
                                                colorIndex,
                                                this.is_active,
                                                this.product.decoration_type,
                                                true
                                            );
                                    }
                                    if (
                                        highest_price_location_index ==
                                            locationIndex &&
                                        colorIndex == 0
                                    ) {
                                        qty_wise_color_price = 0;
                                    }
                                    imprint_color.cost_cost =
                                        qty_wise_color_price *
                                        parseInt(cart_item.total_quantity);
                                    if (
                                        imprint_color.color &&
                                        imprint_color.color.decor_upcharge !==
                                            undefined &&
                                        imprint_color.color.decor_upcharge !==
                                            null
                                    ) {
                                        imprint_color.decor_upcharge.color_cost =
                                            parseFloat(
                                                imprint_color.color
                                                    .decor_upcharge || 0
                                            ) *
                                            parseInt(cart_item.total_quantity);
                                        cart_item.imprint_locations_price =
                                            parseFloat(
                                                imprint_color.cost_cost || 0
                                            ) +
                                            parseFloat(
                                                imprint_color.decor_upcharge
                                                    .color_cost || 0
                                            );
                                    } else if (
                                        imprint_color.color &&
                                        imprint_color.cost_cost
                                    ) {
                                        cart_item.imprint_locations_price =
                                            parseFloat(
                                                imprint_color.cost_cost || 0
                                            );
                                    }
                                }
                            );
                        }
                    );

                    cart_item.total_price =
                        parseFloat(cart_item.total_price) +
                        parseFloat(cart_item.imprint_locations_price);
                }

                cart_item.total_price =
                    parseFloat(cart_item.total_price) +
                    cart_item.subtotal_price;
            });
        },

        getDarkLightFees(color) {
            const activeService = this.activeDecorationService;
            if (color && activeService) {
                const category = String(color.category || "").toLowerCase();
                if (!category) {
                    return 0;
                }

                // For template-driven pricing, always prefer latest template fees
                // fetched on active service change.
                let templateSource = null;
                if (activeService.use_imprintcity_price_template === 1) {
                    if (
                        (activeService.decoration_type === 1 ||
                            activeService.decoration_type === 5) &&
                        this.product.PrintTemplate
                    ) {
                        templateSource = this.product.PrintTemplate;
                    } else if (
                        (activeService.decoration_type === 2 ||
                            activeService.decoration_type === 4) &&
                        this.product.Embroidery
                    ) {
                        templateSource = this.product.Embroidery;
                    }
                }

                if (category === "dark") {
                    if (templateSource && templateSource.price_dark != null) {
                        return parseFloat(templateSource.price_dark || 0);
                    }
                    return parseFloat(activeService.price_dark || 0);
                } else if (category === "light") {
                    if (templateSource && templateSource.price_light != null) {
                        return parseFloat(templateSource.price_light || 0);
                    }
                    return parseFloat(activeService.price_light || 0);
                }
            }
            return 0;
        },

        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.markup_tiers = data.markup_tiers;
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },

        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            if (
                !Array.isArray(this.markup_tiers) ||
                !this.markup_tiers.length ||
                price === undefined ||
                price === null ||
                decoration_type === undefined ||
                decoration_type === null ||
                decoration_price_template === undefined ||
                decoration_price_template === null
            ) {
                return null;
            }

            let markup = null;
            let tier = this.markup_tiers.find(
                (tier) =>
                    decoration_type == tier.decoration_id &&
                    decoration_price_template == tier.template_id &&
                    parseFloat(tier.start_price) <= parseFloat(price) &&
                    parseFloat(tier.end_price) >= parseFloat(price)
            );
            if (tier) {
                markup = parseFloat(tier.markup);
            }
            return markup;
        },

        getResolvedMarkupPercentage(
            price,
            decoration_type,
            decoration_price_template,
            fallbackMarkup = null
        ) {
            const normalizedPrice =
                price !== undefined && price !== null
                    ? parseFloat(price)
                    : parseFloat(this.product.price_base || 0);
            const resolvedDecorationType =
                decoration_type !== undefined && decoration_type !== null
                    ? decoration_type
                    : this.activeDecorationService &&
                      this.activeDecorationService.decoration_type !== undefined
                    ? this.activeDecorationService.decoration_type
                    : this.product.decoration_type;
            const resolvedTemplateId =
                decoration_price_template !== undefined &&
                decoration_price_template !== null
                    ? decoration_price_template
                    : this.activeDecorationService &&
                      this.activeDecorationService.decoration_price_template !==
                          undefined &&
                      this.activeDecorationService.decoration_price_template !==
                          null
                    ? this.activeDecorationService.decoration_price_template
                    : this.product.decoration_price_template;

            const tierMarkup = this.getMarkupFromTier(
                normalizedPrice,
                resolvedDecorationType,
                resolvedTemplateId
            );

            if (tierMarkup !== null) {
                // Keep product-level markup in sync so dependent UI uses the same live tier value.
                this.product.price_markup_percentage = tierMarkup;
                return tierMarkup;
            }

            if (fallbackMarkup !== null && fallbackMarkup !== undefined) {
                return parseFloat(fallbackMarkup) || 0;
            }

            return parseFloat(this.product.price_markup_percentage) || 0;
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) {
                return "";
            }
            return value.toString().toUpperCase();
        }
    },
    watch: {
        // isAuthenticatedClient: function (val) {
        //     if (val) {
        //         setTimeout(() => {
        //             this.UploadedImages();
        //         }, 100);
        //     }
        // }
        // Recalculate patch cost when total quantity changes
        "gender_groups": {
            handler() {
                if (this.selectedPatchData) {
                    this.calculateProductPatchCost();
                }
            },
            deep: true
        }
    }
};
</script>
<style>
.product_details .product_headding .company_logo img {
    object-fit: contain;
}
.product_details .product_headding .heading1 {
    max-width: 480px;
}
button.add_artwork_preview_popup_btn {
    z-index: 1;
    position: relative;
}

.pricing-table {
    border: 1px solid #dee2e6;
    margin-bottom: 0;
    min-width: 100%;
}

.pricing-table th,
.pricing-table td {
    border: 1px solid #dee2e6;
    padding: 0.5rem 0.75rem;
    vertical-align: middle;
    white-space: nowrap;
}

.pricing-table thead th {
    border-bottom-width: 2px;
    background-color: #f8f9fa;
    font-weight: normal;
    color: #495057;
}

.pricing-table .text-left {
    text-align: left !important;
}

.pricing-table td:first-child {
    background-color: #f8f9fa;
}
.preview-disabled {
    cursor: not-allowed;
    pointer-events: none;
}

/* Patch Selection UI Styles */
.patch-selection-row {
    padding: 0;
}
.patch-dropdown-group {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    max-width: 48%;
    width: 100%;
}
.patch-dropdown-label {
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: #333333;
    margin-bottom: 12px;
}

.patch-select:disabled {
    background-color: #e9ecef;
    cursor: not-allowed;
}
.patch-dimensions-display {
    font-size: 16px;
    line-height: 16px;
    color: #333333;
    font-weight: 600;
}
.patch-options-link-wrap {
    line-height: 1;
}
.patch-options-link {
    color: #1D6CB5;
    font-size: 18px;
    line-height: 18px;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
}
.patch-options-link:hover,
.patch-options-link:focus {
    color: #145895;
    text-decoration: underline;
}

/* Patch Badge Styles (B / R indicators in price table) */
.patch-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
    margin-left: 3px;
    vertical-align: middle;
    line-height: 1;
}
.patch-badge-b {
    background-color: #2196F3;
}
.patch-badge-r {
    background-color: #FFC107;
    color: #333;
}
.patch-price-cell {
    background-color: #fffde7 !important;
}
.patch-no-price {
    color: #999;
}
.rush-option .option-price {
    padding-left: 24px;
}
.product_details_update_v3
    .product_details_content
    .product_details_radio_btn
    .form__radio-group
    .form__label-radio {
    white-space: nowrap;
}
.product_details_update_v3
    .product_details_content
    .product_details_radio_btn
    .form__group {
    overflow-x: auto;
    padding-bottom: 5px;
}
.product_details_update_v3 .dropdown_colors .v-select {
    border: 1px solid #8080807a;
    padding: 0px 15px;
    background-color: #fff;
    border-radius: 7px;
    margin-top: 10px;
    height: 45px;
}
.product_details_update_v3
    .right_section_main
    .right_section
    .popup_right_section
    .popup_dropdown
    .left-chest-
    .form-group
    .vs__selected-options
    .vs__search {
    border-bottom: none !important;
    font-size: 16px !important;
    padding: 15px 0px 0px 0px !important;
    padding-bottom: 0px !important;
    margin: 0px !important;
}

.product_details_update_v3 .dropdown_colors .vs__selected {
    font-size: 16px !important;
    top: 6px !important;
}

.product_details_update_v3 .left-chest- .dropdown_colors .vs__actions {
    position: relative !important;
    top: 4px !important;
    background-image: url(/maincss/images/next.svg) !important;
    width: 22px;
    height: 15px;
    background-repeat: no-repeat;
    background-size: 16px;
    transform: rotate(92deg);
}
.product_details_update_v3 .left-chest- .dropdown_colors .vs__dropdown-menu {
    top: 44px;
}
.rush_service_main {
    margin-top: 12px;
    margin-bottom: 12px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    padding: 12px 16px;
}
.rush_service_main .rush-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}
.rush_service_main .ship-date .label {
    font-size: 14px;
    color: #121212;
    line-height: 14px;
    margin-right: 6px;
    font-weight: 600;
}
.rush_service_main .ship-date .label .asterisk,
.rush-options-card .rush_option_heading .asterisk {
    color: #e40000;
    margin-left: 0px;
}
.rush_service_main .ship-date .value {
    font-size: 14px;
    color: #121212;
    line-height: 14px;
    margin-right: 6px;
    font-weight: 600;
}
.rush_service_main .rush-cta {
    display: flex;
    align-items: center;
    gap: 8px;
}
.rush_service_main .rush-cta .need-text {
    font-size: 14px;
    line-height: 14px;
    color: #121212;
    font-weight: 600;
}
.rush_service_main .rush-btn {
    border: 1px solid #1d6cb5;
    background: #fff;
    color: #1d6cb5;
    font-weight: 600;
    padding: 8px 14px;
    border-radius: 4px;
    cursor: pointer;
    min-width: 140px;
    text-transform: uppercase;
}
.rush_service_main .rush-btn:hover {
    background: #f2f8ff;
}
.rush_options_card,
.rush-options-card {
    margin-top: 12px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    padding: 12px 14px;
    background: #fafafa;
}
.rush-options-card .rush-option {
    display: inline-flex;
    align-items: flex-start;
    margin-right: 28px;
    margin-bottom: 8px;
}
.rush-options-card .rush-option-label {
    display: inline-flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 14px;
    color: #121212;
    cursor: pointer;
    position: relative;
}
.rush-options-card input[type="radio"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    margin-top: 2px;
    left: 0px;
}
.rush-options-card .option-title {
    font-weight: 600;
    padding-left: 24px;
    color: #000;
    font-size: 14px;
    line-height: 14px;
}
.rush-options-card .option-date {
    color: #606060;
    font-size: 12px;
    line-height: 12px;
    padding-left: 24px;
}
.rush-options-card .label_items {
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: 16px;
}
.rush-options-card .rush_option_heading {
    font-size: 14px;
    line-height: 14px;
    font-weight: 600;
    color: #121212;
}

.offer_badge_right {
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 36px;
    padding: 0 12px 0 16px;
    /* left padding slightly more */
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.02em;
    color: #ffffff;
    background-color: #f93333;
    user-select: none;
    clip-path: polygon(
        0px 0px,
        100% 0px,
        calc(100% - 0.75rem) 50%,
        100% 100%,
        0px 100%
    );
    padding-right: 1.25rem;
    margin-bottom: 12px;
    line-height: 24px;
}

.offer_badge_right span {
    padding-left: 4px;
}
.on_sale {
    color: #f93333;
}
.retail_discount {
    text-decoration: line-through;
}
.design-add-button {
    width: 250px !important;
}
@media (max-width: 1499px) and (max-width: 1199px) {
    .product_details .product_details_content .buttons .btn_orange {
        padding: 18px 16px !important;
    }
}
@media screen and (max-width: 767px) {
    .product_details_update_v3 .tooltip-content {
        min-width: 300px;
        left: 150%;
    }
    .product_details_update_v3 .left-chest- {
        margin-top: 20px !important;
    }
}
</style>
